export const en = {
  Enums: {
    ProcessType: {
      MassCommand: 'Mass Command',
      MassMeterRegistration: 'Mass Meter Import',
      MassMeterEdit: 'Mass Meter Edit',
      ExportBillings: 'Readings Billing',
      ScheduleRecoverMassMemorySmc: 'Scheduled SMC Mass Memory Recovery',
      ScheduledCommand: 'Scheduled Command',
      MassLicenseRemoval: 'License Point Removal',
    },
    maxPhaseUnbalanceCurve: 'Max Phase Unbalance Curve',
    AccountStatus: {
      DISABLED: 'Disconnected',
      ACTIVATED: 'Connected',
      NO_RELE: 'No Relay',
      NO_INFORMATION: 'No Information',
      maxPhaseUnbalanceCurve: 'Max Phase Unbalance Curve',
      ALL: 'Everything',
    },
    MeterPhase: {
      Monofasico: 'Single-phase',
      Bifasico: 'Two-phase',
      Trifasico: 'Three-phase',
    },
    TicketStatus: {
      Cancelled: 'Canceled',
      CommandTimeOutReached: 'Execution Timeout Reached',
      Executing: 'Executing',
      Failed: 'Failed',
      FailedToContinue: 'Error during processing',
      FailedToStart: 'Failed to initialize',
      Finished: 'Finished',
      Success: 'Executed with Success',
      Interupted: 'Interrupted',
      MiddleWareOffline: 'MiddleWare Offline or Unavailable',
      MiddlewareNotResponding: 'No response from MiddleWare',
      PartiallyFinished: 'Partially Finished',
      Waiting: 'Waiting',
      WaitingScheduleDateTime: 'Waiting for scheduled date and time',
      SystemTimeout: 'System Execution Timeout Reached',
      Timeout: 'Request Timeout Reached',
      OutsideAllowedTime: 'Period not allowed',
      SemLicenca: 'Meter without license',
    },
    StatusCommand: {
      DATA_BLOCK_UNAVAILABLE: 'Data block unavailable',
      DAT_BLOCK_NUMBER_INVALID: 'Invalid block number!',
      HARDWARE_FAULT: 'Hardware Fault',
      INCOMPLETE: 'Incomplete',
      INCORRECT_KEYS: 'Incorrect Keys',
      INTERRUPTED_BY_COMMISSIONING: 'Interrupted by commissioning',
      INVALID_ITEM: 'Invalid item',
      LONG_GET_ABORTED: 'Get Long Aborted',
      LONG_SET_ABORTED: 'Set Long Aborted',
      METERS_NOT_MATCH_WITH_RECEIVED: 'Invalid meter list',
      NO_LONG_GET_IN_PROGRESS: 'No Get Long in progress',
      NO_LONG_SET_IN_PROGRESS: 'No Set Long in progress',
      OBJECT_CLASS_INCONSISTENT: 'Inconsistent object class',
      OBJECT_UNAVAILABLE: 'Object unavailable',
      OBJECT_UNDEFINED: 'Object undefined',
      OPEN_DOOR: 'Open Door',
      OTHER_REASON: 'Other Reason',
      READ_WRITE_DENIED: 'Read or Write Denied',
      SCOPE_OF_ACCESS_VIOLATED: 'Scope of Access Violated',
      SET_INTERVAL_OF_LONG_OUT_VOLTAGE: 'Configuration of Long Out Event Capture Interval',
      SET_INTERVAL_OF_QEE: 'Configuration of DRP/DRC Capture Interval',
      SET_STANDARD_FROZEN_DATA: 'Configuration of Standard Energy Template',
      SUCESS: 'Executed with Success',
      TEMPORARY_FAILURE: 'Temporary Failure',
      TIMEOUT: 'Execution Timeout Reached',
      SYSTEMTIMEOUT: 'System Timeout Reached',
      TYPE_UNMATCHED: 'Inconsistent Type',
      WAITING: 'Waiting for Response',
      EXECUTING: 'Executing',
      NO_COMISSIONED: 'Commissioning not registered',
      SCHEDULED: 'Scheduled',
      SENT: 'Sent',
      FINISHED: 'Finished',
      CANCELLED: 'Canceled',
      SUCCESS: 'Executed with success',
      COMMUNICATIONERROR: 'Communication error',
      EXECUTIONERROR: 'Execution error',
      INTERNALERROR: 'Internal error',
      INVALID_METERS: 'Invalid meter(s)',
      ACKNOWLEDGMENT: 'Simple acknowledgment',
      INVALID_SCHEMA: 'Invalid request format',
      DATA_UNAVAILABLE: 'Data unavailable',
      NOT_SUPPORTED: 'Functionality not supported',
      INVALIDMETER: 'Invalid meter',
      CUT_AT_IMPROPER_TIME: 'Period not allowed',
    },
    CommandType: {
      DisableCollectiveCut: 'Authorize Door Opening',
      EnableCollectiveCut: 'Disable Door Opening',
      GetQEEIndicator: 'Request Quality Parameters',
      GetVoltageOutLong: 'Request Voltage Out Long Alarm',
      GetVoltageOutShort: 'Request Voltage Out Short Alarm',
      ImportFrozenData: 'Import Energy Totalizers',
      ImportMassMemory: 'Import Mass Memory',
      ImportQEEIndicator: 'Import Quality Parameters',
      ImportVoltageOutAlarm: 'Import Voltage Out Alarms',
      InstantMeasure: 'Request Instant Energy',
      ListMetersSmcSerial: 'Request Meters from SMC',
      MarkAlarmAsRead: 'Mark Alarm as Read',
      MeterAddedToSmc: 'Add meter to smc (System)',
      MeterRemovedFromSmc: 'Remove meter from smc (System)',
      NicReset: 'Reset NIC',
      RecoverEventQeeIndicator: 'Recover Quality Indicators',
      RecoverFrozenData: 'Recover Energy Totalizers',
      RecoverGbtMessage: 'GBT',
      RecoverMassMemory: 'Recover Mass Memory',
      RelayOff: 'Disconnect Relay',
      RelayOn: 'Connect Relay',
      RelayOnAllMetersOfSmc: 'Reconnect all clients',
      RelayStatus: 'Get Relay Status',
      SmiInfoRequest: 'Get meter information',
      RequestDoorStatus: 'Get Collective Cut Status',
      RequestRelayStatusAllSmc: 'Request Relay Status of All Meters',
      Rollback: 'Rollback',
      SendKeyAk: 'Send Authentication Keys to Meters',
      SendKeyEk: 'Send Encryption Keys to Meters',
      GetCellIDAndIP: 'Get Cell ID and IP',
      SetDatetime: 'Set SMC Date and Time',
      SetIntervalOLongOutEvent: 'Configuration of Long Out Event Capture Interval',
      SetIntervalOfQee: 'Configuration of DRP/DRC Capture Interval',
      SetStandardFrozenData: 'Configuration of Standard Energy Template',
      Set_Current: 'Change Cutting Current',
      UpdateDateTime: 'Update Date and Time',
      ReadDateTime: 'Read Date and Time',
      UplinkPeriod: 'Change Uplink Reading Period',
      DoorStatusAbsolute: 'Get Door Status',
      SetSmiVoltage: 'Set Reference Voltage',
      SetDisplayConfiguration: 'Set Display Auto Configuration',
      SetDisplayConfigurationManual: 'Set Display Manual Configuration',
      SetDisplayConfigurationMicromax: 'Set Display Auto Configuration MicroMax',
      SetDisplayConfigurationManualMicromax: 'Set Display Manual Configuration MicroMax',
      GetSmiVoltage: 'Get Reference Voltage',
      MeterRecoverEventQeeIndicator: 'Recover Quality Parameters',
      SetQualityMeasureParams: 'Set Quality Measure Parameters',
      GetQeeBuffer: 'Get Qee Buffer',
      GetEnergyTotalizer: 'Request Active Direct Energy',
      MassRegistration: 'Mass Registration',
      MassEdit: 'Mass Edit',
      ChangeNetworkType: 'Change Network Type',
      GetNetworkType: 'Get Network Type',
      GetNetworkInfo: 'Get Network Info',
      GetHeartBeatCommand: 'Recover Signal Quality',
      AlterarTotalLicenca: 'Change license point total',
      RemoverPontoLicenca: 'Remove license point',
      RestaurarPontoLicenca: 'Restore license point',
      AlterarAtivacaoLicenca: 'Enable or disable the license',
      ChangeNetworkTech: 'Change Network Technology',
      GetDaylightSavingsEnabled: 'Get Daylight Savings Enabled',
      GetDaylightSavingsEnd: 'Get Daylight Savings End',
      GetDaylightSavingsDeviation: 'Get Daylight Savings Deviation',
      GetDaylightSavingsBegin: 'Get Daylight Savings Begin',
      GetSpecialDaysTable: 'Get Special Days Table',
      SetSpecialDaysTable: 'Add Special Days',
      DeleteSpecialDays: 'Delete special days',
      GetDmrcSwitch: 'Request DMRC and UFER Switch',
      SetDmrcSwitch: 'Set DMRC and UFER Switch',
      SetDayPassiveActivityCalendar: 'Add Passive Day Calendar',
      SetWeekPassiveActivityCalendar: 'Add Passive Week Calendar',
      ActivatePassiveTimeCalendarActivityCalendar: 'Add Activation Time',
      SetDayProfilePassiveCalendarActivityCalendar: 'Add Passive Day Calendar DMRC',
      DrmcSetWeekProfilePassiveCalendarActivityCalendar: 'Add Passive Week Calendar DMRC',
      DrmcGetDayProfilePassiveActivityCalendar: 'Request Passive Day Calendar DMRC',
      DrmcGetActivatePassiveTimeCalendarActivityCalendar:
        'Request Passive Activation Time Calendar DMRC',
      GetActivatePassiveTimeCalendarActivityCalendar: 'Request Passive Activation Time Calendar',
      GetWeekProfilePassiveActivityCalendar: 'Request Passive Week Calendar',
      GetWeekProfileActiveActivityCalendar: 'Request Active Week Calendar',
      GetDayProfileActiveActivityCalendar: 'Request Active Day Calendar',
      GetDayProfilePassiveActivityCalendar: 'Request Passive Day Calendar',
      DrmcGetWeekProfileActiveActivityCalendar: 'Request Active Week Calendar DMRC',
      DrmcGetWeekProfilePassiveActivityCalendar: 'Request Passive Week Calendar DMRC',
      DrmcGetDayProfileActiveActivityCalendar: 'Request Active Day Calendar DMRC',
      DrmcActivatePassiveTimeCalendarActivityCalendar: 'Add Activation Time DMRC',
      SetActivatePassiveCalendarActivityCalendar: 'Set Profile Status DMRC',
      ActivatePassiveCalendarActivityCalendar: 'Set Profile Status',
      SetDaylightSavingsEnabled: 'Set Daylight Savings Enabled',
      SetDaylightSavingsDeviation: 'Set Daylight Savings Deviation',
      SetDaylightSavingsBegin: 'Set Daylight Savings Begin',
      SetDaylightSavingsEnd: 'Set Daylight Savings End',
      GetTaxPage: 'Get Tax Page',
      GetDemandRegisters: 'Get Demand Registers',
      GetGeneralReadingValues: 'Get General Reading Values',
      DeactivateMeter: 'Deactivate Meter',
      AddMeterToGateway: 'Add Meter to Gateway',
      RemoveMeterFromGateway: 'Remove Meter from Gateway',
      ListMetersFromGateway: 'List Meters from Gateway',
      ReadDisplayConfiguration: 'Read Display Configuration',
      ReadDatetime: 'Date and Time Reading',
      GetDailyBilling: 'Get Daily Billing',
      GetLoadProfile: 'Get Load Profile',
      GetFiscalPage: 'Get Fiscal Page',
      ReprocessBilling: 'Reprocess Billing',
      ReprocessCutRelay: 'Reprocess Cut/Reconnect',
      ReprocessDetailUc: 'Reprocess Consumer Unit Details',
      VoltageInterruptionMonthly: 'Read Voltage Interruption Monthly',
      DrpDrcMonthly: 'Request Monthly DRP/DRC',
      DrpDrcCycle: 'Request Weekly DRP/DRC',
      SetTariffConfiguration: 'Set Tariff Type',
      DeviceReset: 'Device Reset',
      RecoverMonitoring: 'Load Profile (Energy + Mass Memory)',
      InfoRequest: 'Read general info',
      RequestConfiguration: 'Read configuration',
      GetBlockSize: 'Get Block Size',
      ImageTransferInitiate: 'Image Transfer Initiate',
      ImageTransferData: 'Image Transfer Data',
      GetFirstBlockNotTransferred: 'Get First Block Not Transferred',
      ImageTransferVerify: 'Image Transfer Verify',
      ImageTransferActivate: 'Image Transfer Activate',
      UpdateFirmware: 'Update Firmware',
      UploadFirmware: 'Upload Firmware',
      GetHardwareInfo: 'Get Hardware Info',
      ReadNicInfo: 'Read Nic Info',
      ReadNicSetup: 'Read Nic Setup',
      ReadRelay: 'Read Relay',
      ReadTimestamp: 'Read Timestamp',
      ReadNicData: 'Read Nic Data',
      NicSetup: 'Nic Setup',
      ReadLdrUpper: 'Read Ldr Upper',
      ReadLdrBottom: 'Read Ldr Bottom',
      ReadLdrMin: 'Read Ldr Min',
      SetLdrUpper: 'Set Ldr Upper',
      SetLdrBottom: 'Set Ldr Bottom',
      SetLdrMin: 'Set Ldr Min',
      ReadNicSerial: 'Read Nic Serial',
      ReadRelayWithLastSwitchOn: 'Read Relay With Last Switch On',
      ReadRelayWithLastSwitchOnAndOff: 'Read Relay With Last Switch On And Off',
      SetBlockSize: 'Set Block Size',
      MulticastGroupSetup: 'Multicast Group Setup',
      MulticastClassCSession: 'Multicast Class C Session',
      MulticastSetupConfirmation: 'Multicast Setup Confirmation',
      ImageTransferStatus: 'Image Transfer Status',
      GetFirmwareVersion: 'Get Firmware Version',
      ReadAlarmFakeOnOff: 'Read Alarm Fake OnOff',
      ConfigureApplicationGroup: 'Configure Application Group',
      ReadALarmLastGasp: 'Read Alarm Last Gasp',
      SetLastGaspVoltageLevel: 'Set Last Gasp Voltage Level',
      ReadAlarmVoltageMonitor: 'Read Alarm Voltage Monitor',
      SetVoltageMinimalInterval: 'Set Voltage Minimal Interval',
      SetAlarmFakeOnOffThreshold: 'Set Alarm Fake OnOff Threshold',
      ReadTemperatureValue: 'Read Temperature Value',
      ReadRelayWithDelay: 'Read Relay With Delay',
      DeviceCreated: 'Device Created',
      DeviceUpdated: 'Device Updated',
      ScheduleCreated: 'Schedule Created',
      ScheduleUpdated: 'Schedule Updated',
      GroupCreated: 'Group Created',
      GroupUpdated: 'Group Updated',
      SetAlarmFakeOnOff: 'Set Alarm Fake OnOff',
      ScheduleCanceled: 'Schedule Canceled',
      ScheduleDeleted: 'Schedule Deleted',
      DeviceDeleted: 'Device Deleted',
      GroupDeleted: 'Group Deleted',
      CheckScheduleStatus: 'Check Schedule Status',
      ActivateSchedule: 'Activate Schedule',
      DeactivateSchedule: 'Deactivate Schedule',
      CheckScheduleExist: 'Check Schedule Exist',
      ReadDeviceType: 'Read Device Type',
      WriteDeviceRole: 'Write Device Role',
      FullScheduleCommand: 'Full Schedule Command',
      ScheduleCreatedOnSystem: 'Schedule Created (System)',
      ActivateScheduleOnSystem: 'Activate Schedule (System)',
      CheckScheduleStatusOnSystem: 'Check Schedule Status (System)',
      WriteDeviceRoleOnSystem: 'Write Device Role (System)',
      DeactivateScheduleOnSystem: 'Deactivate Schedule (System)',
      CheckScheduleExistOnSystem: 'Check Schedule Exist (System)',
      ReadDeviceTypeOnSystem: 'Read Device Type (System)',
      SetDatetimeOnSystem: 'Set Datetime (System)',
      PeriodicConfiguration: 'Periodic Configuration',
      Decommissioning: 'Decommissioning',
      OpenSession: 'Open Session',
      ReadMeterSerial: 'Read Meter Serial',
      ImportMassMeters: 'Import Mass Meters',
      SaveConfig: 'Save Config',
      ReadConfig: 'Read Config',
      SaveTime: 'Save Time',
      TimeCorrection: 'Time Correction',
      Storage: 'Storage',
      FuotaPause: 'Fuota Pause',
      deleteSpecialDays: 'Delete Special Days',
      GetTotalizers: 'Get Totalizers',
      GetRelayStatusControl: 'Get Relay Status Control',
      SetRelayStatusControl: 'Set Relay Status Control',
      GetIntegrationInstantaneousReadings: 'Get Integration Instantaneous Readings',
      GetVoltageOutLongShort: 'Get Voltage Out Long and Short Alarm',
      RelayStatusOrca: 'Get Orca Relay Status',
      GetQeeOnDemand: 'Get QEE On Demand',
      GetQeeHistoricalData: 'Get QEE Historical Data',
      RecoverFragmentedPacket: 'Recover Fragmented Packet',
      DrpDrcEventLog: 'DRP and DRC Event Log',
      ReadTariffPeriods: 'Get Tariff Reading',
      SmartFuseAlarmAck: 'Alarm Ack',
      ImportAlarms: 'Import Alarms',
    },
    ServiceTypeEquatorial: {
      TurnOnPower: 'Reconnect',
      TurnOffPower: 'Cut',
      RequestRead: 'Read Request',
      RequestNoteLq: 'QEE Request',
    },
    RequestStatusEquatorial: {
      Waiting: 'Waiting',
      Processing: 'Processing',
      Running: 'Running',
      CommunicationWithMDCFailed: 'Communication with MDC Failed',
      InternalFailure: 'Internal Failure',
      MDCTicketFinalized: 'MDC Ticket Finalized',
      MDCTicketFailed: 'MDC Ticket Failed',
      FinishedWithSuccess: 'Finished with Success',
      FinishedWithFailure: 'Finished with Failure',
      Cancelled: 'Cancelled',
    },
    CommandStatus: {
      CHANGING_COLLECTIVE_CUT_ALARM: 'Changing the Collective cut status',
      CHANGING_RELAY_STATUS: 'Changing Relay State',
      GBT: 'GBT',
      GET_QEE_INDICATORS: 'Requesting quality parameters',
      INSTANT_MEASURE: 'Requesting Instant Measure',
      MARK_ALARM_AS_READ: 'Marking Alarm As Read',
      NIC_RESET: 'NIC Reset',
      RECOVER_EVENT_QEE_INDICATOR: 'Retrieving Quality Parameters',
      RECOVER_FROZEN_DATA: 'Recovering Energy Totalizers',
      RECOVER_MASS_MEMORY: 'Recovering Mass Memory',
      REGISTERING_DATETIME: 'Recording Date and Time',
      REGISTERING_KEYS: 'Registering Keys',
      RELAY_ON_ALL_METERS_SMC: 'Reconnecting all clients',
      REQUESTING_DATE: 'Requesting Date',
      REQUESTING_RELAY_STATUS: 'Requesting Relay Status',
      REQUESTING_RELAY_STATUS_ALL_SMC: 'Requesting Relay Status',
      REQUESTING_SERIAL: 'Requesting Serial',
      REQUEST_DOOR_STATUS: 'Getting Status of the Collective Cut',
      ROLLBACK: 'Running RollBack!',
      SET_CURRENT: 'Changing Cutting Current',
      SET_INTERVAL_OF_LONG_OUT_VOLTAGE: 'Setting Long Out Capture Interval',
      SET_INTERVAL_OF_QEE: 'Setting DRP/DRC Capture Interval',
      SET_STANDARD_FROZEN_DATA: 'Configuring Default Energy Template',
      UPLINK_PERIOD: 'Changing the read uplink period',
      WAITING_COMMAND: 'Awaiting Command',
    },
    ComunicationStatus: {
      BUSY: 'Busy',
      COMMUNICATION_FAILED: 'Communication Failure',
      NO_INFORMATION: 'No information',
      SUCCESS: 'Success',
    },
    tariffsType: {
      tariff: 'Rate Type',
      IRRIGANTE: 'Irrigante',
      TARIFA_BRANCA: 'White Tariff',
      GD: 'Distributed Generation',
      IRRIGANTE_GD: 'Irrigante Distributed Generation',
      TARIFA_BRANCA_GD: 'White Tariff Distributed Generation',
      CONVENCIONAL: 'Conventional',
      CONVENCIONAL_GD: 'Conventional Distributed Generation',
      MMGD: 'MMGD',
      REN871: 'REN871',
      GRUPO_B_IRRIGANTE: 'Group B Irrigante',
      GRUPO_A: 'Group A',
      CLIENTE_LIVRE: 'Free Customer',
      TARIFA_BRANCA_MMGD: 'White Tariff + MMGD',
      TARIFA_BRANCA_MMGD_IRRIGANTE: 'White Tariff + MMGD + Irrigante',
      GRUPO_A_IRRIGANTE: 'Group A Irrigante',
    },
    MeterTypes: {
      Integration: 'Integration',
      IntegrationDcu: 'Integration Wasion DCU',
      Nepen: 'Integration MDX',
      IntegrationWirepas: 'Integration Wirepas',
    },
    CceeIntegrationMethod: {
      placeholder: 'Select CCEE integration method',
      None: 'None',
      Soap: 'SOAP',
      Rest: 'REST',
    },
    AlarmDescription: {
      POWER_RESTORE: 'Power Restore',
      TERMINAL_COVER_REMOVED_START: 'Terminal cover removed start',
      TERMINAL_COVER_REMOVED_END: 'Terminal cover removed end',
      CURRENT_REVERSAL_L1_START: 'Current reversal L1 start',
      CURRENT_REVERSAL_L1_END: 'Current reversal L1 end',
      MAGNETIC_FIELD_DETECTION_START: 'Magnetic field detection start',
      MAGNETIC_FIELD_DETECTION_END: 'Magnetic field detection end',
      METER_COVER_OPEN: 'Meter cover open',
      METER_COVER_CLOSE: 'Meter cover close',
      METER_AUTHENTICATION_FAILS: 'Meter authentication fails',
      PRESENCE_OF_VOLTAGE_AT_LOAD_SIDE_START: 'Presence of voltage at Load side start',
      PRESENCE_OF_VOLTAGE_AT_LOAD_SIDE_END: 'Presence of voltage at Load side end',
      FIRMWARE_UPGRADE: 'Firmware upgrade',
      DISCONNECT: 'Disconnect',
      CONNECT: 'Connect',
      CURRENT_REVERSAL_L2_START: 'Current reversal L2 start',
      CURRENT_REVERSAL_L2_END: 'Current reversal L2 end',
      CURRENT_REVERSAL_L3_START: 'Current reversal L3 start',
      CURRENT_REVERSAL_L3_END: 'Current reversal L3 end',
      MISSING_VOLTAGE_L1_START: 'Missing voltage L1 start',
      MISSING_VOLTAGE_L1_END: 'Missing voltage L1 end',
      MISSING_VOLTAGE_L2_START: 'Missing voltage L2 start',
      MISSING_VOLTAGE_L2_END: 'Missing voltage L2 end',
      MISSING_VOLTAGE_L3_START: 'Missing voltage L3 start',
      MISSING_VOLTAGE_L3_END: 'Missing voltage L3 end',
      UNDER_VOLTAGE_L1_START: 'Under voltage L1 start',
      UNDER_VOLTAGE_L1_END: 'Under voltage L1 end',
      UNDER_VOLTAGE_L2_START: 'Under voltage L2 start',
      UNDER_VOLTAGE_L2_END: 'Under voltage L2 end',
      UNDER_VOLTAGE_L3_START: 'Under voltage L3 start',
      UNDER_VOLTAGE_L3_END: 'Under voltage L3 end',
      OVER_VOLTAGE_L1_START: 'Over voltage L1 start',
      OVER_VOLTAGE_L1_END: 'Over voltage L1 end',
      OVER_VOLTAGE_L2_START: 'Over voltage L2 start',
      OVER_VOLTAGE_L2_END: 'Over voltage L2 end',
      OVER_VOLTAGE_L3_START: 'Over voltage L3 start',
      OVER_VOLTAGE_L3_END: 'Over voltage L3 end',
    },
  },
  NetworkManagement: {
    tables: {
      signalQualityTitle: 'Signal Quality History',
      commandsPacketsTitle: 'Command Packets History',
      status: 'Command Status',
      commandType: 'Command Type',
      lastUpdate: 'Last Update',
      serial: 'Serial',
      commandsPackagesHistory: 'Command Packages History',
      executeNetworkCommands: 'Execute Network Commands',
    },
    map: {
      tooltip: 'Signal Legend',
      noSignal: 'No Signal',
      poorSignal: 'Very Poor',
      fairSignal: 'Weak',
      regularSignal: 'Regular',
      goodSignal: 'Good',
      excellentSignal: 'Excellent',
    },
    errors: {
      fetchCommandsPackagesHistoryError: 'Error fetching command packages history',
      fetchSignalQualityHistoryError: 'Error fetching signal quality history',
      fetchMetersError: 'Error fetching meters',
    },
    general: {
      NoSentPackages: 'No Packages Sent for this Command',
      NoReceivedPackages: 'No Packages Received for this Command',
      NetworkDetails: 'Meter Network Details',
      DailySignalQualityHistory: 'Signal Quality',
      SignalQualityHistory: 'Signal History',
      RssiQualityHistory: 'RSSI History',
      commandsPackagesHistory: 'Network Commands History',
    },
  },
  ReadingsTable: {
    serial: 'Serial',
    dateTime: 'Date and Time',
    amrProfileStatus: 'AMR Profile Status',
    totalEnergy_Wh: 'Total Energy (kWh)',
    totalActiveEnergy_Wh: 'Total Active Energy (kWh)',
    totalDirectActiveEnergy_Wh: 'Total Direct Active Energy (kWh)',
    borderTotalizer_Wh: 'Peak Totalizer (kWh)',
    reservedTotalizer_Wh: 'Reserved Totalizer (kWh)',
    offBorderTotalizer_Wh: 'Off-Peak Totalizer (kWh)',
    apparentPowerA: 'Apparent Power A',
    apparentPowerB: 'Apparent Power B',
    apparentPowerC: 'Apparent Power C',
    reactivePowerA: 'Reactive Power A',
    reactivePowerB: 'Reactive Power B',
    reactivePowerC: 'Reactive Power C',
    totalIntermediary_Wh: 'Intermediate Total (kWh)',
    generatedEnergyTotal_Wh: 'Total Generated Energy (kWh)',
    totalReverseActiveEnergy_Wh: 'Total Reverse Active Energy (kWh)',
    generatedOffBorderEnergyTotal_Wh: 'Generated Off-Peak Energy (kWh)',
    generatedIntermediaryEnergyTotal_Wh: 'Generated Intermediate Energy (kWh)',
    generatedBorderEnergyTotal_Wh: 'Generated Peak Energy (kWh)',
    generatedReservedEnergyTotal_Wh: 'Generated Reserved Energy (kWh)',
    q1ReactiveEnergy_VarH: 'Q1 Reactive Energy (kVArh)',
    q2ReactiveEnergy_VarH: 'Q2 Reactive Energy (kVArh)',
    q3ReactiveEnergy_VarH: 'Q3 Reactive Energy (kVArh)',
    q4ReactiveEnergy_VarH: 'Q4 Reactive Energy (kVArh)',
    reactiveEnergyImportQiRi_VarH: 'Reactive Energy Import QI (+Ri) (kVArh)',
    reactiveEnergyImportQivRc_VarH: 'Reactive Energy Import QIV (-Rc) (kVArh)',
    phaseAVoltageAverage_V: 'Phase A Average Voltage (V)',
    phaseBVoltageAverage_V: 'Phase B Average Voltage (V)',
    phaseCVoltageAverage_V: 'Phase C Average Voltage (V)',
    lastAverageVoltageL1_V: 'L1 Average Voltage (V)',
    lastAverageVoltageL2_V: 'L2 Average Voltage (V)',
    lastAverageVoltageL3_V: 'L3 Average Voltage (V)',
    phaseACurrentAverage_A: 'Phase A Average Current (A)',
    phaseBCurrentAverage_A: 'Phase B Average Current (A)',
    phaseCCurrentAverage_A: 'Phase C Average Current (A)',
    lastAverageCurrentL1_A: 'L1 Average Current (A)',
    lastAverageCurrentL2_A: 'L2 Average Current (A)',
    lastAverageCurrentL3_A: 'L3 Average Current (A)',
    totalPowerFactor_NoUnit: 'Total Power Factor',
    phaseAVoltageThd_NoUnit: 'Phase A Voltage THD',
    phaseBVoltageThd_NoUnit: 'Phase B Voltage THD',
    phaseCVoltageThd_NoUnit: 'Phase C Voltage THD',
    phaseACurrentThd_NoUnit: 'Phase A Current THD',
    phaseBCurrentThd_NoUnit: 'Phase B Current THD',
    phaseCCurrentThd_NoUnit: 'Phase C Current THD',
    activePowerThd_NoUnit: 'Active Power THD',
    group0DirectEnergy_Wh: 'Group 0 Direct Energy (kWh)',
    group0InductiveReactiveDirectEnergy_VArhPlus: 'Group 0 Direct Energy (kVArh+)',
    group0CapacitiveReactiveDirectEnergy_VArhMinus: 'Group 0 Direct Energy (kVArh–)',
    group1ReverseEnergy_Wh: 'Group 1 Reverse Energy (kWh)',
    group1InductiveReactiveReverseEnergy_VArhPlus: 'Group 1 Reverse Energy (kVArh+)',
    group1CapacitiveReactiveReverseEnergy_VArhMinus: 'Group 1 Reverse Energy (kVArh–)',
    group2VoltageVaH_V: 'Group 2 Voltage Va (V)',
    group2VoltageVbH_V: 'Group 2 Voltage Vb (V)',
    group2VoltageVcH_V: 'Group 2 Voltage Vc (V)',
    group3CurrentIaH_A: 'Group 3 Current Ia (A)',
    group3CurrentIbH_A: 'Group 3 Current Ib (A)',
    group3CurrentIcH_A: 'Group 3 Current Ic (A)',
    group4ThdVoltageVaH_NoUnit: 'Group 4 THD Voltage Va',
    group4ThdVoltageVbH_NoUnit: 'Group 4 THD Voltage Vb',
    group4AngleUiA_deg: 'Group 4 Angle Ui A (º)',
    group4AngleUiB_deg: 'Group 4 Angle Ui B (º)',
    group4AngleUiC_deg: 'Group 4 Angle Ui C (º)',
    group4ThdVoltageVcH_NoUnit: 'Group 4 THD Voltage Vc',
    group5ThdCurrentIaH_NoUnit: 'Group 5 THD Current Ia',
    group5ThdCurrentIbH_NoUnit: 'Group 5 THD Current Ib',
    group5ThdCurrentIcH_NoUnit: 'Group 5 THD Current Ic',
    totalEnergyIncremental_Wh: 'Total Energy Incremental (kWh)',
    q1ReactiveEnergyIncremental_VarH: 'Q1 Reactive Energy Incremental (kVArh)',
    q4ReactiveEnergyIncremental_VarH: 'Q4 Reactive Energy Incremental (kVArh)',
    voltageA: 'Voltage A (V)',
    voltageB: 'Voltage B (V)',
    voltageC: 'Voltage C (V)',
    currentA: 'Current A (A)',
    currentB: 'Current B (A)',
    currentC: 'Current C (A)',
    activePowerA: 'Active Power A (W)',
    activePowerB: 'Active Power B (W)',
    activePowerC: 'Active Power C (W)',
    maximumVoltageA_V: 'Maximum Voltage A (V)',
    maximumVoltageB_V: 'Maximum Voltage B (V)',
    maximumVoltageC_V: 'Maximum Voltage C (V)',
    minimumVoltageA_V: 'Minimum Voltage A (V)',
    minimumVoltageB_V: 'Minimum Voltage B (V)',
    minimumVoltageC_V: 'Minimum Voltage C (V)',
    maximumCurrentA_A: 'Maximum Current A (A)',
    minimumVoltageL1_V: 'Minimum Voltage L1 (V)',
    minimumVoltageL2_V: 'Minimum Voltage L2 (V)',
    minimumVoltageL3_V: 'Minimum Voltage L3 (V)',
    totalInductiveReactiveEnergy_VarH: 'Total Inductive Reactive Energy (kVArh)',
    totalCapacitiveReactiveEnergy_VarH: 'Total Capacitive Reactive Energy (kVArh)',
    reactiveEnergyImportQiiiRi_VarH: 'Reactive Energy Import QIII (–Ri) (kVArh)',
    reactiveEnergyImportQiiRc_VarH: 'Reactive Energy Import QII (+Rc) (kVArh)',
    maximumVoltageL1_V: 'Maximum Voltage L1 (V)',
    maximumVoltageL2_V: 'Maximum Voltage L2 (V)',
    maximumVoltageL3_V: 'Maximum Voltage L3 (V)',
    maximumCurrentL1_A: 'Maximum Current L1 (A)',
    maximumCurrentL2_A: 'Maximum Current L2 (A)',
    maximumCurrentL3_A: 'Maximum Current L3 (A)',
    instantaneousVoltageL1_V: 'Instantaneous Voltage L1 (V)',
    instantaneousVoltageL2_V: 'Instantaneous Voltage L2 (V)',
    instantaneousVoltageL3_V: 'Instantaneous Voltage L3 (V)',
    instantaneousCurrentL1_V: 'Instantaneous Current L1 (A)',
    instantaneousCurrentL2_V: 'Instantaneous Current L2 (A)',
    instantaneousCurrentL3_V: 'Instantaneous Current L3 (A)',
    instantaneousActiveImportPowerAPlusL1: 'Instantaneous Active Import Power L1 (W)',
    instantaneousActiveExportPowerAMinusL1: 'Instantaneous Active Export Power L1 (W)',
    instantaneousReactiveImportPowerRPlusL1: 'Instantaneous Reactive Import Power L1 (VAr)',
    instantaneousReactiveExportPowerRMinusL1: 'Instantaneous Reactive Export Power L1 (VAr)',
    totalPowerFactorPhaseA_NoUnit: 'Phase A Power Factor',
    totalPowerFactorPhaseB_NoUnit: 'Phase B Power Factor',
    totalPowerFactorPhaseC_NoUnit: 'Phase C Power Factor',
    inductiveDirectIncremental_VarH: 'Direct Inductive Incremental (kVArh)',
    capacitiveDirectIncremental_VarH: 'Direct Capacitive Incremental (kVArh)',
    inductiveReverseIncremental_VarH: 'Reverse Inductive Incremental (kVArh)',
    capacitiveReverseIncremental_VarH: 'Reverse Capacitive Incremental (kVArh)',
    directActiveEnergyIncremental_Wh: 'Direct Active Energy Incremental (kWh)',
    reverseActiveEnergyIncremental_Wh: 'Reverse Active Energy Incremental (kWh)',
    totalAccumulatedImportActiveEnergy: 'Total Accumulated Import Active Energy (kWh)',
    totalAccumulatedExportActiveEnergy: 'Total Accumulated Export Active Energy (kWh)',
    averageImportPowerFactorPhaseA: 'Average Import Power Factor Phase A',
    averageImportPowerFactorPhaseB: 'Average Import Power Factor Phase B',
    averageImportPowerFactorPhaseC: 'Average Import Power Factor Phase C',
    instantaneousActivePowerImportPhaseA: 'Instantaneous Active Import Power Phase A (kW)',
    instantaneousActivePowerImportPhaseB: 'Instantaneous Active Import Power Phase B (kW)',
    instantaneousActivePowerImportPhaseC: 'Instantaneous Active Import Power Phase C (kW)',
    instantaneousReactivePowerImportPhaseA: 'Instantaneous Reactive Import Power Phase A (kVAr)',
    instantaneousReactivePowerImportPhaseB: 'Instantaneous Reactive Import Power Phase B (kVAr)',
    instantaneousReactivePowerImportPhaseC: 'Instantaneous Reactive Import Power Phase C (kVAr)',
  },
  FrozenData: {
    serial: 'Serial',
    dateTime: 'Reading Time',
    amrProfileStatus: 'AMR Profile Status',
    borderTotalizer_Wh: 'Peak Active Energy (kWh)',
    totalEnergy: 'Total Active Energy (kWh)',
    totalEnergy_Wh: 'Total Active Energy (kWh)',
    forderTotalizer_Wh: 'Direct Active Energy T1 (kWh)',
    reservedTotalizer_Wh: 'Reserved Active Energy (kWh)',
    offBorderTotalizer_Wh: 'Off-Peak Active Energy (kWh)',
    totalIntermediary_Wh: 'Intermediate Active Energy (kWh)',
    generatedEnergyTotal_Wh: 'Generated Active Energy (kWh)',
    totalReverseActiveEnergy_Wh: 'Total Reverse Active Energy (kWh)',
    generatedOffBorderEnergyTotal_Wh: 'Generated Off-Peak Energy (kWh)',
    generatedIntermediaryEnergyTotal_Wh: 'Generated Intermediate Energy (kWh)',
    generatedBorderEnergyTotal_Wh: 'Generated Peak Energy (kWh)',
    generatedReservedEnergyTotal_Wh: 'Generated Reserved Energy (kWh)',
    positiveReactiveEnergy_Wh: 'Positive Reactive Energy (kWh)',
    negativeReactiveEnergy_Wh: 'Negative Reactive Energy (kWh)',
    totalDirectEnergyTariffC_Wh: 'Direct Active Energy Tariff C',
    totalDirectEnergyTariffB_Wh: 'Direct Active Energy Tariff B',
    totalDirectEnergyTariffA_Wh: 'Direct Active Energy Tariff A',
    totalDirectEnergyTariffD_Wh: 'Direct Active Energy Tariff D',
    totalReverseEnergyTariffC_Wh: 'Reverse Active Energy Tariff C',
    totalReverseEnergyTariffB_Wh: 'Reverse Active Energy Tariff B',
    totalReverseEnergyTariffA_Wh: 'Reverse Active Energy Tariff A',
    totalReverseEnergyTariffD_Wh: 'Reverse Active Energy Tariff D',
    totalInductiveReactiveEnergy_VarH: 'Total Inductive Reactive Energy (kVarH)',
    totalCapacitiveReactiveEnergy_VarH: 'Total Capacitive Reactive Energy (kVarH)',
    totalInductiveReactiveEnergyTariffC_Wh: 'Reverse Active Energy Tariff C',
    totalInductiveReactiveEnergyTariffB_Wh: 'Reverse Active Energy Tariff B',
    totalInductiveReactiveEnergyTariffA_Wh: 'Reverse Active Energy Tariff A',
    totalInductiveReactiveEnergyTariffD_Wh: 'Reverse Active Energy Tariff D',
    generatedEnergyTotal: 'Generated Active Energy (kWh)',
    generatedOffBorderEnergyTotal: 'Generated Off-Peak Energy',
    generatedIntermediaryEnergyTotal: 'Generated Intermediate Energy',
    generatedBorderEnergyTotal: 'Generated Peak Energy',
    borderTotalizer: 'Peak Totalizer',
    reservedTotalizer: 'Reserved Totalizer',
    offBorderTotalizer: 'Off-Peak Totalizer',
    totalIntermediary: 'Intermediate Total',
    totalReactiveInductiveEnergy: 'Total Inductive Reactive Energy',
    totalReactiveCapacitiveEnergy: 'Total Capacitive Reactive Energy',
    consumedMaximunDemand_W: 'Maximum Consumed Demand (kW)',
    injectedMaximunDemand_W: 'Maximum Injected Demand (kW)',
    reverseCapacitiveReactiveEnergy_VarH: 'Reverse Capacitive Reactive Energy (kVarH)',
    reverseInductiveReactiveEnergy_VarH: 'Reverse Inductive Reactive Energy (kVarH)',
  },
  app: {
    name: 'Electricity Monitoring System',
    description: 'Control panel for measurement, control and energy reports',
    language: 'Select the language',
  },
  navigation: {
    home: 'Home',
    dashboard: 'Dashboard',
    devices: 'Manage Devices',
    reports: 'Detailed Reports',
    settings: 'System Settings',
    logout: 'Logout',
    meters: 'Meters',
    scheduledCommands: {
      label: 'Scheduled Commands',
      systemCommands: 'System Commands',
      routineListing: 'Routine Listing',
    },
    massCommands: {
      label: 'Mass Commands',
      readings: 'Readings',
      cutReconnect: 'Cut/Reconnect',
    },
    customReport: 'Reports',
    ccee: 'Free Market',
    eventReports: 'Event Reports',
    energyBalance: 'Energy Balance',
    smcs: 'SMCs',
    billing: 'Billing',
    dataExtraction: 'Data extraction',
    downloadCenter: 'Download Center',
    transformers: 'Transformers',
    areas: 'Areas',
    regions: 'Regions',
    serviceNotes: 'Service Notes',
    photocell: 'Photocells',
    mdxWater: 'MDX Water',
    vee: {
      label: 'VEE',
      overview: 'VEE Overview',
      groupsLegacy: 'VEE Groups (legacy)',
      monitoring: 'Monitoring',
      resume: 'Summary',
      batchApproval: 'Batch Approval',
      readingImport: 'Reading Import',
      manualEditBatchApproval: 'Batch Edit Approval',
      requestQueue: 'Request Queue',
      zeroConsumption: 'Zero Consumption',
      limitDeviations: 'Limit Deviations',
      executionMonitor: 'Execution Monitor',
      manualBillingRelease: 'Manual Billing Release',
      manualOccurrences: 'Manual Occurrences',
      configuration: {
        label: 'VEE Configuration',
        groups: 'VEE Groups',
        rules: 'Rule Library',
        thresholds: 'Rule Thresholds',
        calendar: 'Billing Calendar',
        notifications: 'Notifications',
        hierarchy: 'Hierarchy Association',
        customRule: 'Custom Rule',
      },
    },
    iagd: {
      label: 'IAGD',
      overview: 'Overview',
      settings: 'Settings',
      completeness: 'Data Completeness',
      ranking: 'Suspicion Ranking',
    },
    management: {
      label: 'Management',
      firmware: 'Firmware',
      gateways: 'Gateways',
      users: 'Users',
      keys: 'Keys',
      license: 'License',
      tags: 'Tags',
      groups: 'Groups',
      clients: 'Clients',
      models: 'Models',
      configuration: 'Configuration',
    },
  },
  views: {
    license: {
      activation: {
        on: 'License enabled',
        off: 'License disabled',
        tooltip: 'Only for clients with a per-point contract',
        enable: 'Enable',
        disable: 'Disable',
        enableTitle: 'Enable the license',
        disableTitle: 'Disable the license',
        enableMessage:
          'With the license enabled, meters without a point stop storing data and receiving commands. There are {used} points in use for a total of {total}. Check the total before enabling.',
        disableMessage:
          'With the license disabled, no meter is blocked, including those with a removed point. Points are still counted.',
        enabled: 'License enabled.',
        disabled: 'License disabled.',
        error: 'Error changing the license activation.',
      },
      title: 'License',
      client: 'Client',
      usage: 'License usage',
      usagePercent: '{percent}% of points in use',
      lastChange: 'Last changed by {user} on {date}',
      history: 'License action history',
      cards: {
        total: 'Contracted points',
        used: 'In use',
        available: 'Available',
        waiting: 'Waiting for a point',
        removed: 'Removed',
      },
      banner: {
        disabled:
          'License enforcement is off in this environment: points are shown, but no data or command is blocked.',
        exceeded:
          'License exceeded: {used} points in use for a total of {total}. New meters do not store data or receive commands.',
        limitReached:
          'Point limit reached. New meters do not store data or receive commands until the total is increased or points are removed.',
        nearLimit: '{percent}% of the license points are in use.',
        waiting:
          '{count} commissioned meter(s) without a point: not storing data or receiving commands for lack of balance.',
      },
      alert: {
        exceeded: 'License exceeded: {used} points in use for a total of {total}.',
        limitReached:
          'License limit of {total} points reached: new meters do not store data or receive commands.',
        nearLimit: '{percent}% of the license points are in use.',
        seeLicense: 'See license',
      },
      actions: {
        editTotal: 'Change total',
        removeOne: 'Remove point',
        removeByFile: 'Remove by file',
        remove: 'Remove',
        restore: 'Restore',
        save: 'Save',
        cancel: 'Cancel',
      },
      filters: {
        all: 'All',
        active: 'Active',
        removed: 'Removed',
        waiting: 'Waiting for a point',
      },
      status: {
        Ativo: 'Active',
        Removido: 'Removed',
        SemPonto: 'No point',
      },
      table: {
        title: 'Points',
        serial: 'Serial',
        status: 'Status',
        assignedAt: 'Assigned at',
        removedAt: 'Removed at',
        removedBy: 'Removed by',
      },
      dialogs: {
        totalTitle: 'Change point total',
        totalLabel: 'Contracted points',
        totalBelowUsage:
          'The new total is lower than the {used} points in use. Meters that already have a point keep storing data, but no new meter will get a point.',
        removeTitle: 'Remove point',
        restoreTitle: 'Restore point',
        serialLabel: 'Meter serial',
        removeMessage: 'Remove the point of meter {serial}?',
        restoreMessage:
          'Restore the point of meter {serial}? It will use a point, store data and receive commands again, if there is balance.',
        removeWarning:
          'The meter stops storing data and receiving commands, and the point returns to the balance. It only works again if restored. The action is recorded as a ticket.',
      },
      massRemove: {
        title: 'Remove points by file',
        description:
          'Upload a spreadsheet with a serial column. Every meter in the file stops storing data and receiving commands, and its point returns to the balance. One ticket is recorded per meter.',
        noFile: 'Select a file.',
        noSerialColumn: 'The file has no serial column.',
        noSerials: 'No serial found in the file.',
        validated: '{count} serial(s) found.',
        validatedWithDuplicates:
          '{count} serial(s) found, {duplicates} duplicated. Duplicates will be recorded as failures.',
        fileError: 'Could not read the file.',
        submit: 'Remove {count} point(s)',
        cancel: 'Cancel',
        processCreated: 'Process created with {count} meter(s). Follow the result in the tickets.',
        submitError: 'Error sending the removal file.',
      },
      success: {
        totalUpdated: 'Point total updated.',
      },
      errors: {
        getSituation: 'Error fetching the license status.',
        getPoints: 'Error fetching the license points.',
        updateTotal: 'Error changing the point total.',
        action: 'Error running the license action.',
      },
    },
    iagd: {
      overviewTitle: 'Overview — IAGD',
      distributor: 'Distributor',
      analyzedUcs: 'GD UCs analyzed',
      kpi: {
        totalUcsGd: 'Total GD UCs',
        riskHigh: 'High Risk',
        riskMedium: 'Medium Risk',
        totalFlags: 'Total Flags',
        metersInRanking: 'Meters in ranking',
        percentOfTotal: 'of total',
        accumulatedInPeriod: 'Accumulated in period',
      },
      charts: {
        riskDistribution: 'Risk Level Distribution',
        flagComposition: 'Flag Composition by Type',
        scoreDistribution: 'Normalized Score — Distribution',
        topMeters: 'Top 10 Meters by Score',
        topMetersEmpty: 'No meters found.',
      },
      flagTypes: {
        quedaBrusca: 'Abrupt Drop',
        injForaDaJanela: 'Inj. Out of Window',
        consumoNoturno: 'Night Consumption',
        tensaoIrregular: 'Irregular Voltage',
      },
      riskLevels: {
        alto: 'High',
        medio: 'Medium',
        baixo: 'Low',
      },
      ranking: {
        title: 'Suspicion Ranking',
        ucsTag: 'UCs',
        riskLabel: 'Risk Level',
        allRisks: 'All',
        searchLabel: 'Search meter',
        searchPlaceholder: 'e.g. UC-000001',
        columns: {
          ucId: 'Meter',
          score: 'Score',
          riskLevel: 'Risk',
          quedaBrusca: 'Ab. Drop',
          injForaDaJanela: 'Out of Win.',
          consumoNoturno: 'Night Cons.',
          tensaoIrregular: 'Voltage',
          cycle: 'Cycle',
        },
      },
      rankingModal: {
        titleRisk: 'Risk Level — Meters',
        titleFlag: 'Flag Type — Meters',
        titleScore: 'Score Range — Meters',
        filterLabelFlag: 'Flag Type',
        filterLabelScore: 'Score Range',
      },
      completeness: {
        title: 'Data Completeness',
        datePlaceholder: 'Month/Year',
        dateLabel: 'Period',
        searchLabel: 'Search by UC ID',
        searchPlaceholder: 'e.g. UC-000001',
        exportCsv: 'Export CSV',
        metersTag: 'meters',
        excludedTag: 'excluded from analysis',
        legendTitle: 'Legend',
        columns: {
          ucId: 'UC ID',
          completeness: 'Completeness',
          excludedReadings: 'Missing Readings',
          status: 'Status',
        },
        status: {
          included: 'Included',
          attention: 'Attention',
          excluded: 'Excluded',
        },
        cluster: {
          high: 'High',
          medium: 'Medium',
          low: 'Low',
        },
        filterStatus: 'Status',
        filterCluster: 'Completeness Bracket',
        filterAll: 'All',
      },
      ucDetail: {
        period: 'Period',
        periodTo: 'to',
        chartTitle: 'HISTORY',
        readings: 'READINGS (15 MIN)',
        flaggedRegionsLegend: 'Red-shaded regions indicate days with active flags.',
        anomalyIndicators: 'ANOMALY INDICATORS',
        flagHistory: 'ACTIVE FLAGS HISTORY',
        tabs: {
          energy: 'Energy (kWh)',
          voltage: 'Voltage (V)',
          current: 'Current (A)',
        },
        series: {
          clusterRef: 'Cluster ref.',
          energyDirect: 'Direct Energy',
          energyReverse: 'Reverse Energy',
          movingAverage: 'Moving Average',
          voltage: 'Voltage',
          current: 'Current',
        },
        noData: 'No IAGD analysis available for this consumer unit.',
      },
      settings: {
        title: 'Settings',
        save: 'Save settings',
        saving: 'Saving...',
        saveSuccess: 'Settings saved successfully',
        saveError: 'Error saving settings',
        solarWindow: {
          title: 'Solar Window',
          start: 'Start',
          end: 'End',
          startPlaceholder: 'e.g. 06:00',
          endPlaceholder: 'e.g. 20:00',
        },
        flagThresholds: {
          title: 'Flag Thresholds',
          abruptDrop: 'Abrupt Drop (%)',
          abruptDropHint: 'Drop relative to moving average (default: 40%)',
          nightConsumption: 'Night Consumption Z-score',
          nightConsumptionHint: 'Statistical deviation threshold (default: 2.5)',
          irregularVoltage: 'Irregular Voltage Z-score',
          irregularVoltageHint: 'Daily σ deviation threshold (default: 2.5)',
        },
        pipelineParams: {
          title: 'Pipeline Parameters',
          completeness: 'Completeness Threshold (%)',
          completenessHint: 'Meters below this value are excluded (default: 70%)',
          clusters: 'Number of Clusters (K)',
          clustersHint: 'Used in consumption profile K-Means',
          analysisWindow: 'Analysis window (days)',
        },
        schedules: {
          title: 'Schedules',
          scoring: 'Cron — Scoring',
          scoringHint: 'Cron format. Default: 0 2 * * * (daily, 02h UTC)',
          clustering: 'Cron — Clustering',
          clusteringHint: 'Default: 0 3 * * 1 (weekly, Mon. 03h UTC)',
        },
      },
    },
    downloads: {
      exportStarted: 'Export started',
      exportStartedDefault:
        'The file will be available in the downloads tab as soon as the process is finished.',
      exportPreparing: 'Preparing export',
      exportPreparingDetail: 'Preparing export, please wait...',
      exportNoRecords: 'No records to export',
      exportNoRecordsDetail: 'There are no records available to export with the selected filters.',
      exportCompleted: 'File available',
      exportCompletedDetail: 'The file is now available in the Download Center.',
      exportError: 'Export error',
      exportErrorDefault: 'The export could not be completed',
      exportDelayed: 'Export still processing',
      exportDelayedDetail:
        'The export is taking longer than expected. You can track its progress in the Download Center.',
    },
    massCommands: {
      invalidModel: 'Invalid model',
      requiredSerialColumn: 'The required column is: Serial',
      invalidDateColumnFormat:
        'The Date column must be in the format: year-month-day, for example 2026-01-01.',
      billingProcessStarted:
        'Billing process started. You will be redirected to track its progress.',
      billingProcessStartError: 'Could not start the billing process.',
    },
    dashboard: {
      title: 'Dashboard',
      tabs: {
        general: 'General',
        commands: 'Commands',
        alarms: 'Alarms',
        averageVariation: 'Average Variation',
        abruptVariation: 'Abrupt Variation',
        effectivenessAndAvailability: 'Effectiveness and Availability',
        quality: 'Quality',
        vee: 'VEE',
        serviceNotes: 'Notes',
        integration: 'Integration',
      },
      effectivenessDailyReport: {
        title: 'Daily report',
        description:
          'This download generates the previous day report and does not use the filters below.',
        action: 'Download report',
      },
      averageVariation: {
        titleConfigAverageVariation: 'Abrupt Variation Configuration',
        dailyConsumption: 'Daily Consumption',
        weeklyConsumption: 'Weekly Consumption',
        monthlyConsumption: 'Monthly Consumption',
        events: 'Events',
        alarms: 'Alarms',
        dailySettings: 'Daily Variation Settings',
        weeklySettings: 'Weekly Variation Settings',
        monthlySettings: 'Monthly Variation Settings',
        weekDay: 'Week Day',
        month: 'Month',
        weekDays: {
          all: 'All',
          monday: 'Monday',
          tuesday: 'Tuesday',
          wednesday: 'Wednesday',
          thursday: 'Thursday',
          friday: 'Friday',
          saturday: 'Saturday',
          sunday: 'Sunday',
        },
        months: {
          all: 'All',
          january: 'January',
          february: 'February',
          march: 'March',
          april: 'April',
          may: 'May',
          june: 'June',
          july: 'July',
          august: 'August',
          september: 'September',
          october: 'October',
          november: 'November',
          december: 'December',
        },
        placeholders: {
          selectWeekDay: 'Select a day of the week',
          selectMonth: 'Select a month',
          selectEventType: 'Select event type',
          loading: 'Loading...',
        },
        eventType: 'Event Type',
        eventTypes: {
          all: 'All',
          flow_inversion: 'Flow Inversion',
          incomplete_memory: 'Incomplete Energy',
          abrupt_consumption_variation_day: 'Abrupt Consumption Variation (Previous Day)',
          abrupt_consumption_variation_week: 'Abrupt Consumption Variation (Previous Week)',
          abrupt_consumption_variation_month: 'Abrupt Consumption Variation (Previous Month)',
          abrupt_generation_variation_day: 'Abrupt Generation Variation (Previous Day)',
          abrupt_generation_variation_week: 'Abrupt Generation Variation (Previous Week)',
          abrupt_generation_variation_month: 'Abrupt Generation Variation (Previous Month)',
          last_gasp: 'Last Gasp',
        },
        abruptVariation: 'Abrupt Variation',
        abruptVariationChart: 'Abrupt Variation Chart',
        settings: {
          title: 'Abrupt Variation Settings',
          percentageValue: 'Reference Value (%)',
          interval: 'Interval',
          loading: 'Loading...',
          cancel: 'Cancel',
          save: 'Save',
        },
        search: 'Search',
        tableHeaders: {
          startWeek: 'Start Week',
          endWeek: 'End Week',
          date: 'Date',
          weekDay: 'Week Day',
          month: 'Month',
          serial: 'Serial',
          instalation: 'Instalation',
          installation: 'Installation',
          consumption: 'Consumption (kWh)',
          generation: 'Generation (kWh)',
          difference: 'Balance (kWh)',
          startMonth: 'Start Month',
          endMonth: 'End Month',
          eventDateTime: 'Event Date/Time',
          eventType: 'Event Type',
        },
      },
    },
    veeDashboard: {
      overviewTitle: 'VEE Overview',
      filters: {
        title: 'Filters',
        region: 'Region',
        tariffClass: 'Tariff Class',
        technology: 'Technology',
        period: 'Period',
        group: 'VEE Group',
        selectRegion: 'Select the region',
        noRegions: 'No regions found',
        selectTariffClass: 'Select the tariff class',
        selectTechnology: 'Select the technology',
        selectPeriod: 'Select the period',
        selectGroup: 'Select the VEE group',
        catm1: 'CATM1',
        nbIot: 'NB-IoT',
        apply: 'Apply',
        clear: 'Clear',
        periodInvalidTitle: 'Invalid period',
        periodError: {
          required: 'Enter the start and end date of the period to search.',
          partial: 'Enter both dates of the period (start and end) to search.',
          invalid: 'The date entered is invalid.',
          reversed: 'The end date cannot be earlier than the start date.',
          future: 'The period cannot contain future dates.',
        },
      },
      errors: {
        title: 'Unable to load the dashboard',
        loadOverview: 'An error occurred while loading the VEE Overview data.',
      },
      cards: {
        validatedReadings: 'Validated Readings',
        validatedReadingsCaption: 'of the evaluated readings in the period',
        validatedReadingsTarget: 'Target',
        notAvailable: 'Not available',
        validatedReadingsUnavailable:
          'VEE has not evaluated any readings yet for the selected period and filters.',
        pendingExceptions: 'Pending Exceptions',
        estimatesToApprove: 'Estimates to Approve',
        dataGaps: 'Data Gaps',
        communicationFailures: 'Communication Failures',
        confirmedInterruptions: 'Confirmed Interruptions',
        outageEvents: 'Power Outage Events',
        tamperEvents: 'Tamper Events',
        batteryEvents: 'Battery Events',
        nextBilling: 'Next Billing',
        pendingSince: 'Pending for {n} day | Pending for {n} days',
        pendingSinceHours: 'Pending for {n} hour | Pending for {n} hours',
        agingMinutes: '{n} minute | {n} minutes',
        agingHours: '{n} hour | {n} hours',
        agingDays: '{n} day | {n} days',
        days: 'days',
        meters: 'meters',
        rowActions: 'Action',
        retry: 'Try again',
        prolongedEstimation: 'Prolonged Estimation',
        prolongedEstimationEmpty: 'No meters in prolonged estimation',
        prolongedEstimationError: 'Unable to load this indicator',
        prolongedEstimationBreakdown:
          'Initial: {initial} · Intermediate: {intermediate} · Critical: {critical}',
        notifications: 'Notifications',
        notificationsEmpty: 'No active notifications',
        notificationsError: 'Unable to load notifications',
        notificationsViewAll: 'View the active notification | View all {n} active notifications',
        notificationsViewCategory: 'View {category} notifications ({n})',
        notificationsViewAllAction: 'View all notifications',
        notificationsTotalTooltip: 'Click to view all notifications.',
        notificationsCategoryTooltip: 'Click to view the records in this category.',
        approveInBulk: 'Approve in bulk',
        approveInBulkDialog: {
          title: 'Approve estimates in bulk',
          message: 'Confirm bulk approval of {count} pending estimate(s)?',
          cancel: 'Cancel',
          confirm: 'Approve',
          successSummary: 'Estimates approved in bulk successfully.',
        },
      },
      notificationsDialog: {
        title: 'VEE Notifications',
        totalFoundLabel: 'notification found | notifications found',
        groupScopeApplied: 'Filtered by the VEE group selected on the dashboard',
        empty: 'No notifications found for the selected filters',
        noMeter: 'No associated meter',
        openSource: 'Open source',
        agingNoteTitle: 'About pending time:',
        agingNote:
          'the time is counted from when the notification was generated, not from the creation of the source record.',
        close: 'Close',
        filters: {
          category: 'Category',
          severity: 'Severity',
          meter: 'Meter',
          meterPlaceholder: 'Search by serial number',
          all: 'All',
        },
        columns: {
          category: 'Category',
          record: 'Record',
          meter: 'Meter',
          group: 'VEE group',
          severity: 'Severity',
          aging: 'Pending time',
          actions: 'Actions',
        },
        entityTypes: {
          VeeException: 'Exception',
          VeeBillingReadinessEvent: 'Billing readiness',
          VeeEstimationProposal: 'Estimation proposal',
          VeeServiceRequest: 'Service request',
          VeeBillingCalendarEscalation: 'Billing calendar escalation',
        },
      },
      trendChart: {
        title: 'Data Quality Trend',
        validated: 'Validated',
        exception: 'Exception',
        empty: 'No data found for the selected filters',
      },
      alerts: {
        title: 'Recent Alerts',
        alert: 'Alert',
        severity: 'Severity',
        meter: 'Meter',
        date: 'Date',
        viewDetails: 'View details',
        empty: 'No recent alerts',
        searchPlaceholder: 'Search meter',
        detailsDialog: {
          title: 'Alert Details',
          close: 'Close',
          resolve: 'Mark as resolved',
          resolveSuccess: 'Alert marked as resolved successfully.',
        },
      },
      groupsTable: {
        title: 'Groups',
        group: 'Group',
        validatedPercent: '% Validated',
        exceptions: 'Exceptions',
        pendingEstimates: 'Pending Estimates',
        nextBilling: 'Next Billing',
        empty: 'No groups found',
        downloadSuccess: 'Download started successfully.',
        viewGroup: 'View group dashboard',
      },
      serviceRequests: {
        title: 'Service Requests',
        meter: 'Meter',
        issue: 'Issue',
        slaRemaining: 'SLA Remaining',
        status: 'Status',
        viewDetails: 'View details',
        empty: 'No pending requests',
        searchPlaceholder: 'Search meter',
        detailsDialog: {
          title: 'Request Details',
          close: 'Close',
          resolve: 'Mark as resolved',
          resolveSuccess: 'Request marked as resolved successfully.',
        },
      },
      refreshSuccess: 'Data updated successfully.',
    },
    veeGroupDashboard: {
      title: 'VEE Group Dashboard',
      notFoundTitle: 'Group not found',
      notFoundBadge: 'No records',
      notFound: 'Group not found or has no meters associated with the current tenant.',
      filters: {
        meterSearch: 'Search meter',
        meterSearchPlaceholder: 'Enter the meter serial',
        status: 'VEE Status',
        selectStatus: 'Select status',
      },
      meters: {
        title: 'Group Meters',
        searchPlaceholder: 'Search meter',
        meter: 'Meter',
        status: 'VEE Status',
        lastUpdatedAt: 'Last Updated',
        action: 'Action',
        empty: 'No meters found in this group',
        viewMeter: 'View meter details',
        status_ok: 'OK',
        status_exception: 'Exception',
        status_estimated: 'Estimated',
        status_communicationFailure: 'No Communication',
        status_blocked: 'Blocked',
        status_unavailable: 'Not available',
      },
      refreshSuccess: 'Data updated successfully.',
    },
    customReport: {
      title: 'Reports',
      emptyState: 'No data to display.',
      readings: 'Readings',
      itemsFound: 'items found',
      comingSoon: 'Coming soon.',
      transformers: 'Transformers',
      warnings: {
        invalidPeriodSummary: 'Invalid period',
        invalidPeriodDetail:
          'On the Abrupt Variation tab, the selected period must contain dates from the same year. Select dates within the same calendar year.',
      },
      events: {
        charts: {
          overload: 'Transformers in Overload',
          overvoltage: 'Transformers in Overvoltage',
          undervoltage: 'Transformers in Undervoltage',
          unbalance: 'Voltage Unbalance',
        },
        tables: {
          overload: 'Overload',
          overvoltage: 'Overvoltage',
          undervoltage: 'Undervoltage',
          unbalance: 'Voltage Unbalance',
        },
        columns: {
          overload: 'Overload (%)',
          overvoltage: 'Overvoltage (%)',
          undervoltage: 'Undervoltage (%)',
          unbalance: 'Unbalance (%)',
        },
        viewMore: 'See More',
      },
      tabs: {
        general: 'Overview',
        events: 'Events',
        alarms: 'Alarms',
        loads: 'Loads',
        abruptVariation: 'Abrupt Variation',
      },
      ccee: {
        dateRange: 'Select period',
        quickOptions: 'Quick options:',
        quickOptionsHint: 'period of up to 7 days, starting from the previous day',
        lastDays: 'Last {count} days',
        failureKind: {
          cceeRejected: 'Rejected by CCEE',
          cceeNoResponse: 'No answer from CCEE',
          iog: 'IoG failure',
        },
        zeroFill: {
          partial: 'Sent with zeros on part of the day',
          full: 'Sent with zeros for the whole day',
        },
        kpi: {
          title: 'Indicators',
          metersOnline: 'Online Meters',
          readingsSent: 'Readings Sent (Today)',
          successRate: 'CCEE Success Rate',
          pendingTickets: 'Pending Tickets',
        },
        statusMap: {
          title: 'Status Map',
          accepted: 'Data Accepted',
          waiting: 'Awaiting CCEE Confirmation',
          lacuna: 'Gap',
          failed: 'Send Failed',
          noSubmission: 'No Submission',
          weekdays: {
            sunday: 'Sunday',
            monday: 'Monday',
            tuesday: 'Tuesday',
            wednesday: 'Wednesday',
            thursday: 'Thursday',
            friday: 'Friday',
            saturday: 'Saturday',
          },
        },
        alerts: {
          title: 'Highlighted Alerts',
          columns: {
            meter: 'Meter',
            alert: 'Alert',
            priority: 'Priority',
            date: 'Date',
          },
          priority: {
            low: 'Low',
            medium: 'Medium',
            high: 'High',
          },
          filters: {
            serial: 'Meter Serial',
            serialPlaceholder: 'Filter by serial',
            priority: 'Priority',
            allPriorities: 'All priorities',
            alertType: 'Alert type',
            allTypes: 'All types',
          },
          actions: {
            viewRelatedMeters: 'View related meters',
            viewReadings: 'View readings',
          },
          types: {
            SubmissionFailed: 'Submission failed',
            SubmissionRejected: 'Measurement rejected',
            SubmissionExhausted: 'Retries exhausted',
            SemComunicacao: 'No communication',
            Lacuna: 'Incomplete reading',
            JobCompleted: 'Send job completed',
            RecoveryFailed: 'Gap recovery failed',
            RecoveryNotSupported: 'Recovery not supported',
            Unknown: 'Unknown alert',
          },
          messageWithSerial: '{label} — {serial}',
          message: '{label}',
          meterModal: {
            title: 'Related Meters',
          },
        },
        sendStatus: {
          title: 'Send Status',
          columns: {
            meter: 'Meter',
            datetime: 'Sent at',
            referenceDate: 'Reference day',
            status: 'Status',
            ticket: 'CCEE Ticket',
            failure: 'Failure reason',
          },
          status: {
            accepted: 'Accepted',
            pending: 'Sent',
            rejected: 'Rejected',
            gap: 'Gap',
          },
          filters: {
            serial: 'Meter Serial',
            serialPlaceholder: 'Filter by serial',
            status: 'Status',
            allStatuses: 'All statuses',
            recoveryStatus: 'Recovery',
            allRecoveryStatuses: 'All recovery states',
          },
          actions: {
            viewReadings: 'View day readings',
          },
          recovery: {
            column: 'Recovery',
            status: {
              none: 'Not yet attempted',
              pending: 'Queued',
              requested: 'Awaiting meter',
              recovered: 'Recovered',
              failed: 'Failed',
              notSupported: 'Not supported',
              unknown: 'Unknown state',
            },
            reason: {
              unknown: 'Unknown reason',
              noSerial: 'Meter has no serial',
              integrationMeter: 'Integration meter — not supported',
              noModem: 'Meter has no modem',
              belongsToSmc: 'Meter belongs to an SMC',
              commandNotImplemented: 'Command unavailable for this manufacturer or model',
            },
            attempts: 'Attempts: {count}',
          },
        },
        anomalies: {
          title: 'Detected Anomalies',
          noData: 'No VEE findings on CCEE meters in the selected period',
          billingBlocked: 'Billing blocked',
          billingBlockedApplied: 'A billing block has been applied to this finding.',
          billingBlockedPending: 'Rule operational action: block billing.',
          actions: {
            viewMeterVee: 'View meter VEE',
          },
          columns: {
            meter: 'Meter',
            anomaly: 'Anomaly',
            status: 'Status',
            actionTaken: 'Action taken',
          },
          action: {
            secondaryValidation: 'Secondary validation',
            justification: 'Justification',
            kinds: {
              None: 'No action',
              ManualOverride: 'Manual edit',
              EstimationApproved: 'Estimation approved',
              EstimationProposed: 'Estimation proposed',
              EstimationRejected: 'Estimation rejected',
              EstimationInvalid: 'Estimation invalid',
              EstimationCancelled: 'Estimation cancelled',
              Resolved: 'Resolved',
              Ignored: 'Ignored',
            },
          },
        },
        performance: {
          title: 'Performance over the last 30 days',
          metrics: {
            metersOnline: 'Online Meters',
            correctedGaps: 'Corrected Gaps',
            cceeAcceptance: 'CCEE Acceptance',
            sendRate: 'Send Rate',
          },
        },
        availableReports: {
          title: 'Available Reports',
          columns: {
            report: 'Report',
            type: 'Type',
          },
        },
        generatedFiles: {
          title: 'Generated Files',
          columns: {
            report: 'Report',
            period: 'Period',
            meters: 'Meters',
            records: 'Records',
            periodicity: 'Periodicity',
          },
          periodRange: '{start} to {end}',
          noData: 'No files generated in the selected period',
          loadError: 'Error loading generated files',
          periodicity: {
            daily: 'Daily',
            monthly: 'Monthly',
          },
          filters: {
            periodicity: 'Periodicity',
            all: 'All',
          },
          downloadError: 'Error starting the file download',
          invalidPeriod: 'Could not identify the file period',
          customPeriod: {
            button: 'Generate file for period',
            title: 'Generate file for period',
            report: 'Report',
            reports: {
              notIntegrated: 'Not integrated',
              failures: 'Failures',
            },
            period: 'Period',
            periodPlaceholder: 'Select the period',
            hint:
              'The selected period must be at most {max} days long and the end date must be the previous day or earlier.',
            description:
              'The file will be generated as CSV (semicolon-separated). Due to the data volume, it will be available in the downloads tab when ready.',
            errors: {
              incomplete: 'Select the start and end dates.',
              startAfterEnd: 'The start date must be on or before the end date.',
              endAfterYesterday: 'The end date must be yesterday at the latest.',
              tooLong: 'The period must have at most {max} days.',
            },
            cancel: 'Cancel',
            confirm: 'Generate',
            errorSummary: 'Error',
            errorDetail: 'Could not start generating the file.',
          },
        },
        collectionGrid: {
          title: 'Collection Extract',
          monthPicker: 'Select month',
          meter: 'Meter',
          noData: 'No data found for the selected period',
          filters: {
            serial: 'Meter Serial',
            serialPlaceholder: 'Filter by serial',
            month: 'Month',
          },
        },
        readingsModal: {
          title: 'Readings',
          filters: {
            period: 'Period',
            status: 'Status',
            allStatuses: 'All statuses',
            ticket: 'CCEE Ticket',
            selectPeriodWarning: 'Please select a period.',
          },
          columns: {
            datetime: 'Date/Time',
            status: 'Status',
            ticket: 'CCEE Ticket',
            integrationMethod: 'Method',
            activeEnergyIn: 'Active Energy In',
            activeEnergyOut: 'Active Energy Out',
            reactiveEnergyIn: 'Reactive Energy In',
            reactiveEnergyOut: 'Reactive Energy Out',
            consumoKwh: 'Consumption',
            codigoErro: 'Error Code',
            descricaoErro: 'Error Description',
          },
          resend: {
            tooltip: 'Resend day {date} to CCEE',
            disabledTooltip: 'Only available when the readings are opened for a single day',
            confirmHeader: 'Confirm resend',
            confirmMessage:
              'Force the resend of meter {serial} to CCEE for {date}? The day will be sent even if it was already sent before.',
            confirm: 'Resend',
            cancel: 'Cancel',
            successSummary: 'Resend completed',
            successDetail:
              'Day {date} of meter {serial} was resent to CCEE. The send status will be updated on the next system check, within 5 minutes. Results can be followed in "{panel}" as processing progresses.',
            incompleteSummary: 'Incomplete day',
            incompleteDetail:
              'Only {veeReadyCount} of {requiredCount} readings are VEE-ready. Nothing was sent.',
            errorSummary: 'Resend failed',
            errorDetail: 'Could not resend the day to CCEE.',
          },
        },
        resend: {
          button: 'Resend day',
          title: 'Resend day to CCEE',
          description:
            'Resends the selected day to CCEE for every meter of this client or only for the chosen meters.',
          date: 'Reference day',
          onlyPastDays: 'Only the previous day or earlier dates can be resent for the meters.',
          mode: 'Meters',
          modeAll: 'All meters',
          modeBatch: 'Batch',
          forcedNotice:
            'Both options resend the day, including for meters that were already sent for that date. Sending runs in the background, and results are shown in "{panel}" as processing progresses.',
          allDescription:
            'The readings of the {count} CCEE meter of this client will be resent for {date}. | The readings of the {count} CCEE meters of this client will be resent for {date}.',
          allDescriptionNoCount:
            'The readings of every CCEE meter of this client will be resent for {date}.',
          meters: 'Meters',
          filters: {
            serial: 'Search meter',
            status: 'Day status',
            allStatuses: 'All statuses',
          },
          columns: {
            serial: 'Meter',
            dayStatus: 'Day status',
            ticket: 'Ticket',
            lastSubmissionAt: 'Last submission',
          },
          dayStatus: {
            accepted: 'Accepted',
            pending: 'Pending',
            rejected: 'Rejected',
            notSent: 'Not sent',
          },
          selectedCount: 'Selected: {count}',
          clearSelection: 'Clear selection',
          noCandidates: 'No CCEE meters found.',
          candidatesError: 'Could not load the meters.',
          cancel: 'Cancel',
          confirm: 'Resend',
          successSummary: 'Resend requested',
          queuedDetail:
            'The resend of {date} was scheduled for {items} meter. Results can be followed in "{panel}" as processing progresses. | The resend of {date} was scheduled for {items} meters. Results can be followed in "{panel}" as processing progresses.',
          errorSummary: 'Resend failed',
          errorDetail: 'Could not resend the day. Please try again.',
          batchCompleted: {
            summary: 'CCEE resend completed',
            detail:
              'Day {date}: {sent} sent, {incomplete} incomplete, {failed} failed, {skipped} skipped and {notEligible} not eligible.',
          },
        },
      },
      filters: {
        equipment: 'Distributor',
        installation: 'MFINSTALA',
        region: 'Region',
        polygon: 'Polygon',
        load: 'Load',
        loadRange: '% LOAD',
        cluster: 'Cluster',
        selectPeriod: 'Select the period',
        minPlaceholder: 'Min',
        maxPlaceholder: 'Max',
        superintendency: 'Superintendency',
        sectional: 'Sectional',
        city: 'City',
        itemsSelected: 'items selected',
        equipmentOptions: {
          eqtlMa: 'EQTL-MA',
          eqtlBa: 'EQTL-BA',
          eqtlPi: 'EQTL-PI',
        },
        installationOptions: {
          mfinstala: 'MFINSTALA',
          finstala: 'FINSTALA',
          nfinstala: 'NFINSTALA',
        },
        regionOptions: {
          regional: 'Region',
          east: 'East',
          west: 'West',
        },
        polygonOptions: {
          default: 'Polygon',
          centerWest: 'Center-West',
          coast: 'Coast',
        },
        loadOptions: {
          default: 'Load',
          normal: 'Normal',
          overload: 'Overload',
        },
        clusterOptions: {
          default: 'Cluster',
          upTo100: 'Up to 100%',
          between100And125: '100% to 125%',
          above175: 'Above 175%',
        },
      },
      legend: {
        normalLoad: 'Normal Load',
        overload: 'Overload',
      },
      cards: {
        loadClusters: 'Load Clusters',
        overloadByPolygon: 'Overload by Polygon',
        maxMonthlyLoad: 'Maximum Monthly Load',
        maxLoad: 'Maximum Load',
        maxLoadCurve: 'Max Load Curve',
        maxPhaseUnbalanceCurve: 'Max Phase Unbalance Curve',
        timeByTier: 'Time by Tier',
        phaseUnbalanceClusters: 'Phase Unbalance Clusters',
      },
      charts: {
        maxLoadCurve: 'Max Load Curve',
        maxPhaseUnbalanceCurve: 'Max Phase Unbalance Curve',
        phaseUnbalanceClusters: 'Phase Unbalance',
      },
      tiers: {
        upTo100: 'up to 100%',
        between100And125: '100% to 125%',
        between125And150: '125% to 150%',
        between150And175: '150% to 175%',
        above175: 'Above 175%',
      },
      unbalance: {
        upTo10: 'up to 10%',
        between10And20: '10% to 20%',
        between20And30: '20% to 30%',
        between30And40: '30% to 40%',
        between40And50: '40% to 50%',
        above50: 'above 50%',
      },
      tables: {
        transformer: 'Transformer',
        transformerName: 'Transformer Name',
        loadPercent: '% Load',
        maxLoad: 'Max Load',
        cluster: 'Cluster',
        phaseUnbalance: 'Phase Unbalance',
        date: 'Date',
        month: 'Month',
        range: 'Range',
        total: 'Total',
        percent: 'Percent',
        polygon: 'Polygon',
        region: 'Region',
        normal: 'Normal',
        overload: 'Overload',
      },
      details: {
        mfinstala: 'MFINSTALA',
        distributor: 'Distributor',
        transformer: 'Transformer',
        power: 'Power',
        region: 'Region',
        polygon: 'Polygon',
        dataDate: 'Data Date',
        posto: 'Post',
        measurementDate: 'Measurement Date',
        imax: 'Imax',
        inum: 'Inum',
        loadPercent: '% Load',
        loadPercentA: '% Load A',
        loadPercentB: '% Load B',
        loadPercentC: '% Load C',
        clusterPercent: 'Cluster %',
        overload: 'Overload',
        phaseUnbalance: 'Phase Unbalance',
        unbalanceCluster: 'Unbalance Cluster',
        currentA: 'Current A',
        currentB: 'Current B',
        currentC: 'Current C',
        undefined: 'Undefined',
      },
    },
    process: {
      title: 'Process',
      user: 'Responsible User',
      processType: 'Process Type',
      updatedAt: 'Last Updated',
    },
    massCommandsCutReconnect: {
      title: 'Cut / Reconnect',
      importSpreadsheet: 'Import spreadsheet',
      send: 'Send',
      importHint: 'Import the spreadsheet to load the cut/reconnect commands.',
      importModalTitle: 'Import Cut / Reconnect',
      validationTitle: 'Validation of imported serials',
      importedRecords: 'Imported records:',
      foundCountLabel: 'Found:',
      notFoundCountLabel: 'Not found:',
      queryingSerials: 'Querying serials...',
      noRecords: 'No records found.',
      serial: 'Serial',
      action: 'Action',
      situation: 'Status',
      foundLabel: 'Found',
      notFoundLabel: 'Not found',
      reason: 'Reason',
      historyTitle: 'Cut / Reconnect History',
      processDetails: 'Process details',
      executedAt: 'Execution Date:',
      commandStateFilter: 'Command status',
      selectPlaceholder: 'Select',
      activateRelay: 'Activate Relay',
      deactivateRelay: 'Deactivate Relay',
      getRelayState: 'Get relay state',
      invalidAction: 'Invalid action',
      statusExecuting: 'Executing',
      statusFinished: 'Finished',
      statusWaiting: 'Waiting',
      statusCancelled: 'Cancelled',
      statusFailed: 'Failed',
      confirmSendTitle: 'Confirm sending',
      notFoundWarning:
        'There are serials that were not found in the uploaded file. Do you want to continue the operation with the successfully processed files?',
      foundNotFoundCounts: 'Serials found: {found}. Not found: {notFound}.',
      sendQuestion: 'Do you want to send {count} cut/reconnect command(s)?',
      cancel: 'Cancel',
      confirmImportTitle: 'Confirm import',
      importProceedMessage:
        'Serials found: {found}. Not found: {notFound}. Do you want to proceed importing only the found items?',
      proceed: 'Proceed',
      downloadTicketsTitle: 'Download tickets',
      downloadQuestion: 'Do you want to download the tickets from this execution?',
      filterApplied: 'Applied filter:',
      noneFilter: 'None',
      download: 'Download',
      ticketDetailsTitle: 'Ticket Details',
      createdAt: 'Creation date',
      createdAtLabel: 'Creation date:',
      ticketId: 'Ticket ID',
      ticketIdLabel: 'Ticket ID:',
      device: 'Device',
      deviceLabel: 'Device:',
      ticketStatus: 'Ticket Status',
      ticketStatusLabel: 'Ticket Status:',
      commandStatus: 'Command Status',
      commandStatusLabel: 'Command Status:',
      command: 'Command',
      commandLabel: 'Command:',
      messageLabel: 'Message:',
      close: 'Close',
      warnTitle: 'Warning',
      errorTitle: 'Error',
      noRowsInFile: 'No rows found in the file.',
      invalidModelTitle: 'Invalid model',
      invalidModelDetail: 'Required columns: Serial and Command (or Meter and Action).',
      noValidSerials: 'No valid serial found in the file.',
      noSerialFoundTitle: 'No serial found',
      noSerialFoundDetail: 'Cannot continue, because no serial from the file exists in the system.',
      fileValidatedTitle: 'File validated',
      fileValidatedDetail: '{count} serial(s) found.',
      validateSerialFailReason: 'Failed to validate serial',
      validateErrorDetail: 'Failed to validate the serials in the system. Please try again.',
      importConfirmedTitle: 'Import confirmed',
      importConfirmedDetail: 'Continuing with {count} serial(s) found.',
      importCancelledTitle: 'Import cancelled',
      importCancelledDetail: 'Adjust the file and import again.',
      sendSuccessTitle: 'Sending completed',
      sendSuccessDetail: 'Mass command process started.',
      sendErrorDetail: 'Failed to send commands.',
      noTicketsToDownload: 'No ticket to download.',
      downloadTitle: 'Download',
      downloadSuccess: 'File generated successfully.',
      downloadError: 'Failed to download the tickets.',
      loadTicketsError: 'Failed to load tickets.',
      loadHistoryError: 'Failed to load history.',
    },
    massCommandsReadings: {
      title: 'Readings',
      datePlaceholder: 'dd/mm/yyyy',
      importSpreadsheet: 'Import spreadsheet',
      selectDateHint: 'Select a date and import the spreadsheet to load the readings.',
      importModalTitle: 'Import Readings',
      validationTitle: 'Validation of imported serials',
      importedRecords: 'Imported records:',
      foundCount: 'Found:',
      notFoundCount: 'Not found:',
      queryingSerials: 'Querying serials...',
      noRecords: 'No records found.',
      serial: 'Serial',
      date: 'Date',
      situation: 'Status',
      foundLabel: 'Found',
      notFoundLabel: 'Not found',
      reason: 'Reason',
      couldNotValidate: 'Could not validate',
      bill: 'Bill',
      noFileOrReading: 'No file or reading found.',
      equipmentSerial: 'Equipment serial',
      billingDate: 'Billing date',
      suggestedDate: 'Suggested date',
      recoverReading: 'Recover reading',
      serialsNotFoundTitle: 'Serials not found',
      foundSummary: '{found} serials were found and {notFound} were not found.',
      proceedQuestion: 'Do you want to proceed with the found serials only?',
      proceedWarning: 'If you proceed, the serials that were not found will be ignored.',
      cancel: 'Cancel',
      proceed: 'Proceed',
      acceptNewDatesTitle: 'Accept new dates',
      bulkNewDatesMessage:
        'The readings below have suggested dates. Do you want to accept the new dates and enable sending?',
      requestedDate: 'Requested date',
      accept: 'Accept',
      singleNewDateTitle: 'New suggested date',
      singleNewDateMessage:
        'Meter {serial} has a suggested date. Do you want to accept the new date to enable sending?',
      requestedDateLabel: 'Requested date:',
      suggestedDateLabel: 'Suggested date:',
      confirmBillingTitle: 'Confirm billing',
      exportType: 'Export type',
      exportSap: 'SAP',
      exportCustom: 'Custom',
      confirm: 'Confirm',
      recoverTitle: 'Recover reading',
      serialLabel: 'Serial:',
      loadingMeter: 'Loading meter information...',
      recoverType: 'Recovery type:',
      smcHint: 'Meter has SMC, Recover Mass Memory SMC will be used.',
      noSmcHint: 'Meter without SMC, Recover Frozen Data will be used.',
      smcQuantity: 'Quantity (SMC)',
      smcQuantityHint:
        '(The backend uses this quantity on the /commands/recover-mass-memory-smc endpoint.)',
      recover: 'Recover',
      successTitle: 'Success',
      warnTitle: 'Warning',
      errorTitle: 'Error',
      validateSerialsError: 'Failed to validate the serials in the system.',
      noValidSerials: 'No valid serial to proceed.',
      spreadsheetValidated: 'Spreadsheet validated',
      proceedingWithFound: 'Proceeding with the found serials only.',
      preProcessEmpty: 'Pre-processing returned empty. Check the date and the spreadsheet content.',
      preProcessError: 'Failed to pre-process the readings.',
      selectDateBeforeImport: 'Select a date before importing.',
      noRowsInFile: 'No rows found in the file.',
      noSerialsInSystem: 'Cannot continue: no serial from the file was found in the system.',
      partialFoundDetail: '{found} serial(s) were found and {notFound} were not found.',
      spreadsheetImported: 'Spreadsheet imported',
      importedDetail: '{count} row(s) loaded. Serials validated and pre-processing completed.',
      meterLoadFallback:
        'Could not load meter data. Trying to recover using Frozen Data by default.',
      selectDateBeforeRecover: 'Select a date before recovering.',
      recoveryTitle: 'Recovery',
      recoverySent: 'Recovery command sent.',
      recoverFailed: 'Failed to send the recovery command.',
      importRemoved: 'Import removed',
      dataCleared: 'Data cleared successfully.',
    },
    gatewaysList: {
      title: 'Gateways',
      fileActions: 'File Actions',
      importGateways: 'Import Gateways',
      associateMeters: 'Associate Meters to Gateways',
      listMeters: 'List Gateway Meters',
      name: 'Name',
      serial: 'Serial',
      ipAddress: 'IP Address',
      countMeters: 'Qty.',
      description: 'Description',
      updatedAt: 'Last update',
      gatewaysPage: 'Gateways Page',
      successTitle: 'Success',
      errorTitle: 'Error',
      fetchError: 'Error fetching Gateways {message}',
      importSuccess: 'Gateways added',
      importError: 'Error sending Gateways',
      associateSuccess: 'Meters associated to Gateways',
      associateError: 'Error associating meters',
      listMetersSuccess:
        'The Gateway meter listing process was created, you can follow the progress on the dashboard',
      listMetersError: 'Error listing Gateway meters',
      noneSelected: 'No Gateway selected',
      deleteSuccess: 'Gateway(s) deleted',
      deleteError: 'Error deleting Gateways {message}',
    },
    groupsList: {
      title: 'Groups',
      newGroup: 'New Group',
      name: 'Name',
      createdAt: 'Creation Date',
      numberOfClients: 'Number of clients',
      tags: 'Tags',
      description: 'Description',
      updatedAt: 'Last Update',
      meterPage: 'Meter Page',
    },
    meters: {
      title: 'Meters',
      periodUpdateAt: 'Period of last update',
      meterCreation: {
        createTitle: 'New Meter',
        editTitle: 'Edit Meter',
        loadError: 'Error loading required data',
        retry: 'Try again',
        serial: 'Meter Serial',
        serialPlaceholder: 'Enter the meter serial',
        manufacturer: 'Manufacturer',
        manufacturerPlaceholder: 'Select the manufacturer',
        phase: 'Phase',
        phasePlaceholder: 'Select the phase',
        model: 'Model',
        modelPlaceholder: 'Select the model',
        smc: 'SMC',
        smcPlaceholder: 'Select the SMC',
        loading: 'Loading...',
        hasTransparent: 'Transparent NIC',
        hasTransparentPlaceholder: 'Select the NIC state',
        hasTransparentInvalid: 'Invalid NIC state',
        meterType: 'Meter Type',
        meterTypePlaceholder: 'Select the type',
        cceeIntegration: 'CCEE Integration',
        cceeIntegrationPlaceholder: 'Select an option',
        cceeIntegrationStartDate: 'Integration start',
        cceeIntegrationStartDatePlaceholder: 'Select the start date',
        cceeIntegrationStartDateRequired: 'Enter the CCEE integration start date',
        cceeIntegrationStartBackfill:
          '{count} days (from {date} to yesterday) will be sent automatically to CCEE in the background.',
        cceeIntegrationStartBackfillOne:
          '1 day (from {date} to yesterday) will be sent automatically to CCEE in the background.',
        cceeIntegrationStartFuture: 'The meter starts integrating on {date}.',
        optional: 'optional',
        rateType: 'Rate Type',
        rateTypePlaceholder: 'Select the type',
        latitude: 'Latitude',
        latitudePlaceholder: 'Enter the latitude',
        longitude: 'Longitude',
        longitudePlaceholder: 'Enter the longitude',
        installation: 'Installation Code',
        installationPlaceholder: 'Enter the installation code',
        connectionPhase: 'Connection Phase',
        connectionPhasePlaceholder: 'Select the connection phase',
        registers: 'Registers',
        registersPlaceholder: 'Select the Registers',
        tags: 'Tags',
        tagsPlaceholder: 'Select the tags',
        clients: 'Clients',
        clientsPlaceholder: 'Select the Client',
        cancel: 'Cancel',
        importFromFile: 'Import from File',
        create: 'Create Meter',
        update: 'Update Meter',
        yes: 'Yes',
        no: 'No',
        successTitle: 'Success',
        errorTitle: 'Error',
        createSuccess: 'Meter created successfully',
        updateSuccess: 'Meter updated successfully',
        createError: 'Error creating meter',
        updateError: 'Error updating meter',
        modelsLoadError: 'Error loading models for the selected manufacturer',
        meterLoadError: 'Error loading meter data',
      },
      meterInfo: {
        title: 'Meter Details',
        infoClient: 'Client Info',
        moreDetails: 'View More',
        noInformation: 'No information',
        serial: 'Serial',
        installation: 'Installation',
        displayConfigured: 'Display Configuration',
        firmware: 'Firmware',
        accountantStatus: 'Relay Status',
        referenceVoltage: 'Reference Voltage',
        status: 'Communication Status',
        associatedGateway: 'Associated gateway:',
        networkTypePublic: 'Public',
        networkTypePrivate: 'Private',
        latLong: 'Lat / Long',
        crcMassMemory: 'CRC Mass Memory',
        uplinkPeriod: 'Uplink Period',
        crcFrozenData: 'CRC Energy Totalizer',
        tags: 'Meter Tags',
        regional: 'Regional',
        sectional: 'Sectional',
        polygon: 'Polygon',
        potency: 'Potency',
        noTags: 'No tags found',
        meterModel: {
          manufacturer: 'Manufacturer',
        },
        delete: 'Delete',
        confirmDelete: 'Confirm deletion of meter',
        confirmDeleteDescription: 'Are you sure you want to delete the meter?',
        confirmDeleteText: 'Yes, delete',
        actions: {
          fileUpload: 'File upload',
          editReadings: 'Edit Readings',
          editTags: 'Configure Tags',
          searchTags: 'Search tags by name',
        },
        tabs: {
          overview: 'Overview',
          iagd: 'IA-GD',
          vee: 'VEE Visualization',
        },
      },
      criticalAlarms: {
        title: 'Critical Alerts',
        criticalAlarm: 'Critical alarm',
        readDateTime: 'Reading Time:',
        updatedAt: 'Last Update:',
        notFound: 'No critical alarms found!',
        relayFailure: 'Relay Failure',
        smiTimeout: 'SMI Timeout',
        lastGasp: 'Last Gasp',
        localReset: 'Local Reset',
        measurementError: 'Measurement System Error',
      },
      maps: {
        title: 'Map View',
        noLocation: 'No location available',
      },
      display: {
        title: 'Meter Display',
        config: 'Display Settings',
        save: 'Update Settings',
        readDisplay: 'Request Display Reading',
        '001': 'Current day, month, and year',
        '002': 'Current hour, minute, and seconds',
        '003': 'Total Active General',
        '004': 'Total Active Peak',
        '006': 'Total Active Reserved',
        '008': 'Total Active Off-Peak',
        '009': 'Total Active Intermediate',
        '024': 'Total Reactive Inductive Energy',
        '103': 'Total Reverse General',
        '104': 'Total Reverse Peak',
        '106': 'Total Reverse Reserved',
        '108': 'Total Reverse Off-Peak',
        '109': 'Total Reverse Intermediate',
      },
      placeholders: {
        serial: 'Enter meter serial',
      },
    },
    meterDetails: {
      titleWithSerial: 'Meter details - {serial}',
    },
    meterFileUpload: {
      title: 'File upload',
      meterCardTitle: 'Meter - {serial}',
      selectPlaceholder: 'Import type',
      importSpreadsheet: 'Import spreadsheet',
      cancel: 'Cancel',
      send: 'Send',
      emptyHint: 'Select a type and import the spreadsheet to preview the records before sending.',
      importedRecordsTitle: 'Imported records',
      qualityWarningTitle: 'Warning',
      qualityWarningDetail:
        'There are {total} record(s) without quality indicators. These records may be rejected during processing because they do not contain DRP, DRC, DTT95, FD95, or phase indicators.',
      total: 'Total',
      tableEmpty: 'No records found.',
      removeDialogTitle: 'Remove import',
      removeDialogMessage: 'Do you want to remove the file and clear the loaded data?',
      remove: 'Remove',
      sendDialogTitle: 'Confirm send',
      sendDialogMessage: 'Do you want to finalize this operation and send {total} record(s)?',
      importModalTitle: 'Import - {label}',
      types: {
        massMemory: 'Mass memory',
        quality: 'Quality parameters',
        energy: 'Energy totalizers',
        alarms: 'Alarms',
      },
      toast: {
        importedTitle: 'File imported',
        importedDetail: '{total} record(s) loaded.',
        removedTitle: 'Import removed',
        removedDetail: 'Data cleared successfully.',
        unavailableTitle: 'Unavailable',
        alarmsNotImplemented: 'This option is not available yet.',
        sentTitle: 'Sent successfully',
        sentDetail: 'Import started successfully.',
        sendError: 'Unable to send the data. Please try again.',
        noRows: 'No records were found in the file.',
        invalidSerial: 'Invalid Serial',
      },
    },
    meterVeeDetails: {
      titleWithSerial: 'VEE - Meter {serial}',
      currentReadingCardTitle: 'Current reading',
      currentReadingUnavailable: 'Not available',
      group: 'VEE Group',
      groupUnavailable: 'Not available',
      statusCardTitle: 'Status',
      blockingCardTitle: 'Blocking',
      status: {
        ok: 'Validated',
        exception: 'With exception',
        estimated: 'Estimating',
        noCommunication: 'No communication',
        blocked: 'Blocked',
        notBlocked: 'Not blocked',
        unavailable: 'Not available',
      },
      hierarchyLevel: {
        meter: 'Level: Meter',
        existingGroup: 'Level: Existing group',
        tag: 'Level: Tag',
        consumerUnit: 'Level: Consumer unit',
        tariffClass: 'Level: Tariff class',
        technology: 'Level: Technology',
        default: 'Level: Tenant default',
      },
      chart: {
        title: 'Readings',
        loadError: 'Unable to load readings.',
        availabilityConflictTitle: 'Unable to consolidate the readings',
        availabilityConflictDescription:
          'Conflicting availability classifications were found for this meter in the selected period. Check the VEE associations and the occurrences for the period, or contact the administrator.',
        period: 'Period',
        periodPlaceholder: 'Select the period',
        measurement: 'Measurement',
        measurementPlaceholder: 'Select the measurement',
        displayedMeasurement: 'Displayed measurement',
        noValues: 'No values for the selected measurement in the period.',
        semantics: {
          incremental: 'Incremental (per interval)',
          accumulative: 'Accumulative (totalizer)',
          instantaneous: 'Instantaneous (average)',
        },
        real: 'Real',
        estimatedApproved: 'Approved estimate',
        edited: 'Edited',
        pendingProposal: 'Pending proposal',
        gapMarker: 'No data',
        gaps: {
          '5': 'Gap',
          '6': 'No communication',
          '7': 'Interruption',
        },
        availabilityReason: {
          dataSource: 'Data type',
          missingIntervals: 'Missing or invalid',
          intervalOne: '{count} interval',
          intervalOther: '{count} intervals',
          periodRange: '{start} to {end}',
          noEligibleSource:
            'No eligible source and no active unavailability classification for this instant.',
        },
      },
      amiEvents: {
        title: 'AMI Events',
        loadError: 'Unable to load AMI events.',
        empty: 'No AMI events in the selected period',
        categoryFilter: 'Event type',
        categoryFilterPlaceholder: 'Select the type',
        origin: 'Origin',
        severity: 'Severity',
        severityNotInformed: 'Not informed',
        start: 'Start',
        end: 'End',
        duration: 'Duration',
        originAmi: 'AMI',
        originManual: 'Manual',
        durationMinutes: '{minutes} min',
        durationHoursMinutes: '{hours}h {minutes}min',
        categories: {
          outage: 'Power Outage',
          restoration: 'Restoration',
          tamper: 'Tamper',
          battery: 'Battery',
          communicationFailure: 'Communication Failure',
          communicationRestored: 'Communication Restored',
        },
        intervalTypes: {
          powerInterruption: 'Power Interruption',
          communicationFailureInterval: 'Communication Failure',
          tamperInterval: 'Tamper',
        },
        columns: {
          event: 'Event',
        },
      },
      prolongedEstimation: {
        banner: 'In continuous estimation for {days} days',
        since: 'Since',
        cause: 'Cause',
        causeDetail: 'Continuous approved estimation in {dataScope} for {quantity} (level {level})',
        levels: {
          initial: 'Initial',
          intermediate: 'Intermediate',
          critical: 'Critical',
        },
        recommendedAction: 'Recommended action',
        suggestServiceOrder: 'Suggestion: consider opening a field service order',
      },
      exceptions: {
        title: 'Active exceptions',
        empty: 'No active exceptions',
        loadError: 'Unable to load exceptions.',
        edit: 'Edit',
        resolve: 'Resolve',
        ignore: 'Ignore',
        resolveTooltip: 'Mark this exception as resolved',
        ignoreTooltip: 'Ignore this exception',
        editTooltip: 'Edit the readings related to this exception',
        columns: {
          rule: 'Rule',
          status: 'Status',
          actions: 'Actions',
        },
        status: {
          pendente: 'Pending',
          emAnalise: 'Under review',
          resolvida: 'Resolved',
          ignorada: 'Ignored',
        },
        availability: {
          dataGap: 'Data gap',
          communicationFailure: 'Communication failure',
          confirmedInterruption: 'Confirmed interruption',
          confirmedInterruptionAmiHint:
            'Confirmed interruption based on AMI event correlation (outage + restoration).',
        },
        correlatedEvent: {
          label: 'Correlated Event',
          amiHint: 'Confirmed interruption based on AMI event correlation (outage + restoration).',
          manualHint: 'Confirmed interruption based on a manually registered alarm.',
        },
        rules: {
          IntervalSize: 'Interval Size',
          DuplicateImd: 'Duplicate Mass Memory Record',
          ConsecutiveInterval: 'Consecutive Intervals',
          UoM: 'Unit of Measure',
          SumCheck: 'Sum Check',
          HighLow: 'Upper/Lower Limit',
          Zero: 'Zero Consumption',
          Negative: 'Negative Value',
          Static: 'Static Reading',
          Spike: 'Abrupt Variation',
          Missing: 'Missing Reading',
          DynamicComparison: 'Dynamic Comparison',
          ProlongedZero: 'Prolonged Zero',
          RegisterInversion: 'Register Inversion',
          Rollover: 'Totalizer Rollover',
          Multiplier: 'Multiplier',
          Duplicate: 'Duplicate Totalizer Record',
          UoMCompatibility: 'Unit Compatibility',
          InactiveMeasurement: 'Reading From Inactive Meter',
          ProlongedEstimation: 'Prolonged Estimation',
          CustomRuleEngine: 'Custom Rule',
          BurnedTp: 'Burned TP',
          BurnedTc: 'Burned TC',
          BurnedMeter: 'Burned meter',
        },
      },
      estimationRequest: {
        title: 'Generate Estimate Proposals',
        openTooltip: 'Generate estimate proposals for this data gap',
        openLabel: 'Generate estimates',
        intro:
          'Request proposals for a period of the gap. Processing runs in the background and the proposals go through secondary validation and human approval.',
        limits: 'Up to {max} intervals per request ({minutes}-minute intervals).',
        zeroFillNote:
          'Continuous gaps longer than {hours} h do not use ZeroFill, even when requested in parts.',
        period: 'Period',
        periodPlaceholder: 'Select the period',
        intervals: '{count} interval(s)',
        proposalsCount: '{count} proposal(s)',
        intervalsExceeded: 'The period exceeds the maximum of {max} intervals per request.',
        periodStartRequired: 'Enter the start date and time.',
        periodEndRequired: 'Enter the end date and time.',
        periodEndNotAfterStart: 'The end date and time must be later than the start.',
        periodNotAligned: 'The period length must be a multiple of {minutes} minutes.',
        noGaps: 'The occurrence has no missing intervals to estimate.',
        gaps: 'Occurrence gaps',
        gapsLoadError: 'Could not load the gaps.',
        runExceedsLimit:
          'Exceeds {max} intervals: using the period applies only a sub-period of up to {max} intervals.',
        appliedRunPartial:
          'Full gap: {period} ({total} intervals). Applied to the form: the first {max} intervals ({subperiod}). The remaining intervals need new requests.',
        viewProposals: 'View proposals',
        useRun: 'Use period',
        zeroFillAllowed: 'Allowed',
        zeroFillBlocked: 'Blocked',
        validationMissing: 'Secondary validation not configured',
        validationReady: 'Secondary validation configured for the period.',
        periodRejected: 'Period not accepted for generation',
        clear: 'Clear',
        clearTooltip: 'Clear the selected period',
        appliedRun: 'Period filled from the gap',
        selectedRun: 'Selected',
        periodStartPlaceholder: 'Start date and time',
        periodEndPlaceholder: 'End date and time',
        validationChecking: 'Checking the secondary validation for the period...',
        validationCheckError: 'Could not check the secondary validation for the period.',
        request: 'Request generation',
        requests: 'Requests',
        noRequests: 'No requests for this occurrence.',
        close: 'Close',
        loadError: 'Could not load the proposal generation data.',
        requestSuccess: 'Request sent. Processing runs in the background.',
        requestExisting: 'A request already exists for this period.',
        requestError: 'Could not request the proposal generation.',
        completedHint:
          'Proposals generated: they appear in "Estimate Proposals" for validation and approval.',
        columns: {
          period: 'Period',
          intervals: 'Intervals',
          status: 'Status',
          proposals: 'Proposals',
          details: 'Details',
          zeroFill: 'ZeroFill',
          actions: 'Actions',
        },
        status: {
          pending: 'Queued',
          running: 'Processing',
          completed: 'Completed',
          completedWithFailures: 'Completed with failures',
          failed: 'Failed',
        },
        failedRuns: '{count} gap(s) without an applicable method',
        toast: {
          refreshErrorTitle: 'Refresh failed',
          requestSuccessTitle: 'Generation requested',
          requestExistingTitle: 'Existing request',
          requestErrorTitle: 'Failed to request the generation',
        },
      },
      estimateProposals: {
        title: 'Estimate proposals',
        empty: 'No pending proposals',
        loadError: 'Unable to load estimate proposals.',
        approve: 'Approve',
        reject: 'Reject',
        notEligible: 'Not eligible for approval',
        columns: {
          method: 'Method',
          actions: 'Actions',
        },
        methods: {
          interpolation: 'Interpolation',
          proxyDay: 'Proxy day',
          loadProfile: 'Load profile',
          scalarCalculation: 'Accumulator difference calculation',
          zeroFill: 'Zero fill',
          burnedEquipmentFactor15: '1.5x factor (burned TP/TC)',
          burnedMeterHistoricalAverage: 'Historical average (burned meter)',
        },
      },
      approvedHistory: {
        title: 'Approved Estimates History',
        approvalPeriod: 'Approval period',
        periodPlaceholder: 'Select the period',
        periodTooltip: 'Filters by approval date, not by reading period.',
        loadError: 'Could not load the approved estimates history.',
        empty: 'No approved estimates for this meter.',
        emptyFiltered: 'No approved estimates in the selected approval period.',
        columns: {
          approvedAt: 'Approved at',
          readingPeriod: 'Reading period',
          method: 'Method',
          value: 'Approved value',
          user: 'User',
          status: 'Status',
          actions: 'Actions',
        },
        statusApproved: 'Approved',
        details: 'Details',
        footnote: 'Times: approval in local time and readings in meter time. The approved value may differ from the current effective value.',
        detailsTitle: 'Approved Estimate',
        readingPeriodSameDay: '{date}, from {start} to {end}',
        readingPeriodMultiDay: 'From {start} to {end}',
        auditNotFound: 'The audit record for this approval was not found.',
        auditLoadError: 'Could not load the audit record for this approval.',
        detailsLoadError: 'Could not load all proposal details.',
        measurement: 'Measurement',
        proposedValue: 'Proposed value',
        group: 'VEE group',
        rule: 'Rule',
        effective: {
          title: 'Current effective value',
          hint: 'Check which value the VEE currently uses for this reading. A reading received later or a manual edit may prevail over the approved estimate.',
          check: 'Check effective value',
          value: 'Value',
          origin: 'Origin',
          noValue: 'No value',
          differs: 'The current effective value differs from the approved value.',
          loadError: 'Could not query the current effective value.',
          origins: {
            '0': 'None',
            '1': 'Manual edit',
            '2': 'Approved estimate',
            '3': 'Raw reading',
          },
        },
        quality: {
          '1': 'Real',
          '2': 'Proposed estimate',
          '3': 'Approved estimate',
          '4': 'Edited',
          '5': 'Missing',
          '6': 'Communication failure',
          '7': 'Interrupted',
        },
        viewAudit: 'View audit',
        close: 'Close',
      },
      auditTrail: {
        title: 'Edit History',
        empty: 'No audit records for the selected filter.',
        loadError: 'Unable to load the audit history.',
        period: 'Period',
        periodPlaceholder: 'Select the period',
        operator: 'Operator',
        operatorPlaceholder: 'Select the operator',
        actionType: 'Action type',
        actionTypePlaceholder: 'Select the action type',
        entityType: 'Related entity',
        entityTypePlaceholder: 'Select the entity',
        qualityStatus: 'Quality Flag',
        qualityStatusPlaceholder: 'Select the quality flag',
        clearFilters: 'Clear filters',
        exportCsv: 'Export CSV',
        exportJson: 'Export JSON',
        before: 'Before',
        after: 'After',
        details: 'View details',
        qualityNotApplicable: 'Not applicable',
        proposalStatus: {
          pending: 'Pending',
          approved: 'Approved',
          rejected: 'Rejected',
          invalid: 'Invalid',
          cancelled: 'Cancelled',
        },
        detailsDialog: {
          title: 'Change Details',
          before: 'Before',
          after: 'After',
        },
        actionTypes: {
          Created: 'Created',
          Edited: 'Edited',
          Approved: 'Approved',
          Rejected: 'Rejected',
          StatusChanged: 'Status changed',
          BillingManuallyReleased: 'Billing manually released',
          ManualOccurrenceCreated: 'Manual occurrence',
          HistoryConsolidated: 'History consolidated',
          BatchSubmitted: 'Batch submitted',
          BatchDecided: 'Batch decided',
          DecisionRecorded: 'Decision recorded',
          SecondaryValidated: 'Secondary validation completed',
          Applied: 'Applied',
          ValueAdjusted: 'Value adjusted',
          Updated: 'Updated',
          Deactivated: 'Deactivated',
          ParametersUpdated: 'Parameters updated',
          ScheduledCreated: 'Schedule created',
          BillingCalendarTriggerCreated: 'Billing calendar trigger created',
          BillingCalendarEscalationTransferredAfterFailure:
            'Billing calendar escalation transferred after failure',
          ScheduledSkippedNoEligibleMeters: 'Schedule skipped: no eligible meters',
        },
        entityTypes: {
          VeeManualReadingOverride: 'Manual reading override',
          VeeEstimationProposal: 'Estimation proposal',
          VeeException: 'Exception',
          VeeServiceRequest: 'Service request',
          VeeBillingReadinessCurrentStatus: 'Billing readiness',
          VeeManualEditBatch: 'Manual edit batch',
          VeeExecution: 'VEE execution',
          VeeGroup: 'VEE group',
          VeeBillingCalendar: 'Billing calendar',
          VeeRuleParameter: 'Rule parameter',
          VeeRule: 'VEE rule',
          VeeNotificationConfig: 'Notification configuration',
          VeeGroupBatchApprovalPolicy: 'Group batch approval policy',
          VeeBillingReadinessEvent: 'Billing readiness event',
          VeeBillingCalendarEscalation: 'Billing calendar escalation',
        },
        columns: {
          occurredAt: 'Date/Time',
          action: 'Action type',
          entity: 'Entity',
          actor: 'User',
          reason: 'Justification',
          qualityStatus: 'Quality Flag',
          actions: 'Actions',
        },
      },
      decisionDialog: {
        approveTitle: 'Approve Estimate Proposal',
        rejectTitle: 'Reject Estimate Proposal',
        loading: 'Loading proposal details...',
        loadError: 'Unable to load the proposal details.',
        proposalChanged: 'The proposal has changed since the list was loaded.',
        reload: 'Reload',
        method: 'Method',
        period: 'Period',
        proposedValue: 'Proposed value',
        measurementKey: 'Measurement',
        secondaryValidation: 'Secondary validation',
        secondaryValidationStatus: {
          approved: 'Approved',
          rejectedByRule: 'Rejected by rule',
          infeasible: 'Infeasible',
          technicalFailure: 'Technical failure',
          none: 'Not evaluated',
        },
        originalData: 'Original data',
        originalDataUnavailable: 'No original data available.',
        originalDataFields: {
          timestamp: 'Date and time',
          value: 'Value',
          unit: 'Unit',
          source: 'Source',
          marker: 'Marker',
          slot: 'Slot',
          measurementKey: 'Measurement',
          slotStart: 'Slot start',
          slotEnd: 'Slot end',
          slotTimestamp: 'Slot date and time',
          note: 'Note',
        },
        referenceReadings: 'Reference readings used',
        referenceReadingsEmpty: 'No reference readings available.',
        referenceReadingRole: {
          leading: 'Leading',
          trailing: 'Trailing',
          context: 'Context',
          before: 'Before',
          after: 'After',
          anchor: 'Anchor',
          comparableTransition: 'Comparable transition',
          accumulatorBefore: 'Accumulator before',
          accumulatorAfter: 'Accumulator after',
        },
        secondaryValidationReason: {
          dataScopeMismatch: 'Outside the rule data scope',
          measurementKeyMismatch: 'Measurement not matching the rule',
          unitMismatch: 'Unit of measurement mismatch',
          zeroToleranceViolation: 'Zero tolerance violation',
          negativeValueViolation: 'Negative value not allowed',
          rangeViolation: 'Value outside the allowed range',
          meterInactive: 'Inactive meter',
          inactiveMeasurementHistoricalStateUnavailable: 'Meter history unavailable',
          comparisonModeNotSupported: 'Comparison mode not supported',
          ruleNotImplemented: 'Rule not implemented',
          ruleInactive: 'Inactive rule',
          mandatoryRuleNotImplemented: 'Mandatory rule not implemented',
          consultiveRuleNotImplemented: 'Consultative rule not implemented',
          invalidRuleConfiguration: 'Invalid rule configuration',
          insufficientDataForRule: 'Insufficient data to apply the rule',
          expectedUnitIncompatibleWithCanonical: 'Expected unit incompatible',
          noApplicableRules: 'No applicable rules',
          noRulesConfigured: 'No rules configured in the VEE group',
          incompleteProposalData: 'Incomplete proposal data',
          technicalErrorDuringRule: 'Technical failure while running the rule',
        },
      },
      editReadingDialog: {
        title: 'Manual reading edit',
        editReading: 'Edit reading',
        readingTimestamp: 'Reading date and time',
        readingTimestampPlaceholder: 'Select the date and time',
        scope: 'Scope',
        scopePlaceholder: 'Select the scope',
        scopes: {
          massMemory: 'Mass Memory',
          totalizers: 'Totalizers',
        },
        measurementKey: 'Measurement',
        measurementKeyPlaceholder: 'Select the measurement',
        newValue: 'New value',
        newValuePlaceholder: 'Enter the new value',
        justification: 'Justification (required)',
        justificationPlaceholder: 'Describe the reason for the manual edit',
        reasonCode: 'Structured reason',
        reasonCodePlaceholder: 'Select the reason',
        reasonCodes: {
          meterReadingError: 'Meter reading error',
          communicationFailureCompensation: 'Communication failure compensation',
          fieldInspectionCorrection: 'Field inspection correction',
          dataEntryCorrection: 'Data entry correction',
          other: 'Other',
        },
        preview: 'Preview',
        previewing: 'Previewing...',
        previewErrors: 'Fix the items below before previewing again:',
        previewRequired: 'Preview the edit before confirming.',
        previewSummary: {
          originalValue: 'Original value',
          newValue: 'New value',
          unit: 'Unit',
          group: 'VEE Group',
          activeOverride:
            'This reading already has an active edit (version {version}, current value {value}).',
          predictedOccurrences: 'Predicted reprocessing impact',
          noPredictedOccurrences: 'No occurrence predicted for the new value.',
        },
        severities: {
          info: 'Informational',
          issue: 'Alert',
          terminate: 'Critical',
        },
        cancel: 'Cancel',
        confirm: 'Confirm edit',
        confirming: 'Confirming...',
      },
      rejectProposalDialog: {
        justification: 'Justification (required)',
        justificationPlaceholder: 'Describe the reason for rejecting the proposal',
        cancel: 'Cancel',
        confirm: 'Reject proposal',
      },
      exceptionDecisionDialog: {
        resolveTitle: 'Resolve Exception',
        ignoreTitle: 'Ignore Exception',
        justification: 'Justification (required)',
        justificationPlaceholder: 'Describe the reason for this decision on the exception',
      },
      errors: {
        loadFailed: 'Unable to load VEE data for this meter.',
        retry: 'Try again',
      },
      ccee: {
        ready: 'Available for Free Market',
        notReady: 'Unavailable for Free Market',
      },
      toast: {
        justificationRequiredTitle: 'Justification required',
        justificationRequired: 'Enter a justification to edit the reading.',
        readingUpdatedTitle: 'Reading updated',
        readingUpdatedDetail: 'The reading was updated successfully.',
        proposalApprovedTitle: 'Estimate approved',
        proposalApprovedDetail: 'Proposal by {method} approved and applied to the current reading.',
        proposalRejectedTitle: 'Estimate rejected',
        proposalRejectedDetail: 'Proposal by {method} rejected.',
        proposalActionErrorTitle: 'Unable to complete the decision',
        proposalActionErrorDetail:
          'An error occurred while processing the decision on this proposal. Please try again.',
        exceptionResolvedTitle: 'Exception resolved',
        exceptionResolvedDetail: '{rule} marked as resolved.',
        exceptionIgnoredTitle: 'Exception ignored',
        exceptionIgnoredDetail: '{rule} marked as ignored.',
        exceptionActionErrorTitle: 'Unable to complete the action',
        exceptionActionErrorDetail:
          'An error occurred while processing the action on this exception. Please try again.',
        overridePreviewErrorTitle: 'Unable to preview the edit',
        overridePreviewErrorDetail: 'Check the entered data and try again.',
        overrideConfirmedTitle: 'Reading edited',
        overrideConfirmedDetail:
          'The edit was confirmed and reprocessing produced {count} occurrence(s).',
        overrideConflictTitle: 'Edit conflict',
        overrideConflictDetail: 'The reading changed since the preview. Preview it again.',
        overrideConfirmErrorTitle: 'Unable to confirm the edit',
        overrideConfirmErrorDetail:
          'An error occurred while confirming the edit. Please try again.',
        periodTooLongTitle: 'Invalid period',
        periodTooLongDetail: 'The selected period cannot exceed {days} days.',
        periodIncompleteTitle: 'Incomplete period',
        periodIncompleteDetail: 'Select both a start and end date before applying the filter.',
        periodRequiredTitle: 'Period required',
        periodRequiredDetail: 'Enter a start and end date to query the readings.',
      },
    },
    manualInsertReadings: {
      title: 'Manual Readings/Alarms Editing',
      tabs: {
        meterAlarms: 'Meter Alarms',
        dataReadings: 'Mass Memory',
        frozenData: 'Totalizers',
        qeeIndicators: 'Quality',
        smcAlarms: 'SMC Alarms',
      },
      meterAlarmsTable: {
        serial: 'Serial',
        description: 'Description',
        terminal: 'Terminal',
        read: 'Read',
        manualInsert: 'Is manual',
        installation: 'Installation',
        user: 'User',
        translate: 'Translation',
        readDate: 'Reading Date',
        updatedAt: 'Last Update',
      },
      dataReadingsTable: {},
      frozenDataTable: {},
      qeeIndicatorsTable: {
        serial: 'Serial',
        comissioned: 'Comm',
        online: 'Online',
        dateTimeInitial: 'Initial Date/Time',
        dateTimeFinal: 'Final Date/Time',
        drp: 'DRP',
        drc: 'DRC',
        dtt95: 'DTT95',
        fd95: 'FD95',
        count: 'Count',
        meterActivated: 'Activated Meters',
        drcPhaseA: 'DrcPhaseA',
        drcPhaseB: 'DrcPhaseB',
        drcPhaseC: 'DrcPhaseC',
        drpPhaseA: 'DrpPhaseA',
        drpPhaseB: 'DrpPhaseB',
        drpPhaseC: 'DrpPhaseC',
        consumerUnitsId: 'Consumer Unit',
        updatedAt: 'Updated At',
      },
      smcAlarmsTable: {
        serial: 'Serial',
        description: 'Description',
        read: 'Read',
        isManualInsert: 'Is manual',
        user: 'User',
        translate: 'Translation',
        readDateTime: 'Reading Date/Time',
        updatedAt: 'Last Update',
      },
      messages: {
        qeeEditUnavailable: 'Editing unavailable.',
        qeeDeleteUnavailable: 'Deletion unavailable.',
        qeeClosedCycle:
          'The selected period has already been closed and does not allow manual editing. Allowed until: {deadline}.',
        qeeDeleteClosedCycle:
          'The selected period has already been closed and does not allow manual deletion. Allowed until: {deadline}.',
        invalidDateRange: 'Initial Date/Time cannot be greater than Final Date/Time.',
        requiredDrpDrc: 'DRP and DRC are required.',
        useCommaDecimalSeparator: 'Enter DRP and DRC using comma and up to 3 decimal places.',
        qeeUpdateSuccess: 'Parameter updated successfully.',
        qeeUpdateError: 'Unable to update the QEE parameter.',
        qeeDeleteConfirmTitle: 'Confirm deletion',
        qeeDeleteConfirmMessage: 'Do you really want to delete this quality parameter?',
        qeeDeleteConfirmAction: 'Delete',
        qeeDeleteSuccess: 'Quality parameter deleted successfully.',
        qeeDeleteError: 'Could not delete the quality parameter.',
      },
    },
    consumerUnit: {
      fullName: 'Full Name',
      address: 'Address',
      locationCode: 'Location Code',
      consumerUnitCode: 'Consumer Unit Code',
      situationCode: 'Situation Code',
      situationDate: 'Situation Date',
      consumptionClassCode: 'Consumption Class Code',
      equipmentNumber: 'Equipment Number',
      historyUc: 'History',
      communicationDescription: 'Communication',
      startRelationDatetime: 'Start of Relation',
      endRelationDatetime: 'End of Relation',
    },
    smcs: {
      title: 'SMCs',
      smcInfo: {
        title: 'SMC Details',
        model: 'Model',
        brand: 'Brand',
        serial: 'Serial',
        qtyMeters: 'Quantity of Clients',
        uplinkPeriod: 'Uplink Period',
        signalQuality: 'Signal',
        networkPublic: 'Public ',
        networkPrivate: 'Private ',
        description: 'Description',
        latitude: 'Latitude',
        longitude: 'Longitude',
        tagsFilterTitle: 'Applied filters',
        tagsFilterDetails: 'Tag-based filters applied; however, SMC does not have tags.',
        doorStatus: 'Door Status',
        online: 'Communication Status',
        comissioned: 'Comissioned',
      },
      criticalAlarms: {
        title: 'Critical Alerts',
        criticalAlarm: 'Critical alarm',
        readDateTime: 'Reading Time:',
        updatedAt: 'Last Update:',
        notFound: 'No critical alarms found!',
        relayFailure: 'Relay Failure',
        openDoor: 'Open Door',
        smcTimeout: 'SMC Timeout',
        lastGasp: 'Last Gasp',
        localReset: 'Local Reset',
        measurementError: 'Measurement System Error',
        keysHLSInvalid: 'Invalid HLS Keys',
        invalidMeter: 'Invalid Meter',
      },
      success: {
        createSmc: 'SMC created successfully',
        updateSmc: 'SMC updated successfully',
      },
      errors: {
        createSmc: 'Error creating SMC',
        updateSmc: 'Error updating SMC',
        loadSmcModels: 'Error loading SMC models',
      },
      summary: {
        statusTitle: 'Status',
        commissioningTitle: 'Commissioning',
        portTitle: 'Port Status',
        fetchErrorTitle: 'Error',
        fetchErrorDetail: 'Error while fetching SMC summary',
        online: 'Online',
        offline: 'Offline',
        absent: 'Absent',
        commissioned: 'Commissioned',
        notCommissioned: 'Not Commissioned',
        authorized: 'Authorized',
        unauthorized: 'Unauthorized',
        details: {
          onlineTitle: 'Online SMCs',
          offlineTitle: 'Offline SMCs',
          absentTitle: 'Absent SMCs',
          commissionedTitle: 'Commissioned SMCs',
          notCommissionedTitle: 'Not Commissioned SMCs',
          authorizedTitle: 'SMCs with Authorized port status',
          unauthorizedTitle: 'SMCs with Unauthorized port status',
          selectBrand: 'Select the brand',
        },
      },
      registerSmcFile: 'Import SMCs via file',
      editSmcFile: 'Edit SMCs via file',
      massActionStartedTitle: 'Process started',
      massActionStartedDetail: 'Process started. Please wait for the action to finish.',
    },
    modemInfo: {
      title: 'Modem',
      notAvailable: 'Not available',
      noInformation: 'No information',
      deviceEui: 'EUI',
      firmwareVersion: 'Firmware',
      signal: 'Signal',
      iccid: 'ICCID',
      imei: 'IMEI',
      imsi: 'IMSI',
      operator: 'Operator',
      cellId: 'Cell ID',
      signalQuality: 'Signal',
      bootCounter: 'Boot Counter',
      snr: 'SNR',
      rssi: 'RSSI',
      bleStack: 'BleStack',
      mcuRevision: 'MCU Revision',
      celLv: 'Cell Level',
      tempC: 'Temperature',
      rsrp: 'RSRP',
      rsrq: 'RSRQ',
      txpwr: 'TX Power',
      band: 'Band',
      lastUpdated: 'Last Updated',
      resetNic: 'Reset NIC',
      resetNicConfirm: 'Are you sure?',
    },
    commands: {
      title: 'Commands',
      command: 'Command',
      notAvailable: 'Not available',
      state: 'State',
      commandQueue: 'Commands in Queue',
      noCommand: 'No Command in Queue',
      lastSeen: 'Last Communication',
      communication: 'Communication',
      noCommunication: 'Not available',
      lastCommand: 'Last Command',
      sendCommand: 'Send',
      notImplemented: 'Command not implemented',
      voltageOutIntervalMinites: 'Minute(s)',
      voltageOutIntervalHours: 'Hour(s)',
      voltageOutIntervalDays: 'Day(s)',
      sendToSelected: 'Enviar Para Selecionados',
      sendToAll: 'Enviar para todos',
      listOfCommands: {
        setSmiVoltageOutInterval: 'Set DIC/FIC Interval',
        setSmiQueeInterval: 'Set DRP/DRC Interval',
        setTariff: 'Set Tariff Type',
        updateDateTime: 'Update Date and Time',
        readDateTime: 'Read Date and Time',
        updatePeriod: 'Change Period',
        getRelay: 'Get Relay State',
        setRelayOff: 'Disconnect Relay',
        setRelayOn: 'Connect Relay',
        setReferenceVoltage: 'Reference Voltage',
        getReferenceVoltage: 'Get Reference Voltage',
        recoverActiveEnergy: 'Request Energies',
        getNetworkType: 'Get Network Type',
        setNetworkPublic: 'Switch to Public Network',
        setNetworkPrivate: 'Switch to Private Network',
        getTech: 'Get Technology',
        setNetworkCatm1: 'Switch to CATM1',
        setNetworkNbiot: 'Switch to NBIoT',
        getCellIdAndIP: 'Get Cell ID and IP',
        getHeartbeat: 'Recover Signal Quality',
        setEventQeeIndicator: 'Retrieve Quality Parameters',
        setStandartFrozenData: 'Set Standard Energies',
        setDisplayAuto: 'Set Auto Display',
        setDisplayManual: 'Set Manual Display',
        setDisplayAutoMicroMax: 'Set Auto Display MicroMax',
        setDisplayManualMicroMax: 'Set Manual Display MicroMax',
        recoverShortDurationAlarms: 'Retrieve Short Duration Alarms',
        getFiscalPage: 'Retrieve Fiscal Page',
        getLoadProfile: 'Retrieve Load Profile',
        getDailyBilling: 'Retrieve Daily Billing',
        updateDatetimeSmc: 'Update Date/Time (SMC)',
        updateDatetimeSmi: 'Update Date/Time (SMI)',
        instantMeasureSmc: 'Instant Read SMC',
        instantMeasureSmi: 'Instant Read',
        requestInstantMeasures: 'Request instant measurements',
        nicResetSmi: 'Reset NIC SMI',
        nicResetSmc: 'Reset NIC SMC',
        recoverMassMemorySmc: 'Recover Mass Memory (SMC)',
        recoverMassMemorySmi: 'Recover Mass Memory (SMI)',
        recoverEnergySmc: 'Retrieve Energy SMC',
        recoverEnergySmi: 'Retrieve Energy',
        recoverQeeIndicator: 'Recover QEE Indicator (Nepen)',
        requestRelayStatusAllSmc: 'Get SMC Relay Status',
        requestDoorStatus: 'Get Door Status',
        getVoltageOutLong: 'Get Long Interruption Alarm',
        getVoltageOutShort: 'Get Short Interruption Alarm',
        setStandardFrozenData: 'Set Standard Energy Template',
        getQeeTransparent: 'Get Transparency',
        readDisplayConfiguration: 'Read Display Configuration',
        setDisplayConfiguration: 'Set Display Configuration',
        voltageInterruptionMonthly: 'Read Voltage Interruption Monthly',
        drpDrcMonthly: 'Request Monthly DRP/DRC',
        drpDrcCycle: 'Request Weekly DRP/DRC',
        nicReset: 'Reset NIC',
        monitoring: 'Load Profile (Energy + Memory)',
        deviceReset: 'Device Reset',
        infoRequest: 'Read general info',
        requestConfiguration: 'Read configuration',
        getBlockSize: 'Get Block Size',
        imageTransferInitiate: 'Image Transfer Initiate',
        imageTransferData: 'Image Transfer Data',
        getFirstBlockNotTransferred: 'Get First Block Not Transferred',
        imageTransferVerify: 'Image Transfer Verify',
        imageTransferActivate: 'Image Transfer Activate',
        updateFirmware: 'Update Firmware',
        uploadFirmware: 'Upload Firmware',
        getHardwareInfo: 'Get Hardware Info',
        readNicInfo: 'Read Nic Info',
        readNicSetup: 'Read Nic Setup',
        readRelay: 'Read Relay',
        readTimestamp: 'Read Timestamp',
        readNicData: 'Read Nic Data',
        nicSetup: 'Nic Setup',
        readLdrUpper: 'Read Ldr Upper',
        readLdrBottom: 'Read Ldr Bottom',
        readLdrMin: 'Read Ldr Min',
        setLdrUpper: 'Set Ldr Upper',
        setLdrBottom: 'Set Ldr Bottom',
        setLdrMin: 'Set Ldr Min',
        readNicSerial: 'Read Nic Serial',
        readRelayWithLastSwitchOn: 'Read Relay With Last Switch On',
        readRelayWithLastSwitchOnAndOff: 'Read Relay With Last Switch On And Off',
        setBlockSize: 'Set Block Size',
        multicastGroupSetup: 'Multicast Group Setup',
        multicastClassCSession: 'Multicast Class C Session',
        multicastSetupConfirmation: 'Multicast Setup Confirmation',
        imageTransferStatus: 'Image Transfer Status',
        getFirmwareVersion: 'Get Firmware Version',
        readAlarmFakeOnOff: 'Read Alarm Fake OnOff',
        configureApplicationGroup: 'Configure Application Group',
        readALarmLastGasp: 'Read Alarm Last Gasp',
        setLastGaspVoltageLevel: 'Set Last Gasp Voltage Level',
        readAlarmVoltageMonitor: 'Read Alarm Voltage Monitor',
        setVoltageMinimalInterval: 'Set Voltage Minimal Interval',
        setAlarmFakeOnOffThreshold: 'Set Alarm Fake OnOff Threshold',
        readTemperatureValue: 'Read Temperature Value',
        readRelayWithDelay: 'Read Relay With Delay',
        deviceCreated: 'Device created',
        deviceUpdated: 'Device updated',
        scheduleCreated: 'Schedule created',
        scheduleUpdated: 'Schedule updated',
        groupCreated: 'Group created',
        groupUpdated: 'Group updated',
        setAlarmFakeOnOff: 'Alarm On/Off',
        scheduleCanceled: 'Schedule canceled',
        scheduleDeleted: 'Schedule deleted',
        deviceDeleted: 'Device deleted',
        groupDeleted: 'Group deleted',
        checkScheduleStatus: 'Check Schedule Status',
        activateSchedule: 'Activate schedule',
        deactivateSchedule: 'Deactivate schedule',
        checkScheduleExist: 'Check if schedule exists',
        readDeviceType: 'Read device type',
        writeDeviceRole: 'Write device role',
        fullScheduleCommand: 'Full schedule command',
        scheduleCreatedOnSystem: 'Schedule created (System)',
        activateScheduleOnSystem: 'Activate schedule (System)',
        checkScheduleStatusOnSystem: 'Check Schedule Status (System)',
        writeDeviceRoleOnSystem: 'Write device role (System)',
        deactivateScheduleOnSystem: 'Deactivate schedule (System)',
        checkScheduleExistOnSystem: 'Check if schedule exists (System)',
        readDeviceTypeOnSystem: 'Read device type (System)',
        setDatetimeOnSystem: 'Update Date and Time (System)',
        periodicConfiguration: 'Periodic Configuration',
        decommissioning: 'Decommissioning',
        openSession: 'Open Session with Meter',
        readMeterSerial: 'Read Meter Serial',
        importMassMeters: 'Import mass meters',
        saveConfig: 'Save configuration',
        readConfig: 'Read configuration',
        saveTime: 'Save datetime',
        timeCorrection: 'Time correction',
        storage: 'Storage',
        fuotaPause: 'Firmware update pause',
        deleteSpecialDays: 'Delete special days',
        getTotalizers: 'Read totalizers',
        getRelayStatusControl: 'Read Relay Status Control',
        setRelayStatusControl: 'Set Relay Status Control',
        getIntegrationInstantaneousReadings: 'Read instantaneous values',
        getVoltageOutLongShort: 'Get Voltage Out Long and short Alarm',
        relayStatusOrca: 'Recover orca relay state',
        getQeeOnDemand: 'Request quality parameters on demand',
        getQeeHistoricalData: 'Request historical data of quality parameters',
        recoverFragmentedPacket: 'Recover fragmented data',
        drpDrcEventLog: 'DRP and DRC Event Log',
        readTariffPeriods: 'Get Tariff Reading',
        smartFuseAlarmAck: 'Alarm Ack',
        getCollectiveCutStatus: 'Get Collective Cut Status',
        sendRollback: 'Send RollBack',
        disableCollectiveCut: 'Enable Collective Cut',
        enableCollectiveCut: 'Disable Collective Cut',
        relayOnAllMeterSmc: 'Relog All Clients',
        getStatus: 'Get Relay Status',
        activate: 'Activate Relay',
        disable: 'Disable Relay',
        requestMeters: 'Request Meters',
        getTariffReading: 'Get Tariff Type',
      },
      placeholders: {
        selectCommand: 'Select a command',
        sendToSelected: 'Send to Selected',
      },
      messagesSuccess: {
        success: 'Success',
        commandSent: 'Command sent successfully!',
        commandExecuted: 'Command executed successfully!',
      },
      messagesErrors: {
        error: 'Error',
        commandSent: 'Error sending command',
        commandExecuted: 'Error executing command',
        errorVerifyCommandCondition: 'Error verifying command condition',
        errorFilterCommands: 'Error filtering available commands',
        commandExecutedTryAgain: 'It was not possible to execute the command.\nTry again later.',
        commandExecutedPartial: 'The commands were executed partially.',
        commandExecutedPartialNotExecute: ' did not execute.',
      },
    },
    dataExtraction: {
      title: 'Data extraction',
      cardTitle: 'Bulk data extraction',
      dateRangePlaceholder: 'Select the period',
      dateRangeTooltip: 'Enter a period of no more than 30 days',
      selectPlaceholder: 'Export type',
      consult: 'Search',
      serialLabel: 'Serial',
      serialsPlaceholder:
        'Enter one serial per line, or separate them by comma, space, or semicolon. This field is optional. You can adjust which information you want to extract according to the selected filters. Only export type and date range are required; serial and client are optional.',
      serialsHint: 'Total valid serials: {total}',
      previewTitle: 'Records preview',
      tableEmpty: 'No records found',
      noResults: 'No records were found for the selected filters.',
      previewError: 'Error while loading extraction preview.',
      columnsError: 'Error while loading the columns available for this export type.',
      maxRangeExceededError: 'The selected range must be no more than 30 days.',
      maxRangeFutureDateError: 'The end date cannot be later than today.',
      filter: {
        typeLabel: 'Export type',
        periodLabel: 'Period',
        clientLabel: 'Client',
        clientPlaceholder: 'Select a client',
        columnsLabel: 'Columns',
        columnsPlaceholder: 'All columns with data',
        columnsSelected: '{0} columns selected',
        columnsHint:
          'The list only shows columns that have data in the period you searched. With no selection, the download includes all of them.',
        columnsEmptyHint: 'Search the data to choose among the columns that come back filled.',
        validationMessage:
          'Specify the export type and the period. Serial and client are optional.',
      },
      types: {
        massMemory: 'Mass memory',
        energy: 'Energy',
        alarms: 'Alarms',
        latestQualityParameters: 'Latest quality parameters',
        qualityDicFic: 'Quality parameters - DIC/FIC',
        qualityDrpDrc: 'Quality parameters - DRP/DRC',
      },
      clearFiltersDialog: {
        title: 'Clear filters',
        message: 'Do you really want to clear the filters and the data preview?',
        cancel: 'Cancel',
        confirm: 'Confirm',
      },
      summary: {
        warning: 'Warning',
        info: 'Information',
        success: 'Success',
        error: 'Error',
      },
    },
    firmware: {
      title: 'Firmware Version',
      version: 'Firmware Version',
      registerFirmware: 'New Version',
      editFirmware: 'Edit Firmware',
      registerFirmwareFile: 'Import Firmwares Through File',
      editFirmwareFile: 'Edit Firmwares Through File',

      success: {
        getFirmwares: 'Firmwares searched successfully',
      },
      errors: {
        getFirmwares: 'Error searching firmwares',
      },
    },
    keys: {
      title: 'Keys',
      importKeys: 'Import Keys',
      editKeysInBulk: 'Edit Keys in Bulk',
      registerKeysInBulk: 'Register Keys in Bulk',
      periodPlaceholder: 'Select the period',
      success: {
        getKeys: 'Keys searched successfully',
        createKey: 'Key created successfully',
        updateKey: 'Key updated successfully',
        addMassKeys: 'Keys registration request sent',
      },
      errors: {
        getKeys: 'Error searching keys',
        createKey: 'Error creating key',
        updateKey: 'Error updating key',
        addMassKeys: 'Error sending command',
        convertKey: 'Error converting key to hexadecimal',
      },
      toasts: {
        importSuccess: 'Import completed successfully',
        importSuccessDetail: 'All keys have been imported successfully',
        importPartial: 'Import partially completed',
        importPartialDetail: 'key imported successfully, | keys imported successfully,',
        importError: 'Error importing keys',
        editSuccess: 'Edit completed successfully',
        editSuccessDetail: 'All keys have been edited successfully',
        editPartial: 'Edit partially completed',
        editPartialDetail: 'key edited successfully, | keys edited successfully,',
        editError: 'Error editing keys',
        failed: 'failed | failed',
      },
    },
    tags: {
      title: 'Tags',
      newTag: 'New Tag',
      success: {
        getTags: 'Tags searched successfully',
        createTag: 'Tag created successfully',
        updateTag: 'Tag updated successfully',
        deleteTag: 'Tag deleted successfully',
      },
      errors: {
        getTags: 'Error searching tags',
        createTag: 'Error creating tag',
        updateTag: 'Error updating tag',
        deleteTag: 'Error deleting tag',
      },
    },
    clients: {
      client: 'Client',
      clients: 'Clients',
      clientDetails: 'Client Details',
      editClient: 'Edit Client',
      fullName: 'Full Name',
      location: 'Location',
      updatedAt: 'Updated At',
      metersTableTitle: 'Meters of Client',
      addMeters: 'Add Meters',
      removeMeters: 'Remove Meters',
      removeMetersDescription:
        'Are you sure you want to remove the selected meters from this client?',
      confirmRemoveMeters: 'Yes, remove',
      weights: 'Weights',
      prefixUf: 'UF Prefix',
      bulkLink: 'Bulk link',
      manageLinks: 'Manage links',
      linkedUsers: 'Linked users',
      unlinkSelected: 'Unlink selected',
      associateClients: 'Associate clients',
      addToTenant: 'Add user',
      removeFromTenant: 'Remove from client',
      userAdded: 'User added to client.',
      userRemoved: 'User removed from client.',
      newUser: 'New User',
      editUser: 'Edit user',
      bulkLinkHeader: 'Bulk link user to clients',
      manageLinkHeader: 'Manage user links',
      unlinkConfirm: 'Unlink Selected',
      selectUser: 'Select a user',
      selectClients: 'Select clients',
      link: 'Link',
      errorLoadingClients: 'Error loading clients',
      deleteClients: 'Delete clients',
      noClientSelected: 'No client selected',
      linksTitle: 'Links',
      clientsLinked: '{count} client(s) linked.',
      clientsLinkFailed: '{count} failed.',
      errorLinkingClients: 'Error linking clients.',
      unlinked: 'Unlinked.',
      countUnlinked: '{count} unlinked.',
      errorUnlinking: 'Error unlinking.',
      goToBulkLink: 'Go to bulk link',
      goToManageLinks: 'Go to manage links',
      userCreated: 'User created successfully.',
      errorCreatingUser: 'Error creating user',
    },
    users: {
      title: 'Users',
      user: 'User',
      newUser: 'New User',
      editUser: 'Edit user',
      yourAccountTab: 'Your Account',
      allUsersTab: 'All Users',
      lastUpdateLabel: 'Last Update',
      confirmDelete: 'Confirm user deletion',
      userEdited: 'User edited successfully.',
      userAddedToClient: 'User added to client.',
      errorAddingUser: 'Error adding user',
      userUnlocked: 'User unlocked successfully.',
      errorFetchingUsers: 'Error fetching users',
      noUserSelected: 'No user selected',
      deleteUsers: 'Delete users',
      removeUsers: 'Remove users',
      countRemoved: '{count} removed from client.',
      countFailed: '{count} failed.',
      usernameLabel: 'Username',
      adUsernameLabel: 'AD username',
      usernamePlaceholder: 'Enter username',
      grantAccess: 'Grant Access',
      createUser: 'Create',
      userTypeLabel: 'Authentication Type',
      userTypeNormal: 'Normal',
      userTypeLdap: 'LDAP',
      userExists: 'User found in the system.',
      userNotFound: 'User not found. Fill in the details to create.',
      nameLabel: 'Name',
      emailLabel: 'Email',
      emailPlaceholder: 'Enter email',
      passwordLabel: 'Password',
      confirmPasswordLabel: 'Confirm password',
      descriptionLabel: 'Description',
      roleLabel: 'Role',
      receiveEmailsLabel: 'Receive emails',
      licenseAccessLabel: 'License access',
      licenseAccessHint: 'Allows viewing the license page and removing or restoring points. Enabling the license and changing the total remain NEPEN only.',
      selectRolePlaceholder: 'Select a role',
      optionalPlaceholder: 'Optional',
      passwordOptionalPlaceholder: 'Leave blank to keep the current password',
      updateButton: 'Update',
      invalidEmail: 'Invalid email.',
      nameMinLength: 'Name must contain at least 4 letters.',
      passwordRequirements:
        'Password must contain at least 8 characters, one uppercase and one lowercase letter.',
      passwordMismatch: 'Passwords do not match.',
      clientLabel: 'Client links',
      noClientPlaceholder: 'No link',
      ldapOnly: 'LDAP only',
      statusHeader: 'Status',
      blocked: 'Blocked',
      active: 'Active',
      loginTypeHeader: 'Login type',
      updated: 'User updated successfully.',
      errorUpdatingUser: 'Error updating user.',
      noClients: 'No clients linked.',
      addClientPlaceholder: 'Add clients...',
    },
    balance: {
      title: 'Balance',
      balanceCalculation: 'Balance Calculation',
      balanceSettings: 'Balance Settings',
      publicLighting: 'Public Lighting - IP (kWh)',
      search: 'Search',
      balanceEnergy: 'Balance Energy',
      balanceEnergyChart: 'Balance Energy Chart',
      data: 'Data',
      meterTrafo: 'Transformer Meter',
      energyRequired: 'Energy Required (kWh)',
      energyConsumed: 'Energy Consumed (kWh)',
      energyPublicLightingLabel: 'Public Lighting',
      loss: 'Loss (kWh)',
      lossPercentage: 'Loss %',
      energyPublicLighting: 'Public Lighting Energy (kWh)',
      readingDateTime: 'Reading Date',
      initialReadingDateTime: 'Initial Reading Date',
      finalReadingDateTime: 'Final Reading Date',
      energyInjectedConsumers: 'Energy Injected to Consumers (kWh)',
      energyReverseTransformer: 'Transformer Reverse Energy (kWh)',
      empty: 'Empty for now...',
      results: 'Results',
      transformerName: 'Transformer Name',
      areaName: 'Area Name',
      regionName: 'Region Name',
      placeholders: {
        publicLighting: 'Enter the value',
      },
      errors: {
        loadBalance: 'Error searching balance',
      },
    },
    transformers: {
      title: 'Transformers',
      transformer: 'Transformer',
      startDate: 'Initial Date',
      endDate: 'End Date',
      placeholders: {
        loading: 'Loading...',
        select: 'Select Transformer',
        selectDate: 'Select the date',
      },
      errors: {
        title: 'Error',
        loadTransformers: 'Error loading transformers',
      },
    },
    veeGroups: {
      pageTitle: 'VEE Configuration - VEE Groups',
      title: 'VEE Groups',
      tableTitle: 'VEE Groups',
      actions: {
        newGroup: 'New VEE Group',
        refresh: 'Refresh',
        retry: 'Try again',
      },
      columns: {
        name: 'Name',
        purpose: 'Purpose',
        scope: 'Scope',
        mode: 'Mode',
        period: 'Validity',
        frequency: 'Frequency',
        priority: 'Priority',
        rules: 'Rules',
        status: 'Status',
        actions: 'Actions',
      },
      filters: {
        searchLabel: 'Search by name',
        searchPlaceholder: 'Search by name',
        purpose: 'Purpose',
        status: 'Status',
        scope: 'Data scope',
        mode: 'Operational mode',
        referenceDate: 'Reference date',
        referenceDatePlaceholder: 'Select the reference date',
        selectOption: 'Select',
      },
      status: {
        active: 'Active',
        inactive: 'Inactive',
      },
      scopes: {
        massMemory: 'Mass Memory',
        totalizers: 'Totalizers',
        both: 'Hybrid',
      },
      modes: {
        gate: 'Gate',
        consultative: 'Consultative',
      },
      purpose: {
        billing: 'Billing Validation',
        monitoring: 'Operational Monitoring',
      },
      sourceRole: {
        initialLoad: 'Initial Load',
        manualOverride: 'Manual Override',
        estimationValidation: 'Estimation Validation',
        billingValidation: 'Billing Validation',
      },
      retentionLevel: {
        reading: 'Reading',
        channel: 'Channel',
        cycle: 'Cycle',
        meter: 'Meter',
      },
      period: {
        openEnded: 'Open',
      },
      loading: {
        list: 'Loading VEE groups...',
        action: 'Processing...',
      },
      empty: {
        title: 'No VEE groups found',
        description: 'Adjust the filters or create a new VEE group.',
      },
      pagination: {
        showing: 'Showing {first} to {last} of {total} groups',
        pageSize: 'Items per page',
      },
      permissions: {
        title: 'Access denied',
        view: 'You do not have permission to view VEE groups.',
        create: 'You do not have permission to create VEE groups.',
        edit: 'You do not have permission to edit VEE groups.',
        deactivate: 'You do not have permission to deactivate VEE groups.',
        configure: 'You do not have permission to access the VEE group configuration.',
        updateFallback: 'You do not have permission to update the fallback configuration.',
        updateBatchApprovalPolicy:
          'You do not have permission to update the batch approval policy.',
      },
      details: {
        loadingTitle: 'Loading VEE Group...',
        breadcrumbTitle: 'VEE Group Details',
        badge: 'Operation/consult',
        sections: {
          configuration: 'VEE Group Configuration',
          fallback: 'Estimation Configuration (Fallback)',
          batchApproval: 'Batch Approval',
          pipeline: 'Pipeline',
          readingHistory: 'Reading History',
          groupMeters: 'Group Meters',
          pendingEstimates: 'Pending Estimation Proposals',
        },
        labels: {
          historicalWindow: 'Historical Window',
        },
        fallbackSettings: {
          caption:
            'Reorder fallback methods and adjust the historical window using the current contract.',
          enableZeroFillLabel: 'Enable zero fill (ZeroFill)',
          savingTitle: 'Saving...',
          saving: 'Saving fallback settings...',
          successTitle: 'Success',
          success: 'Fallback settings updated successfully',
          errorTitle: 'Error',
          error: 'Error updating fallback settings',
        },
        batchApprovalPolicy: {
          caption: 'Define the limits that authorize batch approval of estimates for this group.',
          allowLabel: 'Allows batch approval',
          maxGapDurationMinutesLabel: 'Maximum gap duration (minutes)',
          maxGapDurationMinutesPlaceholder: 'Enter the maximum gap duration',
          maxDeviationPercentLabel: 'Maximum deviation (%)',
          maxDeviationPercentPlaceholder: 'Enter the maximum allowed deviation',
          maxProposalsPerBatchLabel: 'Maximum quantity per batch',
          maxProposalsPerBatchPlaceholder: 'Enter the maximum quantity per batch',
          requiredFieldsHint: 'All three limits are required when batch approval is enabled.',
          disabledHint: 'No limit configured. Batch approval is blocked for this group.',
          loadErrorTitle: 'Error',
          loadError: 'Error loading the batch approval policy',
          successTitle: 'Success',
          success: 'Batch approval policy updated successfully',
          errorTitle: 'Error',
          error: 'Error updating the batch approval policy',
          validation: {
            fieldsRequired: 'Enter all three limits to enable batch approval.',
            gapMustBePositive: 'The maximum gap duration must be greater than zero.',
            deviationMustBeNonNegative: 'The maximum deviation cannot be negative.',
            maxProposalsMustBePositive: 'The maximum quantity per batch must be greater than zero.',
          },
        },
        actions: {
          retry: 'Try again',
          backToList: 'Back to VEE Groups',
          configureGroup: 'Configure group',
          approveSelected: 'Approve selected',
          reject: 'Reject',
        },
        empty: {
          fallback: 'No fallback configured.',
        },
        summary: {
          notAvailable: '-',
          caption: 'Operational summary with real data already available in the group details.',
          labels: {
            group: 'Group',
            scope: 'Type/Scope',
            objective: 'Objective',
            sourceRole: 'Source Role',
            mode: 'Mode',
            lastExecution: 'Last execution',
            priority: 'Priority',
            frequency: 'Frequency',
            period: 'Period',
            status: 'Status',
          },
        },
        configuration: {
          caption: 'Scope, validity, mode, blocking policy, and group resolution level.',
          labels: {
            scope: 'Group scope',
            validity: 'Validity',
            mode: 'Gate/Consultative mode',
            blockingPolicy: 'Blocking policy',
            resolutionLevel: 'Hierarchical resolution level',
            frequency: 'Frequency',
          },
          blockingPolicies: {
            none: 'Not applicable',
            blockOnOpenException: 'Block on open exception',
          },
        },
        errors: {
          title: 'Error loading VEE Group',
          load: 'Error loading VEE Group',
          groupNotFound: 'Group not found',
        },
        pipeline: {
          caption:
            'Local visual pipeline preview while the native rule library and the real flow are not implemented yet.',
          columns: {
            name: 'Name',
            lastExecution: 'Last execution',
            actions: 'Actions',
          },
        },
        readingHistory: {
          real: 'Real readings',
          approvedEstimated: 'Approved estimates',
          proposed: 'Pending proposals',
          subtitle: 'Daily count by origin',
          axisLabel: 'Count',
          loadError: 'Could not load the group reading history.',
          maxPeriodError: 'The reading history period cannot exceed {days} days.',
        },
        meters: {
          loadError: 'Could not load the group meters.',
        },
        pendingEstimates: {
          pendingStatus: 'Pending',
          empty: 'No pending proposals for this group.',
          loadError: 'Could not load the pending estimation proposals.',
          rejectError: 'Could not reject the selected proposal.',
          labels: {
            method: 'Method',
            proposedValue: 'Proposed value',
          },
          columns: {
            status: 'Status',
          },
        },
      },
      form: {
        createTitle: 'Create VEE Group',
        editTitle: 'Edit VEE Group',
        fields: {
          name: 'Group name',
          purposeCode: 'Purpose',
          sourceRole: 'Source role',
          dataScope: 'Data scope',
          period: 'Period',
          effectiveFrom: 'Validity start',
          effectiveTo: 'Validity end',
          fallback: 'Fallback',
          historicalWindow: 'Historical window',
          blockingPolicyCode: 'Billing trigger',
          executionFrequency: 'Execution frequency',
          operationalMode: 'Mode',
          priority: 'Priority (0-10)',
          validatedReadingsThreshold: 'Validated readings target (%)',
        },
        placeholders: {
          name: 'Group name',
          effectiveFrom: 'Select',
          effectiveTo: 'Select',
          blockingPolicyCode: 'Billing trigger',
          select: 'Select',
          validatedReadingsThreshold: 'Enter the target',
        },
        frequency: {
          immediate: 'On Demand',
          dailyDigest: 'Daily Digest',
          dailyDigestDelayed: 'Daily Digest (5-day delay)',
          weeklyDigest: 'Weekly Digest',
        },
        fallback: {
          interpolation: 'Interpolation',
          proxyDay: 'Proxy Day',
          loadProfile: 'Load Profile',
          scalarCalculation: 'Scalar Calculation',
          transformerNeighborAverage: 'Transformer neighbor average',
          moveUp: 'Move fallback up',
          moveDown: 'Move fallback down',
          reorderHint: 'Drag the methods to define the execution order.',
          dragHandle: 'Drag to reorder (or use the arrow keys)',
          sevenDays: '7 days',
          fifteenDays: '15 days',
          oneMonth: '1 month',
        },
        priorityScale: {
          low: 'Low',
          medium: 'Medium',
          high: 'High',
        },
        actions: {
          cancel: 'Cancel',
          save: 'Save',
          saving: 'Saving',
        },
        messages: {
          saveNotAvailableTitle: 'Flow in progress',
          saveNotAvailableDetail:
            'Saving the VEE Group will be implemented in the next micro-activities.',
        },
        validation: {
          title: 'Warning',
          summary: 'Review the highlighted fields before saving',
          required: 'Required field',
          nameRequired: 'Group name is required',
          purposeRequired: 'Purpose is required',
          dataScopeRequired: 'Data scope is required',
          effectiveFromRequired: 'Start date is required',
          invalidPeriod: 'End date must be greater than or equal to the start date',
          blockingPolicyCodeRequired: 'Billing trigger is required in Gate mode',
          executionFrequencyRequired: 'Execution frequency is required',
          operationalModeRequired: 'Mode is required',
          priorityRange: 'Priority must be between 0 and 10',
          validatedReadingsThresholdRange: 'The target must be greater than 0 and at most 100',
        },
      },
      errors: {
        title: 'Error',
        loadList: 'Error loading VEE groups',
        loadDetails: 'Could not load the latest VEE Group data.',
        create: 'Error creating VEE Group',
        update: 'Error updating VEE Group',
        deactivate: 'Error deleting VEE Group',
        unauthorized: 'Your session has expired. Sign in again to continue.',
        forbidden: 'You do not have permission to perform this action.',
        notFound: 'The requested VEE Group was not found.',
        validation: 'Review the provided data and try again.',
        unexpected: 'An unexpected error occurred. Try again.',
      },
      success: {
        title: 'Success',
        create: 'VEE Group created successfully',
        update: 'VEE Group updated successfully',
        deactivate: 'VEE Group deleted successfully',
      },
      deactivateDialog: {
        title: 'Confirm deletion',
        description: 'Do you really want to delete this VEE Group?',
        confirm: 'Delete',
      },
      placeholderDialog: {
        title: 'Flow in progress',
        close: 'Close',
        messages: {
          view: 'The VEE Group details view will be implemented in the next micro-activities.',
          inactivate:
            'The VEE Group deactivation flow will be implemented in the next micro-activities.',
        },
      },
    },
    veeConfiguration: {
      groupDetails: {
        loadingTitle: 'Loading configuration...',
        breadcrumbTitle: 'VEE Group Configuration',
        pageTitlePrefix: 'VEE Configuration',
        actions: {
          backToDetails: 'Back to Group Details',
          retry: 'Try again',
        },
        sections: {
          identification: 'Scope, validity, mode, blocking, hierarchical level and frequency',
          pipeline: 'Rule Pipeline',
          fallback: 'Estimation - Fallback and Historical Window',
        },
        labels: {
          scope: 'Scope',
          scopeCardTitle: 'Group configuration - {name}',
          validity: 'Validity',
          mode: 'Mode',
          blockingPolicy: 'Blocking policy',
          resolutionLevel: 'Hierarchical resolution level',
          frequency: 'Frequency',
        },
        blockingPolicyOptions: {
          perMeter: 'Per whole meter',
          perReadingPeriod: 'Per reading period',
          alertOnly: 'Alert only',
        },
        pipeline: {
          caption:
            'Local preview of the pipeline while the native rule library (activity 008) is not yet available.',
          loading: 'Loading pipeline rules...',
          savingOrder: 'Saving pipeline order...',
          empty: {
            pipeline: 'Empty for now...',
            availableRules: 'No active rules available to add.',
          },
          messages: {
            activeOnly: 'Only active rules can be added to the pipeline.',
            inactiveConfigured:
              'The rule is inactive in the catalog but remains visible because it is already part of this pipeline.',
            orderPreserved: 'The rule order will be preserved when saving.',
          },
          columns: {
            order: 'Order',
            rule: 'Rule',
            severity: 'Severity',
            action: 'Action',
            validity: 'Validity',
            actions: 'Actions',
          },
          severities: {
            info: 'Informational',
            issue: 'Alert',
            terminate: 'Critical',
          },
          actions: {
            alert: 'Alert only',
            hold: 'Hold',
            blockBilling: 'Block billing',
            stopPipeline: 'Stop pipeline',
          },
          crud: {
            create: 'Create Pipeline',
            edit: 'Edit',
            delete: 'Delete',
          },
          form: {
            createTitle: 'Create Pipeline Rule',
            editTitle: 'Edit Pipeline Rule',
            fields: {
              rule: 'Rule',
              severity: 'Severity',
              action: 'Action',
              effectiveFrom: 'Validity start',
              effectiveTo: 'Validity end',
            },
            placeholders: {
              select: 'Select',
              effectiveFrom: 'Validity start date',
              effectiveTo: 'Validity end date',
            },
            validation: {
              ruleRequired: 'Select a rule for the pipeline',
              effectiveFromRequired: 'Validity start is required',
              invalidPeriod: 'Validity end cannot be earlier than validity start',
            },
          },
          deleteDialog: {
            title: 'Remove pipeline rule',
            description:
              'The rule will be removed from the active pipeline. Its configuration and parameter history are preserved and become available again if the rule is re-added.',
            confirm: 'Remove',
          },
          toast: {
            created: 'Pipeline rule created successfully',
            updated: 'Pipeline rule updated successfully',
            deleted: 'Pipeline rule deleted successfully',
          },
          errors: {
            loadRules: 'Unable to load the available rules.',
            duplicateRule: 'This rule has already been added to the pipeline.',
            saveOrder: 'Unable to save the pipeline order.',
          },
        },
        errors: {
          title: 'Error loading configuration',
          load: 'Error loading the group configuration',
          groupNotFound: 'Group not found',
        },
      },
      rulesLibrary: {
        pageTitle: 'VEE Configuration - Rule Library',
        breadcrumbTitle: 'Rule Library',
        tableTitle: 'Rule Library',
        description: 'Configurable catalog of native VEE rules.',
        columns: {
          name: 'Rule',
          description: 'Description',
          scope: 'Scope',
          classification: 'Classification',
          dataType: 'Data type',
          defaultSeverity: 'Default severity',
          defaultAction: 'Default operational action',
          cost: 'Cost',
          status: 'Status',
          actions: 'Action',
        },
        actions: {
          create: 'Create rule',
          thresholds: 'Thresholds',
          thresholdsTooltip: 'View rule thresholds',
          viewTooltip: 'View rule',
          editTooltip: 'Edit rule',
          edit: 'Edit',
          activate: 'Activate',
          deactivate: 'Deactivate',
          activateTooltip: 'Activate rule',
          deactivateTooltip: 'Deactivate rule',
          refresh: 'Refresh',
          retry: 'Try again',
          clearFilters: 'Clear filters',
        },
        filters: {
          searchLabel: 'Search by name or description',
          searchPlaceholder: 'Quick search',
          scope: 'Scope',
          dataType: 'Data type',
          cost: 'Cost',
          status: 'Status',
          severity: 'Severity',
          selectOption: 'Select',
        },
        status: {
          active: 'Active',
          inactive: 'Inactive',
        },
        scopes: {
          massMemory: 'Load Profile',
          totalizers: 'Totalizers',
          both: 'Both',
        },
        dataTypes: {
          percentage: 'Percentage',
          count: 'Count',
          binary: 'Binary',
          numeric: 'Numeric',
        },
        costs: {
          low: 'Low',
          medium: 'Medium',
          high: 'High',
        },
        loading: {
          list: 'Loading rule library...',
          action: 'Updating rule...',
        },
        empty: {
          title: 'No rules found.',
        },
        pagination: {
          pageSize: 'Items per page',
        },
        permissions: {
          title: 'Access denied',
          view: 'You do not have permission to view the rule library.',
          manage: 'You do not have permission to modify the rule library.',
          configureThresholds: 'You do not have permission to configure rule parameters.',
        },
        form: {
          createTitle: 'Create Rule',
          editTitle: 'Edit Rule',
          detailsTitle: 'Rule Details',
          fields: {
            name: 'Rule',
            description: 'Description',
            scope: 'Scope',
            ruleTypeSelection: 'Rule Type',
            ruleType: 'Rule type',
            classification: 'Classification',
            dataType: 'Data type',
            defaultSeverity: 'Default severity',
            defaultAction: 'Default operational action',
            cost: 'Cost',
            status: 'Status',
            parametersMetadata: 'Configurable parameters',
          },
          legacyTypeNotice:
            'This record has a legacy technical type without a handler recognized by the system. You can save the other changes without selecting a new type, or choose a valid type above to fix it.',
          parametersMetadata: {
            key: 'Key',
            keyPlaceholder: 'Parameter technical key',
            label: 'Label',
            labelPlaceholder: 'Label shown to the user',
            valueType: 'Value type',
            required: 'Required',
            min: 'Minimum',
            minPlaceholder: 'Minimum allowed value',
            max: 'Maximum',
            maxPlaceholder: 'Maximum allowed value',
            add: 'Add parameter',
            addTooltip: 'Add a new parameter',
            remove: 'Remove',
            removeTooltip: 'Remove parameter',
            removeAll: 'Remove parameters',
            removeAllTooltip: 'Remove all added parameters',
            maxReached: 'Maximum limit of {max} parameters reached.',
            itemLabel: 'Parameter {index}',
            empty: 'No configurable parameter added.',
            valueTypes: {
              string: 'Text',
              integer: 'Whole number',
              decimal: 'Decimal number',
              boolean: 'True or false',
              json: 'Structured (JSON)',
              dateTime: 'Date and time',
            },
          },
          placeholders: {
            name: 'Rule name',
            description: 'Short rule description',
            select: 'Select',
            selectScopeFirst: 'Select the scope first',
          },
          validation: {
            nameRequired: 'Enter the rule name',
            ruleTypeRequired: 'Select the rule classification',
            ruleTypeSelectionRequired: 'Select the rule type',
            scopeRequired: 'Select the scope',
            dataTypeRequired: 'Select the data type',
            costRequired: 'Select the operational cost',
            severityRequired: 'Select the default severity',
            actionRequired: 'Select the default operational action',
            parameterKeyRequired: 'Enter the parameter key',
            parameterLabelRequired: 'Enter the parameter label',
            parameterRangeInvalid: 'Minimum cannot be greater than maximum',
          },
          ruleTypeOptions: {
            consistency: 'Consistency',
            continuity: 'Continuity',
            comparison: 'Comparison',
            threshold: 'Threshold',
            calibration: 'Calibration',
            custom: 'Custom',
            correction: 'Correction',
          },
          actions: {
            cancel: 'Cancel',
            close: 'Close',
            save: 'Save',
            saving: 'Saving...',
          },
        },
        statusDialog: {
          activateTitle: 'Activate Rule',
          activateDescription: 'Do you want to activate the {rule} rule?',
          deactivateTitle: 'Deactivate Rule',
          deactivateDescription:
            'Do you want to deactivate the {rule} rule? Existing configurations will be preserved.',
          confirmActivate: 'Activate',
          confirmDeactivate: 'Deactivate',
          cancel: 'Cancel',
        },
        toast: {
          created: 'Rule created successfully',
          updated: 'Rule updated successfully',
          activated: 'Rule activated successfully',
          deactivated: 'Rule deactivated successfully',
          ruleTypeClearedByScopeChange:
            'The selected rule type is not compatible with the new scope and was cleared. Select a valid type.',
        },
        errors: {
          title: 'Error loading rule library',
          load: 'Unable to load the rule library.',
          unauthorized: 'Your session has expired. Sign in again to continue.',
          forbidden: 'You do not have permission to access this resource.',
          notFound: 'The requested rule was not found.',
          validation: 'Review the filters or provided data.',
          unprocessable: 'Unable to process the provided data.',
          activate: 'Unable to activate the rule.',
          deactivate: 'Unable to deactivate the rule.',
          create: 'Unable to create the rule.',
          update: 'Unable to update the rule.',
          unexpected: 'An unexpected error occurred. Try again.',
        },
      },
      ruleThresholds: {
        dialogTitle: 'Rule Thresholds',
        ruleLabel: 'Rule: {rule}',
        subtitle: 'Configure rule parameters for the selected VEE Group.',
        preview: {
          catalogOnlyNotice:
            'Read-only view of catalog parameters. Effective configuration is done in the group pipeline.',
        },
        sections: {
          parameters: 'Parameters',
          currentConfiguration: 'Current configuration',
          futureConfiguration: 'Future configuration',
          validity: 'Validity',
          audit: 'Audit',
        },
        labels: {
          group: 'VEE Group',
          rule: 'Rule',
          parameter: 'Parameter',
          value: 'Value',
          unit: 'Unit',
          minimum: 'Minimum',
          maximum: 'Maximum',
          upperLimit: 'Upper limit (%)',
          lowerLimit: 'Lower limit (%)',
          basis: 'Calculation basis',
          seasonality: 'Seasonality',
          severity: 'Severity',
          action: 'Operational action',
          cost: 'Operational cost',
          billing: 'Billing impact',
          historicalWindow: 'Historical window',
          effectiveFrom: 'Validity start',
          effectiveTo: 'Validity end',
          currentConfiguration: 'Current configuration',
          futureConfiguration: 'Future configuration',
          nextEligibleExecution: 'Next eligible execution',
          changedBy: 'Changed by',
          changedAt: 'Changed at',
          createdBy: 'Created by',
          createdAt: 'Created at',
          previousValue: 'Previous value',
          newValue: 'New value',
          changeReason: 'Change reason',
        },
        basisOptions: {
          absolute: 'Absolute',
          historical: 'Historical-based',
        },
        parameterLabels: {
          measurementKey: 'Evaluated measurement',
          basis: 'Calculation basis',
          lowerLimitPercent: 'Lower limit (%)',
          upperLimitPercent: 'Upper limit (%)',
        },
        parameterValues: {
          bothDirections: 'Above and below',
        },
        seasonalityOptions: {
          none: 'No seasonality',
          daily: 'Daily',
          weekly: 'Weekly',
          monthly: 'Monthly',
          annual: 'Annual',
        },
        billingOptions: {
          none: 'No billing impact',
          hold: 'Hold for review',
          block: 'Block billing',
        },
        placeholders: {
          selectRule: 'Select the rule',
          select: 'Select',
          enterValue: 'Enter the value',
          enterValueFor: 'Enter {label}',
          effectiveFrom: 'Select the validity start',
          effectiveTo: 'Select the validity end',
          changeReason: 'Describe the reason for the change',
        },
        validation: {
          required: 'Required field',
          invalidType: 'Enter a value compatible with the parameter type.',
          belowMinimum: 'The value must be greater than or equal to {minimum}.',
          aboveMaximum: 'The value must be less than or equal to {maximum}.',
          lowerGreaterThanUpper: 'The lower limit cannot be greater than the upper limit',
          invalidPeriod: 'The validity start date cannot be earlier than today.',
          effectiveFromRequired: 'The validity start is required.',
          noChanges: 'No changes were provided.',
        },
        help: {
          minimum: 'Lowest accepted value for this parameter.',
          maximum: 'Highest accepted value for this parameter.',
          severity: 'Defines the severity of the exception generated when the rule is violated.',
          action: 'Defines the operational action applied when the rule identifies an exception.',
          cost: 'Indicates the estimated operational cost of processing this rule.',
          billing:
            'Blocking billing prevents billing from proceeding until the exception is handled.',
          validity:
            'Validity defines when the configuration may be used without changing previous executions.',
          historicalWindow: 'Defines the previous data period used by the rule as its reference.',
          seasonality:
            'Defines the seasonal cycle considered when comparing against available history.',
          currentConfiguration: 'Configuration in effect at the time of the query.',
          futureConfiguration: 'Configuration scheduled for a future validity period.',
          nextEligibleExecution:
            'The change will only be considered in the next eligible execution within its validity.',
        },
        loading: {
          load: 'Loading rule parameters...',
          save: 'Saving configuration...',
        },
        empty: {
          parameters: 'This rule has no configurable parameters.',
          currentConfiguration: 'No current configuration found.',
          futureConfiguration: 'No future configuration scheduled.',
          audit: 'No change history found.',
        },
        messages: {
          effectiveNextExecution:
            'The saved configuration will only take effect in the next eligible execution.',
          noRetroactivity: 'The change does not modify previous executions or results.',
          inactiveRule:
            'This rule is inactive. Its existing configuration remains available for viewing.',
          missingContext:
            'Unable to identify the pipeline rule to configure thresholds. Save the rule in the group pipeline before configuring its parameters.',
        },
        audit: {
          created: 'Configuration created',
          updated: 'Configuration updated',
          scheduled: 'New validity scheduled',
          unknownUser: 'User not provided',
        },
        permissions: {
          title: 'Access denied',
          view: 'You do not have permission to view this rule’s parameters.',
          edit: 'You do not have permission to change this rule’s parameters.',
        },
        actions: {
          cancel: 'Cancel',
          close: 'Close',
          save: 'Save',
          saving: 'Saving...',
          refresh: 'Refresh',
          retry: 'Try again',
        },
        toast: {
          saved: 'Configuration saved successfully',
          updated: 'Configuration updated successfully',
        },
        errors: {
          title: 'Error loading parameters',
          load: 'Unable to load the rule parameters.',
          unauthorized: 'Your session has expired. Sign in again to continue.',
          forbidden: 'You do not have permission to access this resource.',
          notFound: 'The requested configuration was not found.',
          validation: 'Review the provided parameters.',
          unprocessable: 'Unable to process the provided parameters.',
          save: 'Unable to save the configuration.',
          unexpected: 'An unexpected error occurred. Try again.',
        },
      },
      billingCalendar: {
        pageTitle: 'VEE Configuration - Billing Calendar',
        breadcrumbTitle: 'Billing Calendar',
        tableTitle: 'Billing Calendar',
        columns: {
          group: 'Group',
          readingDay: 'Reading day',
          closingDay: 'Closing date',
          triggerDMinusN: 'D-N trigger',
          status: 'Status',
          actions: 'Actions',
        },
        statusOptions: {
          ready: 'Ready',
          pending: 'Pending',
          blocked: 'Blocked',
          noData: 'No data',
        },
        labels: {
          group: 'Group',
          readingDay: 'Reading day',
          closingDay: 'Closing date',
          triggerDMinusN: 'D-N trigger',
          effectiveFrom: 'Effective from',
          effectiveTo: 'Effective to',
          escalationThreshold: 'Escalation threshold',
          timezone: 'Timezone',
        },
        placeholders: {
          selectGroup: 'Select the group',
          selectReadingDay: 'Select the reading day',
          selectClosingDay: 'Select the closing day',
          triggerDMinusN: 'Enter the D-N',
          effectiveFrom: 'Select the start date',
          effectiveTo: 'Select the end date',
          escalationThreshold: 'Enter the threshold (%)',
          timezone: 'Select the timezone',
          searchPlaceholder: 'Quick search',
        },
        actions: {
          retry: 'Retry',
        },
        form: {
          createTitle: 'Create Billing Calendar',
          editTitle: 'Edit Calendar',
          actions: {
            create: 'Create Calendar',
            cancel: 'Cancel',
            save: 'Save',
            edit: 'Edit',
            delete: 'Delete',
          },
        },
        deleteDialog: {
          title: 'Delete calendar',
          description: 'This action deactivates the billing calendar of the selected group.',
          confirm: 'Delete',
        },
        toast: {
          created: 'Calendar created successfully',
          updated: 'Calendar updated successfully',
          deleted: 'Calendar deleted successfully',
        },
        errors: {
          title: 'Error',
          loadList: 'Unable to load billing calendars.',
          loadDetails: 'Unable to load the latest calendar data.',
          create: 'Unable to create the billing calendar.',
          update: 'Unable to update the billing calendar.',
          delete: 'Unable to delete the billing calendar.',
          invalidEffectivePeriod: 'The end date cannot be earlier than the start date.',
        },
        validation: {
          groupRequired: 'Group is required.',
          readingDayRequired: 'Reading day is required.',
          closingDayRequired: 'Closing day is required.',
          triggerDaysRequired: 'D-N trigger is required.',
          effectiveFromRequired: 'Start date is required.',
        },
      },
      notifications: {
        pageTitle: 'VEE Configuration - Notifications',
        breadcrumbTitle: 'Notifications',
        tableTitle: 'Notifications',
        columns: {
          group: 'Group',
          frequency: 'Frequency',
          recipients: 'Recipients',
          escalationChannel: 'Escalation channel',
          eventTypes: 'Event types',
          status: 'Status',
          actions: 'Actions',
        },
        labels: {
          veeGroup: 'VEE Group',
          frequency: 'Frequency',
          groupRecipients: 'Recipients per group',
          escalationChannel: 'Escalation channel (critical billing readiness)',
          eventTypes: 'Monitored event types',
        },
        actions: {
          viewDetails: 'Click to view details',
          itemsCount: '{count} records',
          close: 'Close',
        },
        placeholders: {
          searchPlaceholder: 'Search group',
          selectVeeGroup: 'Select the VEE group',
          emailExample: "name{'@'}company.com",
        },
        filters: {
          frequency: 'Frequency',
          status: 'Status',
          selectOption: 'Select',
        },
        frequencies: {
          immediate: 'Immediate',
          dailyDigest: 'Daily digest',
          weeklyDigest: 'Weekly digest',
        },
        eventTypes: {
          CriticalException: 'Critical exception',
          CommunicationFailure: 'Communication failure',
          PendingEstimationProposal: 'Pending estimation proposal',
          OverdueServiceRequestSla: 'Overdue service request SLA',
          CriticalBillingReadiness: 'Critical billing readiness',
          CustomRuleTriggered: 'Custom rule triggered',
        },
        statuses: {
          active: 'Active',
          inactive: 'Inactive',
        },
        form: {
          createTitle: 'Create Notification',
          editTitle: 'Edit Notification',
          actions: {
            create: 'Create notification',
            cancel: 'Cancel',
            save: 'Save',
            saving: 'Saving...',
            edit: 'Edit',
            delete: 'Delete',
            addEmail: 'Add email',
            removeEmail: 'Remove email',
          },
        },
        deleteDialog: {
          title: 'Deactivate notification',
          description: 'This notification configuration will be deactivated.',
          confirm: 'Deactivate',
          notConfigured: 'Not provided',
        },
        validation: {
          invalidEmail: 'Enter a valid email address',
          veeGroupRequired: 'Select the VEE group',
          groupRecipientsRequired: 'Enter at least one group recipient',
          eventTypesRequired: 'Select at least one event type',
        },
        toast: {
          created: 'Notification created successfully',
          updated: 'Notification updated successfully',
          deleted: 'Notification deactivated successfully',
          loadError: 'Error loading notifications',
          loadDetailsError: 'Could not load the latest notification data.',
          saveError: 'Error saving notification',
          deleteError: 'Error deactivating notification',
        },
      },
      hierarchyAssociation: {
        pageTitle: 'VEE Configuration - Hierarchy Association',
        breadcrumbTitle: 'Hierarchy Association',
        tableTitle: 'Hierarchy Association',
        columns: {
          level: 'Level',
          criterion: 'Criterion',
          appliedGroup: 'Applied group',
          priority: 'Priority',
          priorityConflict: 'Conflict',
          priorityConflictHint:
            'Another active association shares the same priority for this criterion',
          validity: 'Validity',
          indeterminateValidity: 'Indefinite',
          status: 'Status',
          actions: 'Actions',
        },
        statusOptions: {
          active: 'Active',
          inactive: 'Inactive',
        },
        levelOptions: {
          meter: 'Meter',
          meterGroup: 'Meter group',
          tariffClass: 'Tariff class',
          technology: 'Technology',
          default: 'Default',
        },
        actions: {
          create: 'Create association',
          edit: 'Edit',
          editTooltip: 'Edit',
          deactivateTooltip: 'Deactivate',
          reactivateTooltip: 'Reactivate',
        },
        filters: {
          searchPlaceholder: 'Quick search',
          level: 'Level',
          levelPlaceholder: 'Enter the level',
          appliedGroup: 'Applied group',
          appliedGroupPlaceholder: 'Enter the group',
          validity: 'Validity',
          validityPlaceholder: 'Enter the validity',
          status: 'Status',
          statusPlaceholder: 'Enter the status',
        },
        form: {
          createTitle: 'Create Association',
          editTitle: 'Edit Association',
          fields: {
            level: 'Level',
            criterion: 'Criterion',
            appliedGroup: 'Applied group',
            priority: 'Priority',
            effectiveFrom: 'Validity start',
            effectiveTo: 'Validity end',
            status: 'Status',
          },
          placeholders: {
            level: 'Enter the level',
            meter: 'Enter the meter',
            tag: 'Enter the meter group',
            tariffClass: 'Enter the tariff class',
            technology: 'Enter the technology',
            appliedGroup: 'Enter the applied group',
            status: 'Enter the status',
            searchMeter: 'Type the meter serial',
            effectiveFrom: 'Enter the validity start',
            effectiveTo: 'Enter the validity end (optional)',
            priority: 'Enter the priority',
          },
          validation: {
            veeGroupRequired: 'Select the VEE Group to apply',
            criterionRequired: 'Enter the criterion',
            effectiveFromRequired: 'Validity start is required',
            invalidPeriod: 'Validity start cannot be later than validity end and vice versa',
          },
          actions: {
            cancel: 'Cancel',
            save: 'Save',
            saving: 'Saving...',
          },
        },
        statusDialog: {
          deactivateTitle: 'Deactivate Association',
          deactivateDescription:
            'The association will be deactivated and will remain registered, and can be reactivated later. Do you want to continue?',
          reactivateTitle: 'Reactivate Association',
          reactivateDescription:
            'The association will be considered again in the effective VEE Group resolution, respecting its validity period. Do you want to continue?',
          confirmDeactivate: 'Deactivate',
          confirmReactivate: 'Reactivate',
          priorityConflictWarning:
            'Warning: this association conflicts in priority with another active association',
        },
        toast: {
          created: 'Association created successfully',
          updated: 'Association updated successfully',
          deactivated: 'Association deactivated successfully',
          reactivated: 'Association reactivated successfully',
          loadError: 'Could not load associations',
          loadDetailsError: 'Could not load the latest association data.',
          saveError: 'Could not save the association',
          deactivateError: 'Could not deactivate the association',
          reactivateError: 'Could not reactivate the association',
        },
      },
      customRule: {
        pageTitle: 'VEE Configuration - Custom Rule',
        breadcrumbTitle: 'Custom Rule',
        sections: {
          group: 'VEE Group',
          list: 'Custom Rules',
          newRule: 'New Custom Rule',
          editRule: 'Edit Custom Rule',
          details: 'Custom Rule Details',
          info: 'Rule Information',
          sandbox: 'Sandbox',
          dryRun: 'Dry Run - Impact',
          history: 'History and Versioning',
        },
        labels: {
          group: 'Group',
          name: 'Name',
          description: 'Description',
          measurementKey: 'Measurement',
          condition: 'Condition',
          operator: 'Operator',
          value: 'Value',
          secondaryValue: 'Secondary value',
          values: 'Values',
          valuesPlaceholder: 'Separate values with a comma',
          action: 'Operational action',
          estimationMethod: 'Estimation method',
          severityOverride: 'Severity (override)',
          operationalActionOverride: 'Operational action (override)',
          historicalWindowDays: 'Historical window (days)',
          effectiveFrom: 'Effective from',
          effectiveTo: 'Effective to',
          openEnded: 'Open ended',
          preview: 'Rule summary',
          sampleMeters: 'Sample meters',
          sampleMetersPlaceholder: 'Select meters for the test',
          periodStart: 'Period start',
          periodEnd: 'Period end',
        },
        placeholders: {
          group: 'Select a VEE group',
          name: 'Enter the rule name',
          description: 'Enter a description',
          measurementKey: 'Select the measurement',
          condition: 'Select the condition',
          operator: 'Select the operator',
          action: 'Select the action',
          estimationMethod: 'Select the estimation method',
          severityOverride: 'Select the severity',
          operationalActionOverride: 'Select the operational action',
          date: 'Select the date and time',
          value: 'Enter the value',
          secondaryValue: 'Enter the secondary value',
          periodStart: 'Select the period start',
          periodEnd: 'Select the period end',
          historicalWindowDays: 'Enter the historical window in days',
        },
        validation: {
          groupRequired: 'Select the VEE group',
          nameRequired: 'Enter the rule name',
          measurementKeyRequired: 'Select the measurement',
          conditionRequired: 'Select the condition',
          operatorRequired: 'Select the operator',
          valueRequired: 'Enter the value',
          valuesRequired: 'Enter at least one value',
          secondaryValueRequired: 'Enter the secondary value',
          actionRequired: 'Select the action',
          estimationMethodRequired: 'Select the estimation method',
          effectiveFromRequired: 'Effective from is required',
          invalidPeriod: 'Effective to cannot be earlier than effective from',
          invalidSandboxPeriod: 'The period end cannot be earlier than the period start',
        },
        actions: {
          newRule: 'New Rule',
          preview: 'Refresh summary',
          save: 'Save',
          cancel: 'Cancel',
          runTest: 'Run Test',
          activate: 'Activate Rule',
          view: 'View Version',
          rollback: 'Roll back to this version',
          enableCustomRuleEngine: 'Enable custom rules',
          enablingCustomRuleEngine: 'Enabling...',
        },
        columns: {
          name: 'Name',
          group: 'Group',
          version: 'Version',
          status: 'Status',
          measurementKey: 'Measurement',
          action: 'Action',
          validity: 'Validity',
          origin: 'Origin',
          createdAt: 'Created at',
          actions: 'Actions',
        },
        filters: {
          group: 'Group',
          status: 'Status',
          measurementKey: 'Measurement',
          actionType: 'Action',
          selectOption: 'Select an option',
        },
        status: {
          active: 'Active',
          draft: 'Draft',
          expired: 'Expired',
          superseded: 'Superseded',
          inactive: 'Inactive',
        },
        origin: {
          created: 'Created',
          edited: 'Edited',
          rolledBack: 'Rolled back',
        },
        enums: {
          conditionType: {
            value: 'Value',
            consecutiveDifference: 'Consecutive difference',
            historicalAverage: 'Historical average',
            historicalStandardDeviation: 'Historical standard deviation',
            hourOfDay: 'Hour of day',
            dayOfWeek: 'Day of week',
            dayType: 'Day type',
            consumptionClass: 'Consumption class',
            region: 'Region',
          },
          operator: {
            equals: 'Equals',
            notEquals: 'Not equals',
            greaterThan: 'Greater than',
            greaterThanOrEqual: 'Greater than or equal to',
            lessThan: 'Less than',
            lessThanOrEqual: 'Less than or equal to',
            between: 'Between',
            in: 'In (list)',
          },
          actionType: {
            generateException: 'Generate exception',
            proposeEstimation: 'Propose estimation',
            markForReview: 'Mark for review',
            notify: 'Notify',
          },
          estimationMethod: {
            loadProfile: 'Load profile',
            proxyDay: 'Proxy day',
            interpolation: 'Interpolation',
            scalarCalculation: 'Scalar calculation',
            zeroFill: 'Zero fill',
          },
          dayType: {
            businessDay: 'Business day',
            weekend: 'Weekend',
          },
        },
        dryRun: {
          requestedMeters: 'Requested meters',
          affectedMeters: 'Affected meters',
          evaluatedMeters: 'Evaluated meters',
          readingsEvaluated: 'Evaluated readings',
          simulatedExceptions: 'Simulated exceptions',
          simulatedProposals: 'Simulated proposals',
          simulatedNotifications: 'Simulated notifications',
          performanceRisk: 'Performance risk identified',
          examples: 'Examples',
          successTitle: 'Test executed successfully',
          successDescription: 'The results below reflect the most recent simulation of this rule.',
          status: {
            success: 'Success',
            failed: 'Failed',
          },
        },
        rollback: {
          title: 'Roll back to an earlier version',
          description:
            'Rollback creates a new draft version with the content of the selected version. Provide a reason to continue.',
          reasonPlaceholder: 'Enter the rollback reason',
          cancel: 'Cancel',
          confirm: 'Confirm rollback',
        },
        activateDialog: {
          title: 'Activate Rule',
          description:
            'This action effectively activates the current version of this rule, applying it immediately to the following evaluations. Do you want to continue?',
          cancel: 'Cancel',
          confirm: 'Confirm activation',
        },
        history: {
          detailsTitle: 'Version v{version} Details',
          previousVersion: 'Previous version',
        },
        sandbox: {
          metersHelpTitle: 'How to make meters available?',
          metersHelpIntro: 'The meters shown in the Sandbox depend on the VEE Group configuration.',
          metersHelpRequirementsTitle: 'To make them available:',
          metersHelpSource: 'Configure a Source Role for the group.',
          metersHelpAssignments: 'Make sure the group has valid, current meter associations.',
          metersHelpWhereConfigure: 'Where to configure?',
          metersHelpSourcePath: 'Source Role: VEE Configuration → VEE Groups → Edit VEE Group',
          metersHelpAssignmentsPath: 'Associations: VEE Configuration → Hierarchy Association',
          noMetersAvailable:
            'No meters available for this group. Check the help icon to review the required configuration.',
        },
        empty: {
          definitions: 'No custom rules found.',
          preview: 'Fill in the required rule fields to generate the summary.',
          dryRunTitle: 'No test run yet',
          dryRun:
            'Run a test in the Sandbox to see the simulated impact of this rule before activating it.',
          history: 'No history available.',
        },
        errors: {
          loadGroups: 'Could not load VEE groups.',
          resolveGroupRule: 'Could not find the custom rule engine for this group.',
          customRuleEngineIntegrity:
            'More than one internal custom rule configuration was found. Fix the VEE configuration before continuing.',
          noCustomRuleEngine:
            'This group is not yet enabled to use custom rules. Enable this feature for the group and then continue configuring the rule.',
          noCustomRuleEnginePermission:
            'This group is not yet enabled to use custom rules. Ask a user with VEE configuration permission to enable this feature.',
          customRuleEngineScopeUnsupported:
            'This group is configured with the "Totalizers" Data scope. Custom rules use Mass Memory readings, so they can only be enabled for groups with the "Mass Memory" or "Hybrid" scope.',
          groupVigenciaExpired:
            'This group is outside its effective period (end date already passed). Adjust the group period before enabling custom rules.',
          enableCustomRuleEngine: 'Could not enable custom rules for this group.',
          loadDefinitions: 'Could not load custom rules.',
          loadHistory: 'Could not load the rule history.',
          loadMeters: 'Could not load the group meters.',
          save: 'Could not save the custom rule.',
          preview: 'Could not refresh the rule summary.',
          validationFailed:
            'The provided combination is not valid. Review the details below before continuing.',
          reviewHighlightedFields: 'Review the fields highlighted in red before saving.',
          dryRun: 'Could not run the rule test.',
          activate: 'Could not activate the custom rule.',
          rollback: 'Could not roll back the custom rule.',
        },
        toast: {
          customRuleEngineEnabled: 'Custom rules enabled for this group.',
          saved: 'Custom rule saved successfully.',
          savedNewVersion:
            'The rule was in use: a new version was created. The previous version remains unchanged.',
          previewUpdated: 'Rule summary updated successfully.',
          previewUnchanged: 'No changes were found to update the summary.',
          dryRunSuccess: 'Test executed successfully.',
          dryRunFailed:
            'The test ran, but the result indicated failure. Check the dry-run details.',
          activated: 'Custom rule activated effectively.',
          rolledBack:
            'Rollback completed: a new draft version was created. Adjust the validity period and run a new test before activating.',
        },
      },
    },
    veeResume: {
      pageTitle: 'Monitoring - Summary',
      title: 'Summary',
      badge: 'Operation/inquiry',
      cards: {
        batchProcessed: 'Batch Processed (%)',
        metersCompleted: 'Meters Completed',
        estimatesToApprove: 'Estimates to Approve',
        blocks: 'Blocks',
        unavailable: 'Unavailable',
      },
      billingReadiness: {
        title: 'Billing Readiness',
        empty: 'No meters found.',
        loadError: 'Unable to load billing readiness.',
        columns: {
          meter: 'Meter',
          status: 'Status',
          pending: 'Pending Items',
          action: 'Recommended Action',
        },
        status: {
          ready: 'Ready',
          pending: 'Pending',
          blocked: 'Blocked',
          manuallyReleased: 'Manually Released',
          notApplicable: 'Not Applicable',
        },
        units: {
          estimates: 'estimates',
          critical: 'critical',
          exceptions: 'exceptions',
        },
        actions: {
          approveEstimates: 'Approve Estimates',
          reviewBlock: 'Review Block',
        },
        noPending: '-',
        filters: {
          group: 'Group',
          selectGroup: 'Select the group',
          status: 'Status',
          selectStatus: 'Select the status',
          searchPlaceholder: 'Search by meter',
        },
      },
      calendar: {
        title: 'Billing Calendar',
        configureTooltip: 'Configure billing calendar',
        empty: 'No billing calendar configured.',
        unavailable: 'Unable to load the billing calendar.',
        partial: 'Some groups could not be loaded.',
        nextClosing: 'Next closing',
        daysRemaining: '{count} day(s) remaining',
        columns: {
          name: 'Name',
          nextClosing: 'Next Closing',
          status: 'Status',
        },
        status: {
          ready: 'Ready',
          pending: 'Pending',
          blocked: 'Blocked',
          unavailable: 'No Data',
        },
      },
      toast: {
        loadError: 'Unable to load the operational summary.',
        partialLoadTitle: 'Partial load',
        partialLoadDetail: 'Some billing calendar groups could not be loaded.',
      },
    },
    veeBatchApproval: {
      pageTitle: 'Monitoring - Batch Approval',
      title: 'Batch Approval',
      badge: 'Operation/inquiry · supervisor',
      filters: {
        title: 'Filters',
        group: 'Group',
        selectGroup: 'Select the group',
        region: 'Region',
        selectRegion: 'Select the region',
        noRegions: 'No regions found',
        method: 'Method',
        selectMethod: 'Select the method',
        period: 'Period',
        selectPeriod: 'Select the period',
        severity: 'Severity',
        selectSeverity: 'Select the severity',
        minAgingDays: 'Minimum aging (days)',
        maxAgingDays: 'Maximum aging (days)',
        agingPlaceholder: 'Enter the value',
        clear: 'Clear',
        apply: 'Apply',
        validation: {
          title: 'Invalid filters',
          agingMustBeNonNegative: 'Minimum and maximum aging cannot be negative.',
          minAgingAboveMax: 'Minimum aging cannot be greater than maximum aging.',
        },
      },
      table: {
        title: 'Estimates pending approval',
        searchPlaceholder: 'Search meter',
        empty: 'No estimates pending approval.',
        mixedGroupSelection:
          'The selection contains proposals from more than one VEE group. Batch approval requires all selected proposals to belong to the same group.',
        valueUnavailable: 'Not available',
        reasonUnavailable: 'Reason not available',
        columns: {
          meter: 'Meter',
          group: 'Group',
          region: 'Region',
          severity: 'Severity',
          aging: 'Aging (days)',
          periodStart: 'Period start',
          periodEnd: 'Period end',
          method: 'Method',
          originalValue: 'Pre-VEE value',
          referenceValue: 'Method reference',
          proposedValue: 'Proposed value',
          measurementKey: 'Measurement',
          unit: 'Unit',
          deviation: 'Deviation',
          secondaryValidation: 'Secondary validation',
          reason: 'Proposal reason',
        },
      },
      actions: {
        approve: 'Approve selected',
      },
      toasts: {
        approveSummary: 'Estimates approved',
        approveDetail: '{count} estimate(s) approved successfully.',
        noSelectionSummary: 'No estimate selected',
        noSelectionDetail: 'Select at least one estimate to continue.',
        mixedGroupSummary: 'Selection with different groups',
        mixedGroupDetail: 'All selected proposals must belong to the same VEE group.',
        partialSummary: 'Partial approval',
        partialDetail: '{approved} approved and {failed} not approved.',
        allFailedSummary: 'No proposal approved',
        allFailedDetail: 'None of the {failed} selected proposal(s) could be approved.',
        requestErrorSummary: 'Unable to approve the batch',
        requestErrorDetail: 'An error occurred while processing the batch approval request.',
        loadErrorSummary: 'Unable to load the estimates',
        loadErrorDetail:
          'An error occurred while loading the list of estimates pending batch approval.',
      },
      outcomeReasons: {
        notFoundInTenant: 'Proposal not found',
        alreadyDecided: 'Proposal already decided',
        notEligible: 'Proposal not eligible',
        secondaryValidationNotApproved: 'Secondary validation not approved',
        gapUnavailable: 'Gap duration unavailable',
        gapExceeded: 'Gap duration above the allowed limit',
        deviationUnavailable: 'Deviation unavailable',
        deviationExceeded: 'Deviation above the allowed limit',
        policyMissingOrIncomplete: 'Batch approval policy missing or incomplete for the group',
        concurrencyConflict: 'Proposal decided by another concurrent operation',
        coverageConflict: 'Period already covered by another approved proposal',
        technicalError: 'Technical error while processing the proposal',
      },
      confirmDialog: {
        title: 'Confirm Batch Approval',
        warning: 'This operation will approve the selected estimates.',
        count: 'Selected quantity',
        group: 'Group',
        distinctMeters: 'Distinct meters',
        methods: 'Methods involved',
        byUnitAndMeasurement: 'Quantity by measurement and unit',
        cancel: 'Cancel',
        confirm: 'Confirm approval',
      },
    },
    veeReadingImport: {
      pageTitle: 'Monitoring - Reading Import',
      title: 'Reading Import',
      badge: 'Operation/inquiry',
      clearAll: 'Clear all',
      addRow: 'Add row',
      importSpreadsheet: 'Import spreadsheet',
      importDialogTitle: 'Import Readings',
      empty: 'No items added yet. Import a spreadsheet or add rows manually.',
      importedRecordsTitle: 'Inserted Records',
      total: 'Total',
      columns: {
        meter: 'Meter',
        meterPlaceholder: 'Meter serial number',
        scope: 'Scope',
        scopePlaceholder: 'Select the scope',
        measurementKey: 'Measurement',
        measurementKeyPlaceholder: 'Select the measurement',
        measurementKeyUnrecognized: 'Measurement "{value}" not recognized for the selected scope.',
        readingTimestamp: 'Date/Time',
        readingTimestampPlaceholder: 'Date and time',
        newValue: 'New value',
        newValuePlaceholder: 'Enter the new value',
        reasonCode: 'Reason',
        reasonCodePlaceholder: 'Select the reason',
        itemJustification: 'Item justification',
        itemJustificationPlaceholder: 'Optional',
        originalValue: 'Original value',
        difference: 'Difference',
        status: 'Status',
        validationReason: 'Validation reason',
        suggestion: 'Suggestion',
        actions: 'Action',
      },
      status: {
        ok: 'Valid',
        warning: 'Warning',
        rejected: 'Invalid',
      },
      requiredFields: {
        meterSerial: 'Meter is required.',
        dataScope: 'Scope is required.',
        measurementKey: 'Measurement is required.',
        readingTimestamp: 'Date/Time is required.',
        newValue: 'New value is required.',
        reasonCode: 'Reason is required.',
      },
      acceptSuggestion: 'Accept suggestion',
      invalidRowsSummary:
        '{count} item(s) failed light validation. Check the reason in the "Validation reason" column.',
      warningRowsSummary:
        '{count} item(s) have a light validation warning. Review the suggestion, if any, before submitting.',
      validRowsSummary: 'All items are valid. You can now submit the batch for approval.',
      batchJustification: 'Batch justification',
      batchJustificationPlaceholder: 'Explain the reason for the edits in this batch',
      validate: 'Validate',
      submit: 'Submit for approval',
      clearAllDialog: {
        title: 'Clear all rows',
        message:
          'Do you really want to remove all {count} rows from the table? This action cannot be undone.',
        cancel: 'Cancel',
        confirm: 'Clear all',
      },
      confirmDialog: {
        title: 'Confirm Submission for Approval',
        warning: 'The batch will be sent for supervisor approval and will not be effectuated yet.',
        totalCount: 'Total records',
        validCount: 'Valid records',
        meters: 'Meters involved',
        measurements: 'Measurements',
        cancel: 'Cancel',
        confirm: 'Confirm submission',
      },
      toasts: {
        emptyFile: 'No rows found in the imported file.',
        importedSummary: 'Spreadsheet imported',
        importedDetail: '{count} row(s) added. Review and validate before submitting.',
        validateErrorSummary: 'Error validating',
        validateErrorDetail: 'Could not validate the batch.',
        invalidRowsSummary: 'Invalid items',
        warningRowsSummary: 'Items with warning',
        validRowsSummary: 'Batch validated',
        submitSuccessSummary: 'Batch submitted for approval',
        submitSuccessDetail:
          'The batch was registered as pending and awaits the supervisor decision.',
        submitErrorSummary: 'Error submitting batch',
        submitErrorDetail: 'Could not submit the batch for approval.',
        suggestionAppliedSummary: 'Suggestion applied',
        suggestionAppliedDetail:
          'The new value was updated with the suggestion. Validate again before submitting.',
      },
    },
    veeManualEditBatchApproval: {
      pageTitle: 'Monitoring - Batch Edit Approval',
      title: 'Batch Edit Approval',
      listCardTitle: 'Edit Batches',
      filters: {
        title: 'Filters',
        status: 'Status',
        selectStatus: 'Select the status',
        author: 'Author/Operator',
        selectAuthor: 'Select the author',
        period: 'Submission period',
        selectPeriod: 'Select the period',
        clear: 'Clear',
        apply: 'Apply',
      },
      empty: 'No edit batches found.',
      columns: {
        submittedAt: 'Submitted at',
        status: 'Status',
        totalItems: 'Items',
        appliedFailed: 'Applied / Failed',
        justification: 'Justification',
        itemStatus: 'Item status',
        actions: 'Actions',
      },
      viewDetails: 'View details',
      detailTitle: 'Edit Batch Detail',
      itemsTitle: 'Batch items',
      itemsSearchPlaceholder: 'Search by meter',
      itemsEmpty: 'No meter found for the search entered.',
      close: 'Close',
      batchJustification: 'Batch justification',
      decisionNote: 'Decision note',
      rejectionJustification: 'Rejection justification',
      rejectionJustificationPlaceholder: 'Explain the reason for the rejection',
      decisionNotAllowed:
        'You can view this batch, but approving or rejecting it requires the Administrator or Manager role.',
      reject: 'Reject',
      approve: 'Approve',
      statuses: {
        pending: 'Pending',
        approved: 'Approved',
        rejected: 'Rejected',
        processing: 'Processing',
        completed: 'Completed',
        failed: 'Failed',
      },
      itemStatuses: {
        pending: 'Pending',
        applied: 'Applied',
        failed: 'Failed',
        skipped: 'Skipped',
      },
      toasts: {
        loadErrorSummary: 'Error loading batches',
        loadErrorDetail: 'Could not load the edit batches.',
        loadDetailErrorSummary: 'Error loading detail',
        loadDetailErrorDetail: 'Could not load the batch detail.',
        approveSummary: 'Batch processed',
        approveDetail: '{applied} item(s) applied, {failed} item(s) failed.',
        rejectSummary: 'Batch rejected',
        rejectDetail: 'The batch was rejected and no reading was effectuated.',
        decisionErrorSummary: 'Error deciding on the batch',
        decisionErrorDetail: 'Could not register the decision on the batch.',
      },
    },
    veeRequestQueue: {
      pageTitle: 'Monitoring - Request Queue',
      title: 'Request Queue',
      badge: 'Operation/inquiry',
      empty: 'No pending requests.',
      slaNotConfigured: 'SLA not configured',
      columns: {
        meter: 'Meter',
        issue: 'Type/Issue',
        priority: 'Priority',
        slaRemaining: 'SLA',
        aging: 'Aging (days)',
        status: 'Status',
        actions: 'Actions',
      },
      requestType: {
        estimationExhausted: 'No estimation method was acceptable',
        proposalRejected: 'Estimation proposal rejected or infeasible',
        operationalEscalation: 'Exception escalated for operational action',
      },
      status: {
        open: 'Open',
        inProgress: 'In progress',
        resolved: 'Resolved',
        cancelled: 'Cancelled',
      },
      severity: {
        info: 'Info',
        issue: 'Warning',
        terminate: 'Critical',
      },
      actions: {
        editReading: 'Manually edit reading for this meter',
        changeStatus: 'Edit status',
      },
      filters: {
        status: 'Status',
        selectStatus: 'Select the status',
        slaOverdue: 'SLA',
        selectSlaOverdue: 'Select',
        overdueOnly: 'Overdue only',
        withinSla: 'Within SLA',
        searchPlaceholder: 'Search by meter',
      },
      statusDialog: {
        title: 'Change Request Status',
        newStatusLabel: 'New status',
        selectStatusPlaceholder: 'Select the new status',
        note: 'Note',
        notePlaceholder: 'Describe the reason for the status change.',
        cancel: 'Cancel',
        confirm: 'Confirm',
        noteRequiredSummary: 'Note required',
        noteRequiredDetail: 'Describe the reason before resolving or cancelling the request.',
      },
      toasts: {
        loadErrorSummary: 'Error loading',
        loadErrorDetail: 'Could not load the request queue.',
        loadDetailsErrorDetail: 'Could not load the latest request data.',
        statusChangedSummary: 'Status updated successfully.',
        statusChangeErrorSummary: 'Error changing status',
        statusChangeErrorDetail: 'Could not change the request status.',
      },
    },
    veeManualBillingRelease: {
      pageTitle: 'Monitoring - Manual Billing Release',
      breadcrumbTitle: 'Manual Billing Release',
      tableTitle: 'Manual Billing Release',
      columns: {
        group: 'Group',
        meter: 'Meter',
        referenceMonth: 'Cycle',
        status: 'Status',
        blockingReason: 'Blocking reason',
        actions: 'Actions',
      },
      statusOptions: {
        ready: 'Ready',
        pending: 'Pending',
        blocked: 'Blocked',
        manuallyReleased: 'Manually released',
        notApplicable: 'Not applicable',
      },
      placeholders: {
        searchPlaceholder: 'Search by meter',
        selectGroup: 'Select the group',
        selectStatus: 'Select the status',
      },
      filters: {
        group: 'Group',
        status: 'Status',
      },
      actions: {
        release: 'Release billing',
        retry: 'Retry',
      },
      dialog: {
        title: 'Release Billing',
        justificationLabel: 'Justification',
        justificationPlaceholder: 'Describe the reason for the manual billing release.',
        cancel: 'Cancel',
        confirm: 'Confirm',
      },
      toast: {
        released: 'Billing manually released successfully.',
      },
      errors: {
        title: 'Error',
        loadList: 'Unable to load the billing readiness list.',
        release: 'Unable to release billing manually.',
      },
    },
    veeManualOccurrences: {
      pageTitle: 'Monitoring - VEE Manual Occurrences',
      breadcrumbTitle: 'Manual Occurrences',
      tableTitle: 'Registered Occurrences',
      columns: {
        diagnosisType: 'Diagnosis',
        meter: 'Meter',
        validity: 'Validity',
        status: 'Status',
        createdAt: 'Registered at',
        actions: 'Actions',
      },
      diagnosisTypeOptions: {
        burnedTp: 'Burned TP',
        burnedTc: 'Burned TC',
        burnedMeter: 'Burned meter',
      },
      statusOptions: {
        pending: 'Pending',
        inAnalysis: 'In analysis',
        resolved: 'Resolved',
        ignored: 'Ignored',
      },
      validityOpenEnded: 'Open-ended',
      filters: {
        diagnosisType: 'Diagnosis',
        diagnosisTypePlaceholder: 'Select the diagnosis',
        meterSerial: 'Meter',
        meterSerialPlaceholder: 'Enter the meter serial',
        validity: 'Validity',
        validityPlaceholder: 'Select the validity',
      },
      actions: {
        create: 'Register occurrence',
        viewMeterTooltip: 'View meter',
      },
      form: {
        title: 'Register Burned TP/TC/Meter Occurrence',
        fields: {
          meter: 'Meter',
          diagnosisType: 'Diagnosis',
          validity: 'Validity',
          justification: 'Justification',
        },
        placeholders: {
          meter: 'Search meter by serial',
          meterSearchHint: 'Type the serial to search for a meter.',
          meterNoResults: 'No available options',
          diagnosisType: 'Select the diagnosis',
          validity: 'Select the validity start and, if any, the end',
          justification: 'Describe the diagnosis and the occurrence evidence',
        },
        validation: {
          meterRequired: 'Select the meter.',
          diagnosisTypeRequired: 'Select the diagnosis.',
          validityStartRequired: 'Enter the validity start.',
          validityStartFuture: 'The validity start cannot be in the future.',
          validityRangeInvalid: 'The validity start cannot be after the end.',
          justificationRequired: 'Justification is required.',
        },
        actions: {
          cancel: 'Cancel',
          save: 'Register',
          saving: 'Registering...',
        },
      },
      toast: {
        created: 'Occurrence registered successfully.',
        loadError: 'Unable to load occurrences.',
        saveError: 'Unable to register the occurrence.',
      },
    },
    veeZeroConsumption: {
      pageTitle: 'Monitoring - Zero Consumption',
      title: 'Prolonged Zero Consumption',
      tableTitle: 'Prolonged Zero Consumption Occurrences',
      empty: 'No prolonged zero consumption occurrences found.',
      cards: {
        affectedMeters: 'Affected Meters',
        criticalMeters: 'Critical Meters',
        pendingMeters: 'Pending Treatment',
        inAnalysisMeters: 'Under Analysis',
        vacantMeters: 'Vacant',
      },
      columns: {
        meter: 'Meter',
        zeroSince: 'Zero since',
        duration: 'Duration',
        region: 'Region',
        class: 'Class',
        occupancy: 'Occupancy',
        severity: 'Severity',
        status: 'Status',
        recommendedAction: 'Recommended action',
        actions: 'Action',
      },
      durationDays: '{days} day(s)',
      statusOptions: {
        pending: 'Pending',
        inAnalysis: 'In analysis',
        resolved: 'Resolved',
        ignored: 'Ignored',
      },
      occupancyOptions: {
        occupied: 'Occupied',
        vacant: 'Vacant',
        unknown: 'Not informed',
      },
      levelOptions: {
        initial: 'Initial',
        intermediate: 'Intermediate',
        critical: 'Critical',
      },
      operationalActionOptions: {
        alert: 'Alert',
        hold: 'Hold',
        blockBilling: 'Billing block',
        stopPipeline: 'Pipeline stop',
      },
      filters: {
        status: 'Status',
        statusPlaceholder: 'Select the status',
        occupancy: 'Occupancy',
        occupancyPlaceholder: 'Select the occupancy',
        level: 'Level',
        levelPlaceholder: 'Select the level',
        regionCode: 'Region',
        regionCodePlaceholder: 'Select the region',
        noRegions: 'No regions found',
        classCode: 'Class',
        classCodePlaceholder: 'Enter the class code',
        minDurationHours: 'Minimum duration (h)',
        minDurationHoursPlaceholder: 'Enter the minimum duration',
        maxDurationHours: 'Maximum duration (h)',
        maxDurationHoursPlaceholder: 'Enter the maximum duration',
        searchPlaceholder: 'Search by meter',
      },
      actions: {
        resolve: 'Resolve',
        ignore: 'Ignore',
        processing: 'Processing...',
        disabledClosed: 'Occurrence already {status}, no action available.',
      },
      decisionDialog: {
        resolveTitle: 'Resolve Occurrence',
        ignoreTitle: 'Ignore Occurrence',
        message: 'Enter the justification to proceed with this occurrence.',
        meterLabel: 'Meter',
        justification: 'Justification',
        justificationPlaceholder: 'Describe the check performed and the evidence found',
        cancel: 'Cancel',
        confirm: 'Confirm',
      },
      toast: {
        loadError: 'Could not load the zero consumption occurrences.',
        actionErrorTitle: 'Error updating occurrence',
        actionErrorDetail: 'Could not update the occurrence status.',
        resolvedTitle: 'Occurrence resolved',
        resolvedDetail: 'The occurrence for meter {meter} was marked as resolved.',
        ignoredTitle: 'Occurrence ignored',
        ignoredDetail: 'The occurrence for meter {meter} was marked as ignored.',
      },
    },
    veeLimitDeviations: {
      pageTitle: 'Monitoring - Limit Deviations',
      title: 'Limit Deviations',
      badge: 'Operation/inquiry',
      empty: 'No deviations found.',
      cards: {
        above: 'Deviations Above',
        aboveUnit: 'meters',
        below: 'Deviations Below',
        belowUnit: 'meters',
      },
      charts: {
        deviationTitle: 'Deviation distribution by meter',
        severityTitle: 'Distribution by severity',
        legendAbove: 'Above the limit',
        legendBelow: 'Below the limit',
      },
      columns: {
        meter: 'Meter',
        direction: 'Direction',
        deviation: 'Deviation',
        baseline: 'Baseline',
        severity: 'Severity',
        status: 'Status',
        region: 'Region',
        class: 'Class',
      },
      filters: {
        searchPlaceholder: 'Search by meter',
        direction: 'Direction',
        directionPlaceholder: 'Select the direction',
        status: 'Status',
        statusPlaceholder: 'Select the status',
        severity: 'Severity',
        severityPlaceholder: 'Select the severity',
        regionCode: 'Region',
        regionCodePlaceholder: 'Select the region',
        noRegions: 'No regions found',
        classCode: 'Class',
        classCodePlaceholder: 'Enter the class code',
      },
      directionOptions: {
        above: 'Above',
        below: 'Below',
      },
      statusOptions: {
        pending: 'Pending',
        inAnalysis: 'In analysis',
        resolved: 'Resolved',
        ignored: 'Ignored',
      },
      baselineMethods: {
        absoluteLimit: 'Absolute limit',
        percentageLimit: 'Percentage limit',
        historicalAverage: 'Historical average',
        comparableDay: 'Comparable day',
        seasonalProfile: 'Seasonal profile',
      },
      toast: {
        loadError: 'Could not load the limit deviations.',
      },
    },
    veeExecutionMonitor: {
      pageTitle: 'Monitoring - Execution Monitor',
      title: 'Batch Execution Monitor',
      badge: 'Operation/inquiry',
      empty: 'No executions found.',
      columns: {
        execution: 'Execution',
        group: 'Group',
        period: 'Period',
        status: 'Status',
        volume: 'Volume',
        duration: 'Duration',
        backlog: 'Backlog',
      },
      status: {
        pending: 'Pending',
        running: 'Running',
        completed: 'Completed',
        completedWithAlert: 'Completed with alert',
        failed: 'Failed',
        cancelled: 'Cancelled',
      },
      filters: {
        status: 'Status',
        statusPlaceholder: 'Select a status',
        period: 'Period',
        selectPeriod: 'Select a period',
      },
      toast: {
        loadError: 'Could not load executions.',
      },
    },
    groupDetails: {
      monthlyQualityParameters: {
        title: 'Monthly DRP/DRC average',
        button: 'Calculate monthly DRP/DRC average',
        dialogTitle: 'Monthly DRP/DRC average',
        success: 'Monthly DRP/DRC average calculated successfully',
        error: 'Error calculating the monthly DRP/DRC average',
        exportError: 'Select a reference to export the monthly DRP/DRC average.',
      },
      latestQualityParameters: {
        title: 'Latest quality parameters',
        error: 'Error loading the latest quality parameters',
      },
    },
    scheduledCommands: {
      title: 'Routine Listing',
      filterByGroup: 'Filter by Group name',
      statusChanged: 'Schedule status changed',
      deleteSuccess: 'Schedule deleted successfully',
      timeMax: 'Maximum time to execute the command',
      description: 'Description',
      selectGroup: 'Select group',
      selectCommand: 'Select command',
      editRoutine: 'Edit Routine',
      addRoutine: 'Add Routine',
      configure: 'Configure',
      review: 'Review',
      quantityLastMeasures: 'Quantity of Last Measurements',
      quantityLastMeasuresSmc: 'Quantity of Last Measurements (SMC)',
      commandParameters: 'Command Parameters',
      alternativeDataSmi: 'Alternative Data (SMI)',
      energyRecoveryDataSmi: 'Energy Recovery Data (SMI)',
      initialDateTime: 'Initial Date/Time',
      finalDateTime: 'Final Date/Time',
      intervalMinutes: 'Interval in Minutes',
      seconds: 'Seconds',
      back: 'Back',
      update: 'Update',
      add: 'Add',
      routineUpdated: 'Routine Updated',
      routineCreated: 'Routine Created',
      saveRoutineError: 'Error saving Routine',
      unknownError: 'Unknown error',
      loadGroupsError: 'Error loading groups',
      successTitle: 'Success',
      errorTitle: 'Error',
      statusChangeError: 'Error changing schedule status',
      deleteRoutineError: 'Error deleting schedule',
      minuteUnit: 'minute',
      minutesUnit: 'minutes',
      placeholders: {
        filterByGroup: 'Enter the Group name',
        description: 'Enter a description for the routine',
        selectGroup: 'Select a group',
        selectCommand: 'Select a command',
        quantity: 'Enter the quantity',
        initialDate: 'Select the initial date',
        finalDate: 'Select the final date',
        interval: 'Enter the interval',
        secondsQuantity: 'Enter the number of seconds',
      },
      days: 'Day(s)',
      hours: 'Hour(s)',
      minutes: 'Minute(s)',
      cronEditor: 'Cron Editor',
      validation: {
        descriptionRequired: 'Enter the routine description.',
        descriptionHtmlNotAllowed: 'The routine description cannot contain HTML.',
        groupRequired: 'Select a group.',
        minimumDuration: 'The maximum time to execute the command must be at least 1 minute.',
        invalidCron: 'Configure a valid cron for the routine.',
      },
      cronEditorOptions: {
        intlLocale: 'en-US',
        every: 'Every',
        second: 'Second',
        minute: 'Minute',
        hour: 'Hour',
        day: 'Day',
        week: 'Week',
        month: 'Month',
        year: 'Year',
        everySecond: 'every second',
        everyMinute: 'every minute',
        everyHour: 'every hour',
        everyMonth: 'every month',
        everyDayOfWeek: 'every specific day of week',
        noSpecificDay: 'no specific day',
        noSpecificDayOfWeek: 'no specific day of the week',
        all: 'all',
        of: 'of',
        onDays: 'on day(s)',
        and: 'and',
        andOf: 'and of',
        at: 'at',
        secondsSuffix: 'second(s)',
      },
      nextExecution: 'Next execution',
      lastExecution: 'Last execution',
      routineDetails: 'Routine Details',
      routinePage: 'Routine Page',
      deleteRoutine: 'Delete Routine',
      noProcessYet: 'No process found for this routine yet.',
      dateRange: {
        label: 'Date range',
        relativeSummary: 'Last {daysBack} day(s)',
        relativeEndsBefore: ', ending {endDaysBack} day(s) before the trigger',
        relativeTruncateToDay: ', aligned to midnight',
      },
    },
    transformerDetails: {
      title: 'Transformer Details',
      details: 'Details',
      transformer: 'Transformer',
      editTransformer: 'Edit Transformer',
      name: 'Name',
      meterSerial: 'Meter Serial',
      metersCount: 'Meters Count',
      publicLighting: 'Public Lighting',
      coordinates: 'Coordinates',
      updatedAt: 'Updated At',
      description: 'Description',
      viewMore: 'View More',
      meterDetails: 'Meter Details',
      manufacturerType: 'Manufacturer | Type',
      serial: 'Serial',
      installation: 'Installation',
      displayConfiguration: 'Display Configuration',
      firmware: 'Firmware',
      relayStatus: 'Relay Status',
      status: 'Status',
      meterMoreDetails: 'Meter Details',
      latitude: 'Lat',
      longitude: 'Long',
      massMemoryCrc: 'CRC Mass Memory',
      uplinkPeriod: 'Uplink Period',
      energyCrc: 'CRC Energy',
      tags: 'Meter Tags',
      noTags: 'No tags found',
      close: 'Close',
      loading: 'Loading...',
    },
    areas: {
      title: 'Areas',
      startDate: 'Initial Date',
      endDate: 'End Date',
      search: 'Search',
      placeholders: {
        loading: 'Loading...',
        select: 'Select Area',
        selectDate: 'Select the date',
      },
      errors: {
        title: 'Error',
        loadAreas: 'Error loading areas',
      },
    },
    areaDetails: {
      title: 'Area Details',
      details: 'Details',
      area: 'Area',
      editArea: 'Edit Area',
      name: 'Name',
      transformersCount: 'Transformers Count',
      updatedAt: 'Updated At',
      description: 'Description',
      errors: {
        title: 'Error',
        loadAreaInfo: 'Error loading area information',
      },
    },
    regions: {
      title: 'Regions',
      regions: 'Regions',
      selectPeriod: 'Select the period',
      startDate: 'Initial Date',
      endDate: 'End Date',
      search: 'Search',
      placeholders: {
        loading: 'Loading...',
        select: 'Select Region',
        selectDate: 'Select the date',
      },
      errors: {
        title: 'Error',
        loadRegions: 'Error loading regions',
      },
    },
    regionDetails: {
      title: 'Region Details',
      details: 'Details',
      region: 'Region',
      editRegion: 'Edit Region',
      name: 'Name',
      areasCount: 'Areas Count',
      updatedAt: 'Updated At',
      description: 'Description',
      errors: {
        title: 'Error',
        loadRegionInfo: 'Error loading region information',
      },
    },
    serviceNotes: {
      code: 'Code',
      contractAccount: 'Contract Account',
      dateTimeLimitConclusion: 'Deadline for Completion',
      dateTimeStart: 'Start Date',
      codeGroup: 'Code Group',
      installation: 'Installation',
      measureCodeGroup: 'Measurement Code Group',
      noteNumber: 'Note Number',
      equipmentSerialNumber: 'Equipment Serial Number',
      cancellationRequest: 'Cancellation Request',
      noteType: 'Note Type',
      cPNumber: 'CP Number',
      cSNumber: 'CS Number',
      cSPosition: 'CS Position',
      noteGroup: 'Note Group',
      noteCode: 'Note Code',
      measureGroup: 'Measurement Group',
      equipment: 'Equipment',
      referenceMonth: 'Reference Month',
      creationDate: 'Creation Date',
      creationHour: 'Creation Time',
      limitDate: 'Limit Date',
      limitHour: 'Limit Time',
      serialMeter: 'Meter Serial Number',
      rateType: 'Rate Type',
      ssn: 'SSN',
      min: 'MIN',
      readingDate: 'Reading Date',
      readingUnit: 'Reading Unit',
      day: 'Day',
      serial: 'Serial',
      registers: 'Registers',
      attempts: 'Attempts',
      origin: 'Origin',
      datetime: 'Date',
      online: 'Status',
      meterActivated: 'Relay State',
      comissioned: 'Commissioned',
      dateTimeInitial: 'Start Date',
      dateTimeFinal: 'End Date',
      drp: 'DRP',
      drc: 'DRC',
      updatedAt: 'Updated At',
      count: 'Count',
      description: 'Description',
      dataResponse: 'Service Note Response',
    },
    models: {
      title: 'Models',
      meterModels: 'Meter Models',
      smcModels: 'SMC Models',
      newModel: 'New Model',
      registerModelFile: 'Import models from file',
      editModelFile: 'Edit models from file',
      import: {
        successAll: 'Import completed successfully',
        partial: 'Import partially completed',
        error: 'Error importing models',
      },
      edit: {
        successAll: 'Edit completed successfully',
        partial: 'Edit partially completed',
        error: 'Error editing models',
      },
      success: {
        createModel: 'Model created successfully',
        updateModel: 'Model updated successfully',
      },
      errors: {
        title: 'Error',
        loadModels: 'Error while fetching models',
        noModelSelected: 'No model selected',
        manufacturerNotFound: 'Manufacturer not found',
        createModel: 'Error while creating model',
        updateModel: 'Error while updating model',
      },
    },
    configuration: {
      title: 'Settings',
      configure: 'Configure',
      effectiveness: {
        title: 'Effectiveness',
        description: 'Configure the minimum number of meters for effectiveness calculation.',
        dialog: {
          title: 'Effectiveness Configuration',
          model: 'Model',
          modelPlaceholder: 'Select a model',
          searchModel: 'Search model',
          emptyModels: 'No models found',
          minimumQuantity: 'Minimum Quantity',
          loading: 'Loading...',
          cancel: 'Cancel',
          save: 'Save',
        },
      },
      abruptVariation: {
        title: 'Abrupt Variation',
        description: 'Configure the parameters for abrupt consumption variation detection.',
      },
      onlineHistoryInterval: {
        title: 'Meter Status Interval Check',
        description: 'Set the interval to check the meter status',
        dialog: {
          title: 'Interval Configuration',
          minimumInterval: 'Minimum Interval',
          loading: 'Loading...',
          cancel: 'Cancel',
          save: 'Save',
        },
      },
    },
    displayText: {
      showMore: 'Show more',
      showLess: 'Show less',
    },
  },
  auth: {
    login: {
      title: 'System Access',
      emailLabel: 'E-mail',
      associate: 'Associate',
      associateWarn:
        'We’ve verified that you’re not yet linked in the system. Please add your email address.',
      passwordLabel: 'Password',
      submitButton: 'Enter',
      submitButtonAd: 'Sign in via Active Directory',
      tabEmail: 'E-mail',
      tabLdap: 'AD',
      usernameLdapLabel: 'AD Username',
      usernameLdapPlaceholder: 'Active Directory username',
      forgotPassword: 'Expired password?',
      placeholders: {
        email: 'Enter your email',
        password: 'Enter your password',
      },
      validation: {
        emailRequired: 'Email is required',
        invalidEmail: 'Invalid email',
        adCredentialRequired: 'Network user or email is required',
        passwordRequired: 'Password is required',
      },
      recoverPassword: {
        saveButton: 'Save',
        cancelButton: 'Cancel',
      },
    },
    userType: {
      admin: 'Administrator',
      operator: 'Technical Operator',
      user: 'User',
      erector: 'Installer',
      manager: 'Technical Manager',
      sap: 'SAP User',
      monitor: 'Monitor',
      root: 'Root',
      invalid: 'Invalid',
    },
    errors: {
      invalidCredentials: 'Invalid email or password',
      missingFields: 'All fields must be filled',
    },
    requiredChangePassword: {
      title: 'Required Password Change',
      emailLabel: 'E-mail',
      expiredPasswordLabel: 'Current password',
      newPasswordLabel: 'New password',
      submitButton: 'Change Password',
      instructions: 'Change the password created by the administrator.',
      passwordRequirements:
        'The password must contain at least 8 characters, one uppercase letter, one lowercase letter, one number and one special character.',
      placeholders: {
        email: 'Enter your email',
        expiredPassword: 'Enter the current password',
        newPassword: 'Enter your new password',
      },
      messages: {
        successSummary: 'Password Changed Successfully',
        successDetail: 'Next time, log in with your email and new password',
        errorSummary: 'Error',
        errorDetail: 'Error changing password',
      },
      validation: {
        emailRequired: 'Email is required',
        expiredPasswordRequired: 'Current password is required',
        newPasswordMinLength: 'Password must have at least 8 characters',
        newPasswordUppercase: 'Password must contain at least one uppercase letter',
        newPasswordLowercase: 'Password must contain at least one lowercase letter',
        newPasswordNumber: 'Password must contain at least one number',
        newPasswordSpecial: 'Password must contain at least one special character',
        uppercase: 'Uppercase and lowercase letters [A-Z]',
        lowercase: 'Lowercase letters [a-z]',
        number: 'Numbers [0-9]',
        special: 'Special characters [!,@,#,$,%,^,&,* or *]',
        minLength: 'Minimum 8 characters',
      },
    },
  },
  forms: {
    firmware: {
      title: 'Firmware Version',
      detailsFirmware: 'Details of Firmware: ',
      crcHexInfo: 'Hex value in decimal: ',
      fields: {
        crc: 'CRC (Hex or Decimal)',
        firmwareForSMC: 'Firmware for SMC',
        nameFirmware: 'Version name:',
        manufacturer: 'Manufacturer:',
      },
      validation: {
        crcRequired: 'CRC is required',
        crcPrefixError: 'Remove the 0x or space before the hexadecimal number',
        crcInvalidError: 'Invalid value. Enter only decimal or hexadecimal numbers (0-9, A-F)',
        crcImmutableInfo: 'The CRC cannot be changed after creation',
        nameFirmwareRequired: 'Version name is required',
        manufacturerRequired: 'Manufacturer is required',
      },
      actions: {
        registerFirmware: 'Register',
        editFirmware: 'Edit firmware',
        deleteFirmware: 'Delete firmware',
        deleteConfirmationTitle: 'Confirm deletion of firmware in bulk',
        cancel: 'Cancel',
      },
      placeholder: {
        crc: 'Enter the CRC',
        nameFirmware: 'Enter the version name',
        selectManufacturer: 'Select a manufacturer',
        loadingManufacturers: 'Loading manufacturers...',
      },
    },
    keys: {
      title: 'Register key',
      titleEdit: 'Modify Key',
      fields: {
        serial: 'Serial',
        authenticationKey: 'Authentication Key',
        encryptionKey: 'Encryption Key',
        masterKey: 'Master Key',
        lls2: 'LLS2',
        usSecret: 'US Secret (optional)',
        mrSecret: 'MR Secret (optional)',
        fuSecret: 'FU Secret (optional)',
      },
      validation: {
        fieldRequired: 'This field is required!',
        serialImmutableInfo: 'The Serial cannot be changed after creation',
        keySize: 'This field must contain 32 characters.',
        lls2Size: 'This field must contain 16 (gateway) or 20 (meter) characters.',
      },
      actions: {
        cancel: 'Cancel',
        create: 'Register',
        update: 'Update',
        save: 'Save',
      },
    },
    tags: {
      title: 'New Tag',
      titleDetails: 'Tag Details: ',
      fields: {
        name: 'Name',
        colors: 'Colors',
      },
      actions: {
        create: 'Create tag',
        update: 'Edit tag',
        delete: 'Delete tag',
        cancel: 'Cancel',
        deleteConfirmationTitle: 'Confirm deletion of tag in bulk',
      },
      validation: {
        fieldRequired: 'This field is required!',
      },
    },
    smcs: {
      title: 'Register new SMC',
      titleEdit: 'Edit SMC',
      fields: {
        serial: 'SMC Serial',
        description: 'Description',
        manufacturer: 'Manufacturer',
        model: 'Model',
        latitude: 'Latitude',
        longitude: 'Longitude',
      },
      validation: {
        serialRequired: 'Serial is required',
        serialNoSpaces:
          'The SMC serial cannot contain spaces at the beginning, in the middle, or at the end.',
        descriptionRequired: 'Description is required',
        manufacturerRequired: 'Manufacturer is required',
        modelRequired: 'Model is required',
        warningDialogTittle: 'Are you sure you want to mark the selected alarms as read?',
        warningDialogMessage:
          "Upon confirmation, a ticket will be automatically generated containing the responsible user's information for historical records.",
        warningDialogTittleSingle: 'Are you sure you want to mark this alarm as read?',
      },
      actions: {
        cancel: 'Cancel',
        create: 'Create SMC',
        update: 'Update',
        confirm: 'Confirm',
      },
      placeholders: {
        serial: 'Enter SMC serial',
        description: 'Enter SMC description',
        manufacturer: 'Enter manufacturer name',
        model: 'Select model',
        latitude: 'Enter latitude',
        longitude: 'Enter longitude',
      },
    },
    clients: {
      title: 'Register new client',
      titleEdit: 'Edit client',
      fields: {
        fullName: 'Full name',
        location: 'Location',
        weights: 'Weights',
        prefixUf: 'UF Prefix',
        selectAvailableMeters: 'Select Available Meters',
      },
      validation: {
        fullNameRequired: 'Full name is required',
        locationRequired: 'Location is required.',
        weightsInvalidFormat:
          'Enter weights with a single digit per position, separated by comma, space, or semicolon.',
        weightsInvalidLength: 'Invalid weights count. Accepted values: 6, 7, or 10 digits.',
        prefixUfRequired: 'UF Prefix is required.',
        prefixUfInvalid: 'Enter a valid UF Prefix.',
      },
      actions: {
        cancel: 'Cancel',
        create: 'Register',
        update: 'Update',
      },
    },
    tariffs: {
      dateStart: 'Initial Date',
      select: 'Select Tariff Type',
      dateActivation: 'Activation Date',
      send: 'Send',
    },
    models: {
      title: 'Register new model',
      titleEdit: 'Edit model',
      fields: {
        name: 'Name',
        manufacturer: 'Manufacturer',
        positionsCount: 'Positions count',
      },
      validation: {
        nameRequired: 'Name is required',
        manufacturerRequired: 'Manufacturer is required',
      },
      actions: {
        cancel: 'Cancel',
        create: 'Create',
        update: 'Save',
      },
      placeholder: {
        name: 'Enter the model name',
        selectManufacturer: 'Select the manufacturer',
        loadingManufacturers: 'Loading manufacturers...',
        positionsCount: 'Positions count',
      },
    },
  },
  tables: {
    noData: 'No data found',
    general: {
      search: 'Quick Search',
      status: 'Status',
      period: 'Period',
      dateRange: 'Date Range',
      dateRangeError: 'Select a valid date range.',
      quickOptions: 'Quick options',
      quickOptionsHint: 'select a suggested period',
      commands: 'Commands',
      searchByEmail: 'Search by email',
      searchBySerial: 'Search by serial',
      selectColumns: 'Select columns:',
      selectCommands: 'Select the commands',
      selectionLimitSummary: 'Selection limit',
      alarmTypesSelectionLimitDetail: 'You can select up to 5 alarm types.',
      commandsSelectionLimitSummary: 'Selection limit',
      commandsSelectionLimitDetail: 'You can select up to 5 commands.',
      commandsSelectionRequiredSummary: 'Warning',
      commandsSelectionRequiredDetail: 'Select at least one command.',
      selectStatus: 'Select status:',
      searchByText: 'Search by text',
      commissioning: 'Commissioning',
      gatewayName: 'Gateway Name',
      gatewaySerial: 'Gateway Serial',
      typeSignalQuality: 'Signal Type',
      type: 'Type',
      details: 'Details',
      tags: 'Tags',
      selectTags: 'Select tags',
      selectOption: 'Select an option',
      cleanFilters: 'Clear Filters',
      addFilter: 'Add Filter',
      all: 'All',
      error: 'Error',
      totalRecords: 'Total records: {totalRecords}',
      yes: 'Yes',
      no: 'No',
      placeholders: {
        search: 'Search',
        searchByText: 'Search here',
        gatewayName: 'Gateway Name',
        gatewaySerial: 'Gateway Serial',
        commissioning: 'Select commissioning',
        period: 'Select period',
        type: 'Select type',
        typeSignalQuality: 'Select signal type',
        selectColumns: 'Select columns',
      },
      tableChart: {
        showAll: 'Show all',
        showLess: 'Show less',
        displayedColumns: 'Displayed columns:',
        monoChartDisplayedColumns: 'Charts:',
      },
    },
    meterFileUpload: {
      massMemory: {
        dateTime: 'Reading date/time',
        totalEnergy_Wh: 'General totalizer (Wh)',
        totalEnergyIncremental_Wh: 'Incremental totalizer (Wh)',
        q1ReactiveEnergy_VarH: 'Reactive energy Q1 (VarH)',
        q4ReactiveEnergy_VarH: 'Reactive energy Q4 (VarH)',
        group2VoltageVaH_V: 'Voltage Va (V)',
        group2VoltageVbH_V: 'Voltage Vb (V)',
        group2VoltageVcH_V: 'Voltage Vc (V)',
        group3CurrentIaH_A: 'Current Ia (A)',
        group3CurrentIbH_A: 'Current Ib (A)',
        group3CurrentIcH_A: 'Current Ic (A)',
        totalActiveEnergy_KWh: 'Total active energy (kWh)',
        totalInductiveReactiveEnergy_KVarh: 'Total inductive reactive energy (kvarh)',
        totalCapacitiveReactiveEnergy_KVarh: 'Total capacitive reactive energy (kvarh)',
        totalReverseActiveEnergy_KWh: 'Total reverse active energy (kWh)',
        reactiveEnergyImportQiiiRi_KVarH: 'Reactive energy import Q3 +Ri (kvarh)',
        reactiveEnergyImportQiiRc_KVarH: 'Reactive energy import Q2 +Rc (kvarh)',
        q1ReactiveEnergyIncremental_VarH: 'Reactive energy Q1 incremental (kWh)',
        q4ReactiveEnergyIncremental_VarH: 'Reactive energy Q4 incremental (kWh)',
        totalActiveEnergy_Wh: 'Direct active energy (kWh)',
        totalDirectActiveEnergy_Wh: 'Total direct active energy (kWh)',
        borderTotalizer_Wh: 'Peak totalizer (kWh)',
        reservedTotalizer_Wh: 'Off-peak totalizer (kWh)',
        offBorderTotalizer_Wh: 'Reserved totalizer (kWh)',
        totalIntermediary_Wh: 'Intermediary total (kWh)',
        generatedEnergyTotal_Wh: 'Generated energy - total (kWh)',
        totalReverseActiveEnergy_Wh: 'Total reverse active energy (kWh)',
        totalDemand_W: 'Total active demand (W)',
        borderDemand_W: 'Peak active demand (W)',
        reservedDemand_W: 'Off-peak active demand (W)',
        totalApparentDemand_Va: 'Total apparent demand (VA)',
        borderApparentDemand_Va: 'Peak apparent demand (VA)',
        reservedApparentDemand_Va: 'Off-peak apparent demand (VA)',
        totalDemandIncremental_W: 'Total active demand incremental (W)',
        borderDemandIncremental_W: 'Peak active demand incremental (W)',
        reservedDemandIncremental_W: 'Off-peak active demand incremental (W)',
        demandResetCount: 'Demand reset count',
        demandResetTime: 'Demand reset time',
        demandResetTimeMs: 'Demand reset time (ms)',
        demandCurrentTime: 'Current demand time',
        demandCurrentTimeMs: 'Current demand time (ms)',
        voltageA: 'Voltage A (V)',
        voltageB: 'Voltage B (V)',
        voltageC: 'Voltage C (V)',
        currentA: 'Current A (A)',
        currentB: 'Current B (A)',
        currentC: 'Current C (A)',
        maximumCurrentA_A: 'Maximum current A (A)',
        activePowerA: 'Active power A (W)',
        activePowerB: 'Active power B (W)',
        activePowerC: 'Active power C (W)',
        lastAverageVoltageL1_V: 'Average voltage L1 (V)',
        lastAverageCurrentL1_A: 'Average current L1 (A)',
        lastAverageVoltageL2_V: 'Average voltage L2 (V)',
        lastAverageCurrentL2_A: 'Average current L2 (A)',
        lastAverageVoltageL3_V: 'Average voltage L3 (V)',
        lastAverageCurrentL3_A: 'Average current L3 (A)',
        totalPowerFactor_NoUnit: 'Total power factor',
      },
      quality: {
        dateTimeInitial: 'Initial date/time',
        dateTimeFinal: 'Final date/time',
        description: 'Description',
        drp: 'DRP (%)',
        drc: 'DRC (%)',
        dtt95: 'DTT95 (%)',
        fd95: 'FD95 (%)',
      },
      energy: {
        dateTime: 'Date/time',
        totalEnergy_Wh: 'Total active energy (Wh)',
        borderTotalizer_Wh: 'Peak totalizer (Wh)',
        reservedTotalizer_Wh: 'Reserved totalizer (Wh)',
        offBorderTotalizer_Wh: 'Off-peak totalizer (Wh)',
        totalIntermediary_Wh: 'Intermediary totalizer (Wh)',
        generatedEnergyTotal_Wh: 'Generated energy total (Wh)',
        totalReverseActiveEnergy_Wh: 'Total reverse active energy (kWh)',
        totalInductiveReactiveEnergy_VarH: 'Total inductive reactive (VarH)',
        totalCapacitiveReactiveEnergy_VarH: 'Total capacitive reactive (VarH)',
        consumedMaximunDemand_W: 'Maximum consumed demand (W)',
        injectedMaximunDemand_W: 'Maximum injected demand (W)',
        positiveReactiveEnergy_Wh: 'Positive reactive energy (kWh)',
        negativeReactiveEnergy_Wh: 'Negative reactive energy (kWh)',
        forderTotalizer_Wh: 'Direct active energy T1 (kWh)',
        generatedOffBorderEnergyTotal_Wh: 'Generated off-peak active energy (kWh)',
        generatedIntermediaryEnergyTotal_Wh: 'Generated intermediary active energy (kWh)',
        generatedBorderEnergyTotal_Wh: 'Generated peak active energy (kWh)',
        generatedReservedEnergyTotal_Wh: 'Generated reserved active energy (kWh)',
      },
      alarms: {
        dateEvent: 'Event date',
        description: 'Description',
        serial: 'Serial',
        installation: 'Installation',
        terminal: 'Terminal',
      },
    },
    meters: {
      title: 'Meters',
      importMeters: 'Import Meters',
      importFromTo: 'Import From-To',
      editMeters: 'Edit Meters',
      linkTags: 'Link Tags',
      unlinkTags: 'Unlink Tags',
      commissioning: 'Commissioning',
      serial: 'Serial',
      installation: 'Installation',
      modemSignalQuality: 'Signal',
      accountantStatus: 'Status',
      updatedAt: 'Updated At',
      readingsCount: 'Readings Count',
      totalOfSent: 'Total of Sent',
      successOfSent: 'Success of Sent',
      failOfSent: 'Fail of Sent',
      deviceEui: 'Device Eui',
      meterPhase: 'Phase',
      manufacturer: 'Manufacturer',
      position: 'Position',
      commands: 'Commands',
      tags: 'Tags',
      firmware: 'Firmware',
      phase: 'Phase',
      communication: 'Communication',
      status: 'Status',
      fromTo: 'From-To',
    },
    smcs: {
      title: 'Smcs',
      serial: 'Serial',
      qtyMeters: 'Quantity',
      firmware: 'Firmware',
      comissioned: 'Commissioned',
      doorStatus: 'Door',
      online: 'Communication Status',
      smcModel: 'Model',
      signalQuality: 'Signal',
      updatedAt: 'Updated At',
    },
    alarms: {
      title: 'Alarms',
      serial: 'Serial',
      description: 'Description',
      dateTime: 'Date and Time',
      alarmType: 'Alarm Type',
      selectAlarmType: 'Select alarm type',
      terminal: 'Terminal',
      updatedAt: 'Updated At',
      isCritical: 'Critical Alarm',
      errors: {
        error: 'Error',
        incompleteMeterData: 'Incomplete meter data for export',
      },
    },
    smcAlarms: {
      title: 'Alarms of SMC',
      readDateTime: 'Reading Date and Time',
      description: 'Description',
      updatedAt: 'Last Update',
    },
    meterAlarms: {
      title: 'Alarms of Meters',
      readDateTime: 'Reading Date and Time',
      description: 'Description',
      updatedAt: 'Last Update',
      serial: 'Serial',
      terminal: 'Terminal',
    },
    alarmTypesMeter: {
      title: 'SMI/SMC Meter Events Table',
      description: 'Description',
      count: 'Count',
      wasRead: 'Reading Status',
      read: 'Read',
      unread: 'Unread',
      errorSearch: 'Error fetching alarm types',
    },
    alarmTypesSmc: {
      title: 'SMC Events Table',
      description: 'Description',
      count: 'Count',
      wasRead: 'Reading Status',
      read: 'Read',
      unread: 'Unread',
      errorSearch: 'Error fetching alarm types',
    },
    tickets: {
      title: 'Tickets',
      serial: 'Serial',
      commandType: 'Command',
      ticketStatus: 'Status of Ticket',
      selectTicketStatus: 'Select the status of the ticket',
      generatedBySystem: 'Generated by the system',
      statusCommand: 'Status of Command',
      lastUpdate: 'Last Update',
      initialDate: 'Initial Date',
      updatedAt: 'Updated At',
      serialMeter: 'Serial Meter',
      user: 'User',
      scheduledTickets: 'Scheduled Tickets',
      scheduledDate: 'Scheduled Date',
      company: 'Company',
      manufacturer: 'Manufacturer',
      deadline: 'Deadline',
      startDate: 'Start Date',
      trackingCode: 'Tracking Code',
      serviceType: 'Service Type',
      status: 'Status of SAP',
      commandTicket: {
        commandId: 'Command ID',
        commandType: 'Command Type',
        initialDate: 'Initial Date',
        finishDate: 'Finish Date',
        attempt: 'Attempt',
        messageSent: 'Message Sent',
        messageReceived: 'Message Received',
        messageError: 'Message Error',
        messageSuccess: 'Message Success',
        noResponse: 'No response',
        totalData: 'Total Data',
        saved: 'Saved',
        failedProcesses: 'Failed Processes',
        answerColumns: {
          answer: 'Answer',
          lineNumber: 'Line',
          operation: 'Operation',
          success: 'Success',
          message: 'Message',
          processedAt: 'Processed At',
          position: 'Answer Position',
          totalEnergy: 'Answer Total Energy',
          relayStatus: 'Answer Relay Status',
          accountantStatus: 'Relay status',
          serial: 'Serial',
          datetime: 'Date/Time',
          group2VoltageVaH_V: 'Voltage VaH(V)',
          group3CurrentIaH_A: 'Current IaH(A)',
          group2VoltageVbH_V: 'Voltage VbH(V)',
          group3CurrentIbH_A: 'Current IbH(A)',
          group2VoltageVcH_V: 'Voltage VcH(V)',
          group3CurrentIcH_A: 'Current IcH(A)',
          group4AngleUiA_deg: 'Angle UiA (º)',
          group4AngleUiB_deg: 'Angle UiB (º)',
          group4AngleUiC_deg: 'Angle UiC (º)',
          index: 'Index',
          specialDayDate: 'Special day date',
          dayOfWeek: 'Day of week',
          dayId: 'Day ID',
          meterId: 'Meter ID',
          type: 'Type',
          name: 'Name',
          description: 'Description',
          time: 'Time',
          tariffType: 'Tariff type',
          dailyTariffs: 'Daily tariffs',
          hourlyTariffs: 'Hourly tariffs',
          drmcDailyTariffs: 'DMCR daily tariffs',
          drmcHourlyTariff: 'DMCR hourly tariffs',
          dmcrType: 'DMCR type',
          hourlyDMCRs: 'Hourly DMCRs',
          meterProfileId: 'Meter profile ID',
          meterDMCRProfileId: 'Meter DMCR profile ID',
          startDate: 'Start date',
          endDate: 'End date',
          deviation: 'Deviation',
          isEnable: 'Enabled',
          enabled: 'Enabled',
          saturdayInductive: 'Saturday inductive',
          saturdayCapacitive: 'Saturday capacitive',
          sundayInductive: 'Sunday inductive',
          sundayCapacitive: 'Sunday capacitive',
          workdayInductive: 'Workday inductive',
          workdayCapacitive: 'Workday capacitive',
          holidayInductive: 'Holiday inductive',
          holidayCapacitive: 'Holiday capacitive',
          timeToActivate: 'Time to activate',
          daylightEndDatetime: 'Daylight saving end date/time',
          daylightBeginDatetime: 'Daylight saving start date/time',
        },
      },
    },
    frozenData: {
      title: 'Energy',
      recoverButton: 'Request Energy Totals',
      errors: {
        error: 'Error',
        incompleteMeterData: 'Incomplete meter data for export',
      },
    },
    massMemory: {
      title: 'Mass Memory',
      recoverButton: 'Request Mass Memory',
      errors: {
        error: 'Error',
        incompleteMeterData: 'Incomplete meter data for export',
      },
    },
    tableFiscalFasional: {
      title: 'Fiscal Page',
    },
    billing: {
      title: 'Billing History',
      billing: 'Billing',
      stageCode: 'Stage',
      stageDay: 'Day',
      dateSent: 'Sent on',
      status: 'Status',
      type: 'Type',
      typeCode: 'Type Code',
      readingDate: 'Reading Date',
      readingValue: 'Reading Value',
      registers: 'Registers',
    },
    eventLogs: {
      title: 'Event Logs',
      dateTime: 'Date and Time',
      message: 'Message',
      logLevel: 'Log Level',
      logs: {
        critical: 'Critical',
        debug: 'Debug',
        error: 'Error',
        trace: 'Detailed ( Only Debug )',
        warning: 'Warning',
        none: 'No Message',
        information: 'Information',
      },
      errors: {
        getEventLogs: 'Error getting event logs',
        serialRequired: 'Serial is required',
      },
    },
    alarmVoltage: {
      titleShortDuration: 'Short Interruption Duration Alarms',
      titleLongDuration: 'Long Interruption Duration Alarms',
      calculateInterruptionIndicators: 'Calculate Interruption Indicators',
      referenceMonth: 'Reference Month',
      calculate: 'Calculate',
      fic: 'FIC',
      dic: 'DIC',
      hours: 'Hours',
      hundredthHour: 'Hundredths of Hours',
      minutes: 'Minutes',
      ficTooltip: 'Frequency of Individual Interruption by Consumer Unit or Connection Point',
      dicTooltip:
        'Duration of Individual Interruption by Consumer Unit or Connection Point expressed in Hours',
      dicHundredthHourTooltip:
        'Duration of Individual Interruption by Consumer Unit or Connection Point expressed in Hundredths of Hours',
      dateTime: 'Reading Date',
      voltageOut: 'Voltage',
      createdAt: 'Created At',
      dateTimeStart: 'Start Date and Time',
      dateTimeEnd: 'End Date and Time',
      timeVariation: 'Time Variation',
    },
    alarmsMeters: {
      title: 'Alarms of Meters',
    },
    qeeIndicators: {
      title: 'Quality Parameters',
      monthlyAverage: 'Monthly Average',
      recoverQualityParams: 'Recover Quality Parameters',
      calculateMonthlyAverage: 'Calculate Monthly Average',
      dateAndTimeInitial: 'Initial Date',
      dateAndTimeFinal: 'Final Date',
      referenceMonth: 'Month of Reference',
      meterStatus: 'Meter Status',
      onlineStatus: 'Online Status',
      description: 'Description',
      commissioned: 'Commissioned',
      dateTime: 'Fecha y hora',
      drp: 'DRP',
      drc: 'DRC',
      dic: 'DIC',
      fic: 'FIC',
      dmic: 'DMIC',
      dmicOccurrenceTime: 'DMIC Occurrence Time',
      noInformation: 'No Information',
      dialog: {
        referenceMonth: 'Reference Month',
        quantityOfSamples: 'Desired Number of Samples',
        initialDate: 'Set Start Date',
        endDate: 'Set End Date',
        drp: 'DRP',
        drc: 'DRC',
        dtt95: 'DTT95',
        fd95: 'FD95',
        drcPhaseA: 'DRC Phase A',
        drpPhaseA: 'DRP Phase A',
        drcPhaseB: 'DRC Phase B',
        drpPhaseB: 'DRP Phase B',
        drcPhaseC: 'DRC Phase C',
        drpPhaseC: 'DRP Phase C',
        calculate: 'Calculate',
        cancel: 'Cancel',
        request: 'Request',
        requestSentTitle: 'Request Sent',
        requestSentSuccess: 'Monthly average requested successfully',
        requestSentError: 'Could not request Monthly Average',
        relayOff: 'Relay off',
        relayOffDescription: 'Could not request the monthly average for this meter',
        noQualityParametersFound: 'No quality parameters were found for this meter',
      },
      placeholders: {
        referenceMonth: 'Select the reference month',
      },
      errors: {
        incompleteMeterData: 'Incomplete meter data for export',
      },
    },
    instantMeasure: {
      title: 'Instant Measurements',
      requestMeasure: 'Request Measurements',
      readingTime: 'Reading Time',
      voltageVa: 'Voltage Va (V)',
      voltageVb: 'Voltage Vb (V)',
      voltageVc: 'Voltage Vc (V)',
      currentIa: 'Current Ia (A)',
      currentIb: 'Current Ib (A)',
      currentIc: 'Current Ic (A)',
      angleUiA: 'Angle Ui A (º)',
      angleUiB: 'Angle Ui B (º)',
      angleUiC: 'Angle Ui C (º)',
    },
    firmware: {
      lastUpdate: 'Last Update',
      crc: 'CRC',
      name: 'Name',
      manufacturer: 'Manufacturer',
    },
    keys: {
      lastUpdate: 'Last Update',
      serial: 'Serial',
      authenticationKey: 'Authentication Key',
      encryptionKey: 'Encryption Key',
      masterKey: 'Master Key',
      lls2: 'LLS2',
    },
    tags: {
      lastUpdate: 'Last Update',
      tagId: 'Tag ID',
      name: 'Name',
      colorCode: 'Color (Hex Code)',
      colors: 'Colors',
    },
    models: {
      name: 'Name',
      manufacturer: 'Manufacturer',
      positionsCount: 'Positions count',
    },
    clients: {
      title: 'Clients',
      newClient: 'New Client',
      deleteClients: 'Delete Clients',
      name: 'Name',
      location: 'Location',
      statusActive: 'Active',
      quantityMeterSerials: 'Quantity of Meters',
      updatedAt: 'Last update',
      weights: 'Weights',
      prefixUf: 'UF Prefix',
    },
    process: {
      title: 'Processes',
      processId: 'Process ID',
      processType: 'Process Type',
      user: 'User',
    },
    balanceDevices: {
      title: 'Balance of Devices',
      trafo: 'Trafo',
      device: 'Device',
      initialDate: 'Initial Energy Consumption Date',
      initialReading: 'Initial Energy Consumption (kWh)',
      finalDate: 'Final Energy Consumption Date',
      finalReading: 'Final Energy Consumption (kWh)',
      consumption: 'Consumption (kWh)',
      energyInjectedConsumers: 'Injected Energy (kWh)',
      energyReverseTransformer: 'Reverse Energy (kWh)',
    },
    balanceTransformers: {
      title: 'Balance of Transformers',
      date: 'Date',
      nameTrafo: 'Transformer Name',
      trafoMeter: 'Transformer Meter',
      energyRequired: 'Energy Required (kWh)',
      energyConsumed: 'Energy Consumed (kWh)',
      loss: 'Loss (kWh)',
      streetLighting: 'Public Lighting Energy (kWh)',
      lossPercentage: 'Loss %',
    },
    balanceAreasRegions: {
      title: 'Balance of Areas',
      data: 'Data',
      nameArea: 'Area Name',
      energyRequired: 'Energy Required (kWh)',
      energyConsumed: 'Energy Consumed (kWh)',
      loss: 'Loss (kWh)',
      streetLighting: 'Public Lighting Energy (kWh)',
      lossPercentage: 'Loss %',
    },
    transformers: {
      title: 'Transformers',
      newTransformer: 'New Transformer',
      deleteTransformers: 'Delete Transformers',
      name: 'Name',
      description: 'Description',
      publicLighting: 'Public Lighting Monthly (kWh)',
      trafoMeter: 'Transformer Meter',
      connected: 'Connected',
      latLong: 'Lat/Long',
      updatedAt: 'Last Update',
      errorSearch: 'Error searching Transformers',
      noTransformerSelected: 'No transformer selected',
    },
    scheduledCommands: {
      group: 'Group',
      command: 'Command',
      executionTime: 'Execution Time',
      status: 'Status',
      nextExecution: 'Next Execution',
      active: 'Active',
      paused: 'Paused',
      pausedScheduling: 'Paused Scheduling',
      scheduling: 'schedule',
      errorSearch: 'Error fetching schedules',
      noScheduleSelected: 'No schedule selected',
      noSchedule: 'No schedule registered',
      deleteSchedule: 'Schedule Deletion',
      newRoutine: 'Schedule Command',
    },
    lowEffectiveness: {
      title: 'Low Effectiveness Locations',
      locationCode: 'Location Code',
      regionCode: 'Region Code',
      estado: 'State',
      cidade: 'City',
      totalMeters: 'Total Meters',
      lowEffectivenessMeters: 'Low Effectiveness Meters',
      lowEffectivenessPercent: 'Low Effectiveness Percentage',
      effectivenessPercent: 'Effectiveness Percentage',
      errorSearch: 'Error searching low effectiveness locations',
      tabs: {
        state: 'By State',
        city: 'By City',
      },
    },
    unavailabilityPeak: {
      title: 'Unavailability Peak',
      meter: 'Meter',
      consumerUnit: 'Consumer Unit',
      locationCode: 'Location Code',
      regionCode: 'Region Code',
      manufacturer: 'Manufacturer',
      unavailableDays: 'Unavailable Days',
      totalDays: 'Total Days',
      unavailabilityPercent: 'Unavailability Percentage',
      availabilityPercent: 'Availability Percentage',
      errorSearch: 'Error searching unavailability peaks',
    },
    areas: {
      title: 'Areas',
      newArea: 'New Area',
      name: 'Name',
      description: 'Description',
      transformersCount: 'Transformers Count',
      updatedAt: 'Last Update',
      deleteAreas: 'Delete Areas',
      errors: {
        title: 'Error',
        loadAreaInfo: 'Error loading area information',
        noAreaSelected: 'No area selected',
      },
      areasTransformers: {
        title: 'Transformers of Area',
        manageTransformers: 'Manage Transformers',
        name: 'Name',
        serialMeter: 'Serial Meter',
        metersCount: 'Meters Count',
        publicLighting: 'Public Lighting',
        coordinates: 'Coordinates',
        updatedAt: 'Last Update',
      },
    },
    regions: {
      title: 'Regions',
      newRegion: 'New Region',
      deleteRegions: 'Delete Regions',
      name: 'Name',
      description: 'Description',
      areasCount: 'Areas Count',
      updatedAt: 'Last Update',
      errors: {
        title: 'Error',
        loadRegions: 'Error loading regions',
        noRegionSelected: 'No region selected',
      },
    },
    regionsAreas: {
      title: 'Areas of Region',
      manageAreas: 'Manage Areas',
      name: 'Name',
      description: 'Description',
      transformersCount: 'Transformers Count',
      updatedAt: 'Last Update',
    },
    transformerMeters: {
      title: 'Transformers Meters',
      importMeters: 'Import meters by file',
      removeMeters: 'Remove meters by file',
      manageMeters: 'Manage meters',
      importNameModal: 'meter-model-by-transformer-registration',
      removeNameModal: 'meter-model-by-transformer-removal',
      meter: 'meter(s)',
      success: {
        registerMeters: 'Meters registered successfully',
        removeMeters: 'Meters removed successfully',
      },
      errors: {
        registerMeters: 'Error registering meters',
        removeMeters: 'Error removing meters',
        metersNotRegistered: 'meter(s) could not be registered',
        unknownReason: 'Unknown reason',
      },
      warnings: {
        partialSuccess: 'Partial meter registration',
        metersNotUpdated: 'meter(s) were not updated',
      },
    },
  },
  echarts: {
    noteType: {
      title: 'Service Type',
      services: 'Services',
      regions: 'Regions',
      manufactures: 'Manufacturers',
    },
    sapStatus: {
      title: 'SAP Status',
      services: 'Services',
      regions: 'Regions',
      manufactures: 'Manufacturers',
    },
    requestStatus: {
      title: 'Command Status',
      status: 'Status',
      services: 'Services',
      regions: 'Regions',
      manufactures: 'Manufacturers',
    },
    eqtlIntegrationByCompany: {
      title: 'Daily Integration by Company',
      success: 'Success',
      failure: 'Failure',
      serviceType: 'Service Type',
      cleanFilter: 'Clean Filter',
      addFilter: 'Add Filter',
    },
    integrationDaily: {
      title: 'Daily Integration',
      success: 'Success',
      failure: 'Failure',
      select: 'Select a Distributor',
      company: 'Distributor',
      serviceType: 'Service Type',
    },
    failedNotesByCategory: {
      title: 'Failed Notes by Category',
    },
    failedNotesByCategoryDaily: {
      title: 'Failed Notes by Category (Daily)',
    },
    specificFailedNotes: {
      title: 'Specific Failed Notes',
    },
    table: {
      title: 'Column listing',
      createdAt: 'Created at',
      updatedAt: 'Updated at',
      startDate: 'Start date of execution',
      actionType: 'Action type',
      status: 'Status',
      company: 'Region',
      manufacturer: 'Manufacturer',
      meterSerial: 'Serial',
      trackingCode: 'Tracking',
    },
    effectiveness: {
      title: 'Effectiveness and Availability',
      manufacturers: 'Manufacturers',
      manufacturersPlaceholder: 'Select the manufacturers',
      networkTech: 'Network Technology',
      cityOrState: 'City / State',
      cityOrStatePlaceholder: 'Enter city/state name',
      state: 'State',
      statePlaceholder: 'Select the state',
      city: 'City',
      cityPlaceholder: 'Select the city',
      quickOptions: 'Quick options:',
      quickOptionsHint: 'Maximum of 30 days',
      lastDays: 'Last {count} days',
      meterRegion: {
        serial: 'Serial',
        regionCode: 'Region Code',
        districtCode: 'District Code',
        sectionCode: 'Section Code',
        locationTypeCode: 'Location Type Code',
        locationCode: 'Location Code',
        fullAddress: 'Full Address',
        city: 'City',
        feeder: 'Feeder',
        districtName: 'District Name',
        neighborhood: 'Neighborhood',
        regional: 'Regional',
        sectional: 'Sectional',
      },
    },
    process: {
      title: 'Status',
      success: 'Success',
      failed: 'Failed',
      waiting: 'Waiting',
      executing: 'Executing',
      scheduled: 'Scheduled',
    },
    status: {
      title: 'Status',
      statusOnline: 'Online',
      statusOffline: 'Offline',
      statusAbsent: 'Absent',
    },
    commission: {
      title: 'Commissioning',
      commissionOn: 'Commissioned',
      commissionOff: 'Not Commissioned',
      commissionOns: 'Commissioned',
      commissionOffs: 'Not Commissioned',
    },
    situation: {
      title: 'Situation',
      disabled: 'Disconnected',
      activated: 'Connected',
      noRelay: 'No Relay',
      noInformation: 'No Information',
      titleNoMeters: 'Table of Situation - Meters',
    },
    billing: {
      title: 'Information about billing',
      status: 'Status',
      success: 'Success',
      noReadings: 'No readings',
      noReadingsDescription: 'No readings available for billing.',
      withReadings: 'With readings',
      withReadingsDescription:
        'There were readings, but an error occurred when sending them to the commercial system.',
      withoutStage: 'Without stage',
      withoutStageDescription: 'There is no billing stage assigned to this meter yet.',
      scheduled: 'Scheduled',
      scheduledDescription: 'Billing scheduled for a future date within the defined period.',
      notStarted: 'Billing not started',
      notStartedDescription: 'The billing date has passed and the process was not executed.',
      successDescription: 'Billing performed successfully, without errors.',
    },
    signalQuality: {
      signal: 'Signal',
      title: 'Signal Quality',
      period: 'Period',
      dateRange: 'Date Range',
      fiveBars: '5 Bars',
      fourBars: '4 Bars',
      threeBars: '3 Bars',
      twoBars: '2 Bars',
      oneBar: '1 Bar',
      unregistered: 'Unregistered',
      metersWith: 'Meters with',
    },
    commandsSent: {
      title: 'Commands Sent',
    },
    statusCommand: {
      title: 'All Commands',
      noData: 'No data...',
    },
    alarmStatisticMeter: {
      title: 'SMI/SMC Meter Events',
      read: 'Read',
      unread: 'Unread',
    },
    alarmStatisticSmc: {
      title: 'SMC Events',
      read: 'Read',
      unread: 'Unread',
    },
    fiscalPage: {
      title: 'Fiscal Page',
      noData: 'No data available',
      noDataOnInterval: 'There is no data for the selected range',
      noDataChart: 'No data',
      requestFiscalPage: 'Request Fiscal Page',
      value: 'Value',
      phaseA: 'Phase A',
      phaseB: 'Phase B',
      phaseC: 'Phase C',
      packageDate: 'Package Date',
      frequency: 'Frequency (Hz)',
      voltage: 'Voltage (V)',
      angleVI: 'Angle VI (°)',
      angleVoltage: 'Angle Voltage (°)',
      anglePhase: 'Angle Phase (AB/BC/CA °)',
      current: 'Current',
      currentAngle: 'Angle Current (°)',
      activePower: 'Active Power (W)',
      reactivePower: 'Reactive Power (VAR)',
      powerFactor: 'Power Factor',
      legend: {
        angVoltageA: 'Angle Voltage A',
        angVoltageB: 'Angle Voltage B',
        angVoltageC: 'Angle Voltage C',
        angVIA: 'Angle VI A',
        angVIB: 'Angle VI B',
        angVIC: 'Angle VI C',
        angPhaseAB: 'Angle Phase AB',
        angPhaseBC: 'Angle Phase BC',
        angPhaseCA: 'Angle Phase CA',
        angPhaseAC: 'Angle Phase AC',
        currentAngleA: 'Angle Current A',
        currentAngleB: 'Angle Current B',
        currentAngleC: 'Angle Current C',
      },
    },
  },
  notifications: {
    effectiveness: {
      success: {
        updateConfig: 'Effectiveness configuration updated successfully!',
      },
      error: {
        updateConfig: 'Failed to update effectiveness configuration.',
        getConfig: 'Failed to fetch effectiveness configuration.',
      },
    },
    averageVariation: {
      success: {
        updateConfig: 'Configuration updated successfully!',
      },
      error: {
        updateConfig: 'Failed to update configuration.',
        getConfig: 'Failed to fetch configuration.',
      },
    },
    tickets: {
      success: {
        getTickets: 'Tickets searched successfully',
      },
      error: {
        getTickets: 'Error searching Tickets',
      },
    },
    fiscalPage: {
      success: {
        getFiscalPage: 'Fiscal page recovered successfully',
      },
      error: {
        getFiscalPage: 'Error recovering fiscal page',
      },
    },
    recoverEnergy: {
      success: {
        recoverEnergy: 'Energy totals recovered successfully',
      },
      error: {
        recoverEnergy: 'Error recovering energy totals',
      },
    },
    recoverMassMemory: {
      success: {
        recoverMassMemory: 'Mass memory requested successfully',
      },
      error: {
        recoverMassMemory: 'Error requesting mass memory',
      },
    },
    onlineHistoryInterval: {
      success: {
        updateConfig: 'Intervalo atualizado com sucesso!',
      },
      error: {
        updateConfig: 'Falha ao atualizar o intervalo',
        getConfig: 'Falha ao buscar a configuração de intervalo.',
      },
    },
  },
  dialogs: {
    deleteMass: {
      title: 'Confirm deletion in bulk',
      message: 'Are you sure you want to delete the selected items?',
      confirmButton: 'Yes, delete',
      cancelButton: 'Cancel',
    },
    recoverByRangeDate: {
      title: 'Send command',
      description: 'Select the date range',
      placeholder: 'Date range',
      confirmButton: 'Request',
      cancelButton: 'Cancel',
    },
    importModal: {
      downloadModel: 'Download Model',
      chooseFile: 'Choose File',
      fileNotSelected: 'File not selected',
      validateFile: 'Validate File',
      importItems: 'Import Items',
      viewValidatedItems: 'View Validated Items',
      viewIgnoredItems: 'View Ignored Items',
      serialWhitespaceError:
        'The serial cannot contain spaces at the beginning, in the middle, or at the end. Invalid rows: {rows}.',
    },
    gatewayForm: {
      createTitle: 'Gateway Registration',
      editTitle: 'Edit Gateway',
      name: 'Name:',
      nameRequired: 'Name is required',
      serial: 'Serial:',
      serialRequired: 'Serial is required',
      ipAddress: 'IP Address:',
      ipInvalid: 'Invalid IP',
      port: 'Port:',
      description: 'Description:',
      cancel: 'Cancel',
      confirm: 'Confirm',
      successTitle: 'Success',
      errorTitle: 'Error',
      createSuccess: 'Gateway added',
      createError: 'Error creating Gateway: {message}',
      updateSuccess: 'Gateway updated',
      updateErrorTitle: 'Error updating Gateway',
    },
    groupCreateModal: {
      title: 'Create Group',
      name: 'Name',
      description: 'Description',
      tags: 'Tags',
      tagsPlaceholder: 'Select the tags',
      meters: 'Meters',
      cancel: 'Cancel',
      create: 'Create Group',
      position: 'Position',
      relayStatus: 'Relay Status',
      communicationStatus: 'Communication Status',
      deviceEui: 'Device EUI',
      firmwareVersion: 'Firmware Version',
      phase: 'Phase',
      commandStatus: 'Command Status',
      installation: 'Installation',
      manufacturer: 'Manufacturer',
      serial: 'Serial',
      commands: 'Commands',
      updatedAt: 'Last Update',
      createdTitle: 'Group created',
      createdDetail: 'Group created successfully',
    },
    deleteGroupModal: {
      title: 'Delete Groups',
      cancel: 'Cancel',
      confirm: 'Delete Groups',
      noneSelected: 'No group selected',
      confirmQuestion: 'Are you sure you want to delete the groups',
      deletedTitle: 'Group {name} deleted',
      deletedDetail: 'Group deleted successfully',
      deleteErrorTitle: 'Error deleting group {name}',
      deleteErrorDetail: 'Error deleting group',
    },
    massCommandsToMeters: {
      title: 'Mass Commands',
      steps: {
        search: 'Search',
        validate: 'Validate',
        commands: 'Commands',
        parameters: 'Parameters',
      },
      tabs: {
        search: 'By Search',
        import: 'By Import',
      },
      searchPlaceholder: 'Search',
      searchTypePlaceholder: 'Search Type',
      searchTypes: {
        serial: 'Serial',
        installation: 'Installation',
        manufacturer: 'Manufacturer',
      },
      relayStatusPlaceholder: 'Relay Status',
      noSerialFound: 'No Serial Found',
      next: 'Next',
      back: 'Back',
      actions: 'Actions',
      startDate: 'Start Date',
      endDate: 'End Date',
      startDateParam: 'Start Date (Parameter)',
      endDateParam: 'End Date (Parameter)',
      sendingCommand: 'Sending Command',
      selectParameters: 'Select Parameters',
      sendCommand: 'Send Command',
      intervalPlaceholder: 'Select the interval',
      valuesPlaceholder: 'Select the values',
      minutes: '{count} Minutes',
    },
    massTagsToMeters: {
      linkTitle: 'Link Tags',
      unlinkTitle: 'Unlink Tags',
      steps: {
        tags: 'Tags',
        import: 'Import',
      },
      tagsPlaceholder: 'Select tags',
      selectTagsHint: 'Select at least one tag to continue.',
      next: 'Next',
      back: 'Back',
      selectedTagsCount: '{count} tag(s) selected.',
      finishLink: 'Finish linking',
      finishUnlink: 'Finish unlinking',
      noFileSelected: 'No file selected.',
      emptySerialError: 'The file contains rows with an empty Serial field.',
      fileValidatedSuccess: 'File validated successfully',
      fileValidatedWithIgnored:
        'File validated successfully, but {count} invalid row(s) were ignored.',
      fileProcessError: 'Error processing file',
      noValidSerials: 'No valid serial was found in the file.',
      linkError: 'Could not link tags to meters.',
      unlinkError: 'Could not unlink tags from meters.',
      success: {
        linksCreated: '{affectedLinks} link(s) created on {processedMeters} meter(s).',
        linksRemoved: '{affectedLinks} link(s) removed from {processedMeters} meter(s).',
        notFoundSerials: '{count} serial(s) not found.',
        notFoundTagIds: '{count} tag(s) not found.',
      },
    },
    dialogTransformer: {},
    dialogArea: {
      titleNewArea: 'New Area',
      titleEditArea: 'Edit Area',
      name: 'Name',
      fieldRequired: 'This field is required!',
      description: 'Description',
      delete: 'Delete',
      cancel: 'Cancel',
      modify: 'Modify',
      register: 'Register',
      success: {
        title: 'Success',
        createArea: 'Area created successfully!',
        updateArea: 'Area updated successfully!',
      },
      error: {
        title: 'Error',
        createArea: 'Error creating area',
        updateArea: 'Error updating area',
      },
    },
    dialogRegion: {
      editRegion: 'Edit Region',
      createRegion: 'Create Region',
      title: 'Manage transformers of region',
      name: 'Name',
      fieldRequired: 'This field is required!',
      description: 'Description',
      deleteRegion: 'Delete',
      cancel: 'Cancel',
      modify: 'Modify',
      register: 'Register',
      success: {
        title: 'Success',
        createRegion: 'Region created successfully!',
        updateRegion: 'Region updated successfully!',
      },
      error: {
        title: 'Erro',
        createRegion: 'Error creating region',
        updateRegion: 'Error updating region',
      },
    },
    dialogNewEditAreasInRegion: {
      title: 'Manage areas of region',
      areasInRegion: 'Areas of Region',
      total: 'Total',
      availableAreas: 'Available Areas',
      available: 'Available',
      selected: 'Selected',
      removeAreas: 'Remove Areas',
      addAreas: 'Add Areas',
      exit: 'Exit',
      name: 'Name',
      description: 'Description',
      transformersCount: 'Transformers Count',
      updatedAt: 'Last Update',
      success: {
        title: 'Success',
        addAreas: 'Areas added successfully!',
        removeAreas: 'Areas removed successfully!',
      },
      errors: {
        title: 'Error',
        loadAvailableAreas: 'Error loading available areas',
        addAreas: 'Error adding areas to region',
        removeAreas: 'Error removing areas from region',
      },
    },
    dialogNewEditTransformersInArea: {
      title: 'Manage transformers of area',
      transformersInArea: 'Transformers in Area',
      total: 'Total',
      availableTransformers: 'Available Transformers',
      available: 'Available',
      selected: 'Selected',
      removeTransformers: 'Remove Transformers',
      addTransformers: 'Add Transformers',
      exit: 'Exit',
      name: 'Name',
      serialMeter: 'Serial Meter',
      meters: 'Meters',
      updatedAt: 'Last Update',
      success: {
        title: 'Success',
        addTransformers: 'Transformers added successfully!',
        removeTransformers: 'Transformers removed successfully!',
      },
      errors: {
        title: 'Error',
        loadAvailableTransformers: 'Error loading available transformers',
        addTransformers: 'Error adding transformers to area',
        removeTransformers: 'Error removing transformers from area',
      },
    },
    dialogNewEditMetersInTransformer: {
      title: 'Manage meters of transformer',
      registeredMeters: 'Registered Meters',
      availableMeters: 'Available Meters',
      total: 'Total',
      available: 'Available',
      selected: 'Selected',
      removeMeters: 'Remove Meters',
      registerMeters: 'Register Meters',
      exit: 'Exit',
      serialMeter: 'Serial Meter',
      manufacturer: 'Manufacturer',
      phase: 'Phase',
      signalQuality: 'Signal Quality',
      success: {
        title: 'Success',
        registerMeters: 'Meters registered successfully',
        removeMeters: 'Meters removed successfully',
      },
      errors: {
        title: 'Error',
        registerMeters: 'Error registering meters',
        removeMeters: 'Error removing meters',
      },
    },
    dialogNewEditTransformer: {
      editTransformer: 'Edit Transformer',
      registerTransformer: 'Register Transformer',
      requiredField: 'This field is required!',
      requiredFields: 'Fill in all required fields',
      name: 'Name',
      publicLighting: 'Public Lighting Monthly (kWh)',
      latitude: 'Latitude',
      longitude: 'Longitude',
      readingMeter: 'Reading Meter',
      searchPlaceholder: 'Search by name, manufacturer or serial',
      description: 'Description',
      cancel: 'Cancel',
      modify: 'Modify',
      register: 'Register',
      success: {
        title: 'Success',
        createTransformer: 'Transformer created successfully!',
        updateTransformer: 'Transformer updated successfully!',
      },
      errors: {
        title: 'Error',
        createTransformer: 'Error creating transformer',
        updateTransformer: 'Error updating transformer',
      },
    },
    dialogCancelTicket: {
      title: 'Cancel ticket execution',
      message: 'Do you want to cancel this ticket execution?',
      ticketLabel: 'Ticket',
      commandLabel: 'Command',
      close: 'Close',
      cancelTicket: 'Cancel Ticket',
      success: {
        title: 'Success',
        message: 'Cancellation executed successfully!',
      },
      error: {
        title: 'Error',
        message: 'Error canceling ticket',
      },
      notCancellable: {
        title: 'Unable to cancel',
        message: 'The ticket is already running and can no longer be canceled.',
        messageWithStatus:
          'The ticket can no longer be canceled, its current status is "{status}".',
      },
      statusCheckError: {
        title: 'Unable to cancel',
        message: 'Error checking the current ticket status. Please try again.',
      },
    },
    dialogReprocessServiceNote: {
      label: 'Reprocess service note',
      title: 'Confirm Reprocessing',
      message: 'Are you sure you want to reprocess this service note?',
      cancelReprocess: 'Cancel',
      confirmReprocess: 'Confirm',
      success: {
        title: 'Success',
        message: 'Reprocessing executed successfully!',
      },
      error: {
        title: 'Error',
        message: 'Error reprocessing service note',
      },
    },
  },
  general: {
    cancel: 'Cancel',
    save: 'Save',
    meter: 'Meter',
    meters: 'Meters',
    serial: 'Serial',
    attention: 'Attention',
    noInformation: 'No Information',
    notAvailable: 'Not Available',
    noDataFound: 'No data found',
    itemsFound: 'items found',
    actionsFile: 'Actions through file',
    consumerUnit: 'Consumer Unit',
    yes: 'Yes',
    no: 'No',
    exit: 'Exit',
    myAccount: 'My Account',
    editMyAccount: 'Edit My Account',
    edit: 'Edit',
    update: 'Update',
    error: 'Error',
    success: 'Success',
    profileUpdated: 'Profile updated successfully.',
    errorUpdatingProfile: 'Error updating profile',
    greeting: 'Hello,',
    email: 'E-mail',
    description: 'Description',
    receiveEmails: 'Receive e-mails',
    changingClient: 'Switching client...',
    selectClient: 'Select client',
    search: 'Search...',
    loading: 'Loading...',
    maximizeMap: 'Maximize Map',
    minimizeMap: 'Minimize Map',
    veeSeverity: {
      info: 'Info',
      issue: 'Warning',
      terminate: 'Critical',
    },
    validation: {
      requiredFields: 'Check the required fields before continuing.',
      meterSerialRequired: 'The meter serial is required.',
      manufacturerRequired: 'Manufacturer is required.',
      phaseRequired: 'Phase is required.',
      meterModelRequired: 'Model is required.',
      meterTypeRequired: 'Meter type is required.',
      rateTypeRequired: 'Rate type is required.',
      installationRequired: 'Installation code is required.',
      connectionPhaseRequired: 'Connection phase is required.',
      serialCannotContainSpaces:
        'The serial cannot contain spaces at the beginning, in the middle, or at the end.',
      meterSerialCannotContainSpaces:
        'The meter serial cannot contain spaces at the beginning, in the middle, or at the end.',
      smcSerialCannotContainSpaces:
        'The SMC serial cannot contain spaces at the beginning, in the middle, or at the end.',
      meterRegistersRequired: 'Registers are required.',
      clientIdRequired: 'Client is required.',
    },
    comissionedType: {
      all: 'All',
      comissioned: 'Comissioned',
      notComissioned: 'Not Comissioned',
      notRegistered: 'Not Registered',
    },
    meterTypes: {
      all: 'All',
      nepen: 'Integration MDX',
      integration: 'Integration',
      integrationDcu: 'Integration Wasion DCU',
    },
    meterActivated: {
      activated: 'Connected',
      notActivated: 'Disconnected',
      deactivateConfirmation: 'Do you want to disconnect this relay?',
      activateConfirmation: 'Do you want to connect this relay?',
      deactivateMessage: 'Relay Disconnected',
      activateMessage: 'Relay Connected',
    },
    doorStatus: {
      authorized: 'Authorized',
      unauthorized: 'Unauthorized',
    },
    communicationStatus: {
      noInformation: 'No information',
      success: 'Success',
      busy: 'Busy',
      communicationFailed: 'Communication Failure',
      online: 'Online',
      waiting: 'Waiting',
      offline: 'Offline',
      pending: 'Pending',
    },
    signalQuality: {
      neverSeen: 'Never Seen',
      veryWeak: 'Very Weak (1 Bar)',
      weak: 'Weak (2 Bars)',
      reasonable: 'Reasonable (3 Bars)',
      strong: 'Strong (4 Bars)',
      excellent: 'Excellent (5 Bars)',
    },
    signalQualityBars: {
      fiveBars: '5 Bars',
      fourBars: '4 Bars',
      threeBars: '3 Bars',
      twoBars: '2 Bars',
      oneBar: '1 Bar',
    },
    signalQualityLabel: {
      neverSeen: 'Never Seen',
      veryWeak: 'Very Weak',
      weak: 'Weak',
      reasonable: 'Reasonable',
      strong: 'Strong',
      excellent: 'Excellent',
    },
    datePickerExecutionFilter: 'Filter by execution start date',
  },
  manufacturerFilter: {
    label: 'Manufacturers',
    placeholder: 'All Manufacturers',
    loading: 'Loading manufacturers...',
  },
  globalFilterComponent: {
    title: 'Filters',
    period: 'Period',
    command: 'Command type',
    cleanButton: 'Clean',
    applyButton: 'Apply',
    datePlaceholder: 'dd/mm/yyyy - dd/mm/yyyy',
    selectPlaceholder: 'Select...',
    allPlaceholder: 'All',
    selectCommands: 'Select the commands',
  },
  alarmsFilter: {
    title: 'Filters',
    tags: 'Tags',
    tagsPlaceholder: 'Select the tags...',
    period: 'Period',
    datePlaceholder: 'dd/mm/yyyy - dd/mm/yyyy',
    quickOptions: 'Quick options:',
    quickOptionsHint: 'select a suggested period',
    quickDays: '{count} days',
    quickMonth: '1 month',
    longRangeHint: 'Custom periods longer than 90 days require confirmation before applying.',
    status: 'Status',
    statusPlaceholder: 'All',
    statusRead: 'Read',
    statusUnread: 'Unread',
    cleanButton: 'Clean',
    applyButton: 'Apply',
    longRangeTitle: 'Long period',
    longRangeMessage:
      'Periods longer than 90 days may take a little longer to load. Do you want to continue?',
    cancelButton: 'Cancel',
    continueButton: 'Continue',
  },
  parametrization: {
    parametrization: 'Parameterization',
    manageParams: 'Manage Parameters',
    searchBySerial: 'Search by Serial',
    unity: 'Consumer Unit',
    manufacturer: 'Manufacturer',
    actions: 'Actions',
    commands: {
      timeParams: 'Time-Related Parameters',
      createDataTemplate: 'Create Date Template',
      requestHolidays: 'Request Holidays',
      createHolidayTemplate: 'Create Holiday Template',
      deleteHolidayTemplate: 'Delete Holiday Template',
      activateProfileActivityCalendar: 'Set Profile Status',
      addActivateTime: 'Add Activation Time',
      sendTarrifPassiveCalendar: 'Send Passive Tariff Calendar',
      requestActivateTimeProfilePassiveActivityCalendar: 'Request Passive Calendar Activation Time',
      dmrcParams: 'Electricity-Related Parameters',
      setDmrcActiveStatus: 'Set DMCR Profile Status',
      setDmrcActivateTime: 'Add DMCR Activation Time',
      requestDmrcDayProfilePassive: 'Request DMCR Passive Calendar Activation Time',
      addDmrcDayPassiveCalendar: 'Add DMCR Passive Calendar Day',
      setDmrcSwitch: 'Set DMCR and UFER Switch',
      requestDmrcSwitch: 'Request DMCR and UFER Switch',
      readings: 'Demand-Related Parameters',
      recoverRegisters: 'Retrieve Registers',
      getGeneralReadings: 'Retrieve General Readings',
    },
    daylightSavingTable: 'Registered Schedules',
    finalDate: 'Start Date',
    endDate: 'End Date',
    deviation: 'Deviation (minutes)',
    isEnable: 'Active',
    confirmDelete: 'Confirm Deletion',
    deleteConfirmationMessage: 'Do you really want to delete this schedule?',
    deleteTarrifConfirmationMessage: 'Do you really want to delete this tariff?',
    cancel: 'Cancel',
    delete: 'Delete',
    tarrifsTable: 'Daily Tariffs',
    createDailyTariff: 'Create Daily Tariff',
    day: 'Day',
    name: 'Name',
    description: 'Description',
    meterProfile: 'Meter Profile',
    numberOfSchedules: 'Number of Schedules',
    activateProfileActivityCalendar: 'Set Profile Status',
    serial: 'Serial',
    meter: 'Meter',
    value: 'Value',
    addTimeForActivation: 'Add Activation Time',
    activationDateTime: 'Activation Date and Time',
    save: 'Save',
    createDmrcCalendar: 'Create DMCR Calendar',
    dayId: 'Day ID',
    annualHoliday: 'Annual holiday',
    time: 'Time',
    dmcrType: 'DMCR Type',
    createHolidayTemplate: 'Create Holiday Template',
    deleteHolidayTemplate: 'Delete Holiday Template',
    index: 'Index',
    holidayDate: 'Holiday Date',
    addHoliday: 'Add Holiday',
    addIndex: 'Add Index',
    createDailyTariffTemplate: 'Create Daily Tariff Template',
    hourlyTariffs: 'Hourly Tariffs',
    add: 'Add',
    tariffType: 'Tariff Type',
    createTimePeriodTemplate: 'Create Time Period Template',
    deviationMinutes: 'Deviation (minutes)',
    active: 'Active',
    dmcrSwitchConfiguration: 'DMCR Switch Configuration',
    saturday: 'Saturday',
    sunday: 'Sunday',
    holiday: 'Holiday',
    workday: 'Workday',
    capacitive: 'Capacitive',
    inductive: 'Inductive',
    send: 'Send',
    demandReading: 'Demand Reading',
    demandTypes: 'Demand Types',
    selectDemands: 'Select demands',
    generalReadings: 'General Readings',
    readings: 'Readings',
    selectReadings: 'Select readings',
    sendTariffPassiveCalendar: 'Send Passive Tariff Calendar',
    dailyTariffs: 'Daily Tariffs',
    confirm: 'Confirm',
    startDate: 'Start Date',
    addDmrcActivateTime: 'Add DMCR Activation Time',
    setDmrcActiveStatus: 'Set DMCR Profile Status',
    editDailyTariff: 'Edit Daily Tariff',
    editTimePeriodTemplate: 'Edit Date Template',
    createTimePeriod: {
      title: 'Replace existing record',
      message:
        'This meter already has a configured time period. Would you like to overwrite the current record with the new information?',
    },
  },
  errors: {
    unauthorized: 'You do not have permission to perform this action.',
    notImplemented:
      'Action currently unavailable. This method has not yet been integrated into the system.',
    deviceNotIdentified: 'Device not identified. Check if the serial is registered and try again.',
    badRequest: 'Invalid request. Please check the information provided.',
    notFound: 'Resource not found or route unavailable.',
    conflict: 'Data conflict. Please try again.',
    validation: 'There are invalid fields. Please check the information provided.',
    server: 'Internal server error. Please try again later.',
    network: 'Could not connect to the server. Check your connection and try again.',
    generic: 'An error occurred while processing your request.',
    noValidClient: {
      title: 'No access',
      detail: 'A valid client is required for this operation.',
    },
  },
  demands: {
    0: 'Total accumulated active imported energy',
    1: 'Accumulated active imported energy (tariff 1)',
    2: 'Accumulated active imported energy (tariff 2)',
    3: 'Accumulated active imported energy (tariff 3)',
    4: 'Accumulated active imported energy (tariff 4)',
    5: 'Total accumulated active exported energy',
    6: 'Accumulated active exported energy (tariff 1)',
    7: 'Accumulated active exported energy (tariff 2)',
    8: 'Accumulated active exported energy (tariff 3)',
    9: 'Accumulated active exported energy (tariff 4)',
    10: 'Current demand of total active imported energy',
    11: 'Current demand of active imported energy (tariff 1)',
    12: 'Current demand of active imported energy (tariff 2)',
    13: 'Current demand of active imported energy (tariff 3)',
    14: 'Current demand of active imported energy (tariff 4)',
    15: 'Current demand of total active exported energy',
    16: 'Current demand of active exported energy (tariff 1)',
    17: 'Current demand of active exported energy (tariff 2)',
    18: 'Current demand of active exported energy (tariff 3)',
    19: 'Current demand of active exported energy (tariff 4)',
    20: 'Maximum demand of total active imported energy',
    21: 'Maximum demand of active imported energy (tariff 1)',
    22: 'Maximum demand of active imported energy (tariff 2)',
    23: 'Maximum demand of active imported energy (tariff 3)',
    24: 'Maximum demand of active imported energy (tariff 4)',
    25: 'Maximum demand of total active exported energy',
    26: 'Maximum demand of active exported energy (tariff 1)',
    27: 'Maximum demand of active exported energy (tariff 2)',
    28: 'Maximum demand of active exported energy (tariff 3)',
    29: 'Maximum demand of active exported energy (tariff 4)',
  },
  generalReadings: {
    0: 'Battery status',
    1: 'Closed billing counter',
    2: 'Direct totalizer - General',
    3: 'Direct totalizer - Peak',
    4: 'Direct totalizer - Off-peak',
    5: 'Direct totalizer - Reserved',
    6: 'Direct totalizer - 4th period',
    7: 'Reverse totalizer - General',
    8: 'Reverse totalizer - Peak',
    9: 'Reverse totalizer - Off-peak',
    10: 'Reverse totalizer - Reserved',
    11: 'Reverse totalizer - Reserved',
    12: 'Reactive inductive direct - General',
    13: 'Reactive inductive direct - Peak',
    14: 'Reactive inductive direct - Off-peak',
    15: 'Reactive inductive direct - Reserved',
    16: 'Reactive inductive direct - 4th period',
    17: 'Reactive capacitive direct - General',
    18: 'Reactive capacitive direct - Peak',
    19: 'Reactive capacitive direct - Off-peak',
    20: 'Reactive capacitive direct - Reserved',
    21: 'Reactive capacitive direct - 4th period',
    22: 'Reactive inductive reverse - General',
    23: 'Reactive inductive reverse - Peak',
    24: 'Reactive inductive reverse - Off-peak',
    25: 'Reactive inductive reverse - Reserved',
    26: 'Reactive inductive reverse - 4th period',
    27: 'Reactive capacitive reverse - General',
    28: 'Reactive capacitive reverse - Peak',
    29: 'Reactive capacitive reverse - Off-peak',
    30: 'Reactive capacitive reverse - Reserved',
    31: 'Reactive capacitive reverse - 4th period',
    32: 'Maximum demand - Direct total',
    33: 'Maximum demand - Direct peak',
    34: 'Maximum demand - Direct off-peak',
    35: 'Maximum demand - Direct reserved',
    36: 'Maximum demand - Direct type D',
    37: 'Accumulated demand - Direct total',
    38: 'Accumulated demand - Direct peak',
    39: 'Accumulated demand - Direct off-peak',
    40: 'Accumulated demand - Direct reserved',
    41: 'Accumulated demand - Direct type D',
    42: 'Maximum demand - Reverse total (peak)',
    43: 'Maximum demand - Reverse peak',
    44: 'Maximum demand - Reverse off-peak',
    45: 'Maximum demand - Reverse reserved',
    46: 'Maximum demand - Reverse type D',
    47: 'Accumulated demand - Reverse total',
    48: 'Accumulated demand - Reverse peak',
    49: 'Accumulated demand - Reverse off-peak',
    50: 'Accumulated demand - Reverse reserved',
    51: 'Accumulated demand - Reverse type D',
    52: 'Total',
    53: 'Peak',
    54: 'Off-peak',
    55: 'Reserved',
    56: 'Peak',
    57: 'Off-peak',
    58: 'Reserved',
    59: 'Peak',
    60: 'Off-peak',
    61: 'Reserved',
  },
  qualityParameters: {
    drpViolationsChartTitle: 'Meters by DRP Violation',
    serial: 'Serial',
    installation: 'Installation',
    selectPeriod: 'Select Period',
    serialPlaceholder: 'Enter meter serial',
    installationPlaceholder: 'Search by installation',
    searching: 'Searching...',
    noResults: 'No results found',
    filters: 'Filters',
    pendencies: 'Pending Issues',
    loading: 'Loading',
    meterWithoutReadings: 'Meters without readings',
    noData: 'No data to be displayed',
    installationsAboveDicLimit: 'Installations above DIC limit',
    installationsAboveFicLimit: 'Installations above FIC limit',
    averageBaseDic: 'Average Base DIC',
    averageBaseFic: 'Average Base FIC',
    badInstalations: 'Installations with Worst Indicators',
    dic: 'DIC',
    fic: 'FIC',
    dicLimit: 'DIC Limit',
    ficLimit: 'FIC Limit',
    ficRegion: 'Region (FIC)',
    status: 'Status',
    drcViolation: 'Meters by DRC Violation',
    tensionVariation: 'Monthly Average Voltage Variation',
    readingsByMonth: 'Readings by Month',
    drpDrcAverage: 'Monthly Average DRP/DRC',
    drpDrcViolations: 'Average DRP/DRC Violation',
    monthlyDicFic: 'Monthly DIC/FIC Value',
    interruptions: 'Power Interruption',
    installationsAboveDrpLimit: 'Installations above DRP limit',
    installationsAboveDrcLimit: 'Installations above DRC limit',
    averageBaseDrp: 'Base Average DRP',
    averageBaseDrc: 'Base Average DRC',
    drp: 'Monthly DRP (%)',
    drc: 'Monthly DRC (%)',
    drpLimit: 'DRP Limit',
    drcLimit: 'DRC Limit',
    drpViolation: 'Monthly DRP Violation (%)',
    drcViolationT: 'Monthly DRC Violation (%)',
    statusGood: 'Good',
    statusAdequate: 'Adequate',
    statusPrecarious: 'Precarious',
    statusCritical: 'Critical',
    drpUpTo20: 'DRP up to 20%',
    drpUpTo40: 'DRP up to 40%',
    drpUpTo60: 'DRP up to 60%',
    drpUpTo80: 'DRP up to 80%',
    drpUpTo100: 'DRP 100%',
    drcUpTo20: 'DRC up to 20%',
    drcUpTo40: 'DRC up to 40%',
    drcUpTo60: 'DRC up to 60%',
    drcUpTo80: 'DRC up to 80%',
    drcUpTo100: 'DRC 100%',
    noInformation: 'No Information',
    categories: 'Categories',
    selectCategories: 'Select categories',
    state: 'State',
    city: 'City',
    selectState: 'Select state',
    selectCity: 'Select city',
    clear: 'Clear',
    apply: 'Apply',
    averageVoltage: 'Average Voltage',
    readings: 'Readings',
    voltage: 'Voltage',
    viewChart: 'View Chart',
    viewTable: 'View Table',
    exportMonthlySummary: 'Export Monthly Summary',
    byMonth: 'By Month',
    byWeek: 'By Week',
    meters: 'Meters',
    day: 'Day',
    week: 'Week',
    drpPercent: 'DRP %',
    drcPercent: 'DRC %',
    drcViolationPercent: 'DRC VIOLATION %',
    drpViolationPercent: 'DRP VIOLATION %',
    dicHours: 'DIC (Hours)',
    dmicHours: 'DMIC (Hours)',
    drpBand20: 'DRP up to 20%',
    drpBand40: 'DRP up to 40%',
    drpBand60: 'DRP up to 60%',
    drpBand80: 'DRP up to 80%',
    drpBand100: 'DRP 100%',
    drcBand20: 'DRC up to 20%',
    drcBand40: 'DRC up to 40%',
    drcBand60: 'DRC up to 60%',
    drcBand80: 'DRC up to 80%',
    drcBand100: 'DRC 100%',
    averageV: 'Average (V)',
    phaseA: 'Phase A (V)',
    phaseB: 'Phase B (V)',
    phaseC: 'Phase C (V)',
    violationDrc: 'DRC Violation',
    violationDrp: 'DRP Violation',
    totalFicEvents: 'Total FIC (Events)',
    meterQuantity: 'Meter Count',
    dicHoursCompact: 'DIC (Hours)',
    dmicHoursCompact: 'DMIC (Hours)',
    detailedIndicators: 'Detailed Indicators',
    detailedDrpDrcViolations: 'Detailed DRP/DRC Violations',
    detailedDicFic: 'DIC/FIC Details',
    detailedTensionLevels: 'Detailed Voltage Levels',
    averageDrp: 'Average DRP',
    averageDrc: 'Average DRC',
    createdAt: 'Created At',
    manufacturer: 'Manufacturer',
    model: 'Model',
    dateTime: 'Date/Time',
    voltageReading: 'Voltage Reading',
    generalV: 'General (V)',
  },
}
